//#region \0rolldown/runtime.js
var e = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), t = globalThis, n = t.ShadowRoot && (t.ShadyCSS === void 0 || t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, r = Symbol(), i = /* @__PURE__ */ new WeakMap(), a = class {
	constructor(e, t, n) {
		if (this._$cssResult$ = !0, n !== r) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
		this.cssText = e, this.t = t;
	}
	get styleSheet() {
		let e = this.o, t = this.t;
		if (n && e === void 0) {
			let n = t !== void 0 && t.length === 1;
			n && (e = i.get(t)), e === void 0 && ((this.o = e = new CSSStyleSheet()).replaceSync(this.cssText), n && i.set(t, e));
		}
		return e;
	}
	toString() {
		return this.cssText;
	}
}, o = (e) => new a(typeof e == "string" ? e : e + "", void 0, r), s = (e, ...t) => new a(e.length === 1 ? e[0] : t.reduce((t, n, r) => t + ((e) => {
	if (!0 === e._$cssResult$) return e.cssText;
	if (typeof e == "number") return e;
	throw Error("Value passed to 'css' function must be a 'css' function result: " + e + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
})(n) + e[r + 1], e[0]), e, r), c = (e, r) => {
	if (n) e.adoptedStyleSheets = r.map((e) => e instanceof CSSStyleSheet ? e : e.styleSheet);
	else for (let n of r) {
		let r = document.createElement("style"), i = t.litNonce;
		i !== void 0 && r.setAttribute("nonce", i), r.textContent = n.cssText, e.appendChild(r);
	}
}, l = n ? (e) => e : (e) => e instanceof CSSStyleSheet ? ((e) => {
	let t = "";
	for (let n of e.cssRules) t += n.cssText;
	return o(t);
})(e) : e, { is: u, defineProperty: d, getOwnPropertyDescriptor: f, getOwnPropertyNames: p, getOwnPropertySymbols: m, getPrototypeOf: h } = Object, g = globalThis, ee = g.trustedTypes, te = ee ? ee.emptyScript : "", _ = g.reactiveElementPolyfillSupport, v = (e, t) => e, y = {
	toAttribute(e, t) {
		switch (t) {
			case Boolean:
				e = e ? te : null;
				break;
			case Object:
			case Array: e = e == null ? e : JSON.stringify(e);
		}
		return e;
	},
	fromAttribute(e, t) {
		let n = e;
		switch (t) {
			case Boolean:
				n = e !== null;
				break;
			case Number:
				n = e === null ? null : Number(e);
				break;
			case Object:
			case Array: try {
				n = JSON.parse(e);
			} catch {
				n = null;
			}
		}
		return n;
	}
}, b = (e, t) => !u(e, t), ne = {
	attribute: !0,
	type: String,
	converter: y,
	reflect: !1,
	useDefault: !1,
	hasChanged: b
};
Symbol.metadata ??= Symbol("metadata"), g.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
var x = class extends HTMLElement {
	static addInitializer(e) {
		this._$Ei(), (this.l ??= []).push(e);
	}
	static get observedAttributes() {
		return this.finalize(), this._$Eh && [...this._$Eh.keys()];
	}
	static createProperty(e, t = ne) {
		if (t.state && (t.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(e) && ((t = Object.create(t)).wrapped = !0), this.elementProperties.set(e, t), !t.noAccessor) {
			let n = Symbol(), r = this.getPropertyDescriptor(e, n, t);
			r !== void 0 && d(this.prototype, e, r);
		}
	}
	static getPropertyDescriptor(e, t, n) {
		let { get: r, set: i } = f(this.prototype, e) ?? {
			get() {
				return this[t];
			},
			set(e) {
				this[t] = e;
			}
		};
		return {
			get: r,
			set(t) {
				let a = r?.call(this);
				i?.call(this, t), this.requestUpdate(e, a, n);
			},
			configurable: !0,
			enumerable: !0
		};
	}
	static getPropertyOptions(e) {
		return this.elementProperties.get(e) ?? ne;
	}
	static _$Ei() {
		if (this.hasOwnProperty(v("elementProperties"))) return;
		let e = h(this);
		e.finalize(), e.l !== void 0 && (this.l = [...e.l]), this.elementProperties = new Map(e.elementProperties);
	}
	static finalize() {
		if (this.hasOwnProperty(v("finalized"))) return;
		if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(v("properties"))) {
			let e = this.properties, t = [...p(e), ...m(e)];
			for (let n of t) this.createProperty(n, e[n]);
		}
		let e = this[Symbol.metadata];
		if (e !== null) {
			let t = litPropertyMetadata.get(e);
			if (t !== void 0) for (let [e, n] of t) this.elementProperties.set(e, n);
		}
		this._$Eh = /* @__PURE__ */ new Map();
		for (let [e, t] of this.elementProperties) {
			let n = this._$Eu(e, t);
			n !== void 0 && this._$Eh.set(n, e);
		}
		this.elementStyles = this.finalizeStyles(this.styles);
	}
	static finalizeStyles(e) {
		let t = [];
		if (Array.isArray(e)) {
			let n = new Set(e.flat(Infinity).reverse());
			for (let e of n) t.unshift(l(e));
		} else e !== void 0 && t.push(l(e));
		return t;
	}
	static _$Eu(e, t) {
		let n = t.attribute;
		return !1 === n ? void 0 : typeof n == "string" ? n : typeof e == "string" ? e.toLowerCase() : void 0;
	}
	constructor() {
		super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
	}
	_$Ev() {
		this._$ES = new Promise((e) => this.enableUpdating = e), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((e) => e(this));
	}
	addController(e) {
		(this._$EO ??= /* @__PURE__ */ new Set()).add(e), this.renderRoot !== void 0 && this.isConnected && e.hostConnected?.();
	}
	removeController(e) {
		this._$EO?.delete(e);
	}
	_$E_() {
		let e = /* @__PURE__ */ new Map(), t = this.constructor.elementProperties;
		for (let n of t.keys()) this.hasOwnProperty(n) && (e.set(n, this[n]), delete this[n]);
		e.size > 0 && (this._$Ep = e);
	}
	createRenderRoot() {
		let e = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
		return c(e, this.constructor.elementStyles), e;
	}
	connectedCallback() {
		this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((e) => e.hostConnected?.());
	}
	enableUpdating(e) {}
	disconnectedCallback() {
		this._$EO?.forEach((e) => e.hostDisconnected?.());
	}
	attributeChangedCallback(e, t, n) {
		this._$AK(e, n);
	}
	_$ET(e, t) {
		let n = this.constructor.elementProperties.get(e), r = this.constructor._$Eu(e, n);
		if (r !== void 0 && !0 === n.reflect) {
			let i = (n.converter?.toAttribute === void 0 ? y : n.converter).toAttribute(t, n.type);
			this._$Em = e, i == null ? this.removeAttribute(r) : this.setAttribute(r, i), this._$Em = null;
		}
	}
	_$AK(e, t) {
		let n = this.constructor, r = n._$Eh.get(e);
		if (r !== void 0 && this._$Em !== r) {
			let e = n.getPropertyOptions(r), i = typeof e.converter == "function" ? { fromAttribute: e.converter } : e.converter?.fromAttribute === void 0 ? y : e.converter;
			this._$Em = r;
			let a = i.fromAttribute(t, e.type);
			this[r] = a ?? this._$Ej?.get(r) ?? a, this._$Em = null;
		}
	}
	requestUpdate(e, t, n, r = !1, i) {
		if (e !== void 0) {
			let a = this.constructor;
			if (!1 === r && (i = this[e]), n ??= a.getPropertyOptions(e), !((n.hasChanged ?? b)(i, t) || n.useDefault && n.reflect && i === this._$Ej?.get(e) && !this.hasAttribute(a._$Eu(e, n)))) return;
			this.C(e, t, n);
		}
		!1 === this.isUpdatePending && (this._$ES = this._$EP());
	}
	C(e, t, { useDefault: n, reflect: r, wrapped: i }, a) {
		n && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(e) && (this._$Ej.set(e, a ?? t ?? this[e]), !0 !== i || a !== void 0) || (this._$AL.has(e) || (this.hasUpdated || n || (t = void 0), this._$AL.set(e, t)), !0 === r && this._$Em !== e && (this._$Eq ??= /* @__PURE__ */ new Set()).add(e));
	}
	async _$EP() {
		this.isUpdatePending = !0;
		try {
			await this._$ES;
		} catch (e) {
			Promise.reject(e);
		}
		let e = this.scheduleUpdate();
		return e != null && await e, !this.isUpdatePending;
	}
	scheduleUpdate() {
		return this.performUpdate();
	}
	performUpdate() {
		if (!this.isUpdatePending) return;
		if (!this.hasUpdated) {
			if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
				for (let [e, t] of this._$Ep) this[e] = t;
				this._$Ep = void 0;
			}
			let e = this.constructor.elementProperties;
			if (e.size > 0) for (let [t, n] of e) {
				let { wrapped: e } = n, r = this[t];
				!0 !== e || this._$AL.has(t) || r === void 0 || this.C(t, void 0, n, r);
			}
		}
		let e = !1, t = this._$AL;
		try {
			e = this.shouldUpdate(t), e ? (this.willUpdate(t), this._$EO?.forEach((e) => e.hostUpdate?.()), this.update(t)) : this._$EM();
		} catch (t) {
			throw e = !1, this._$EM(), t;
		}
		e && this._$AE(t);
	}
	willUpdate(e) {}
	_$AE(e) {
		this._$EO?.forEach((e) => e.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
	}
	_$EM() {
		this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
	}
	get updateComplete() {
		return this.getUpdateComplete();
	}
	getUpdateComplete() {
		return this._$ES;
	}
	shouldUpdate(e) {
		return !0;
	}
	update(e) {
		this._$Eq &&= this._$Eq.forEach((e) => this._$ET(e, this[e])), this._$EM();
	}
	updated(e) {}
	firstUpdated(e) {}
};
x.elementStyles = [], x.shadowRootOptions = { mode: "open" }, x[v("elementProperties")] = /* @__PURE__ */ new Map(), x[v("finalized")] = /* @__PURE__ */ new Map(), _?.({ ReactiveElement: x }), (g.reactiveElementVersions ??= []).push("2.1.2");
//#endregion
//#region ../../node_modules/.pnpm/lit-html@3.3.2/node_modules/lit-html/lit-html.js
var S = globalThis, re = (e) => e, C = S.trustedTypes, ie = C ? C.createPolicy("lit-html", { createHTML: (e) => e }) : void 0, ae = "$lit$", w = `lit$${Math.random().toFixed(9).slice(2)}$`, T = "?" + w, E = `<${T}>`, D = document, O = () => D.createComment(""), k = (e) => e === null || typeof e != "object" && typeof e != "function", A = Array.isArray, j = (e) => A(e) || typeof e?.[Symbol.iterator] == "function", oe = "[ 	\n\f\r]", se = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, ce = /-->/g, M = />/g, N = RegExp(`>|${oe}(?:([^\\s"'>=/]+)(${oe}*=${oe}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), le = /'/g, ue = /"/g, P = /^(?:script|style|textarea|title)$/i, F = ((e) => (t, ...n) => ({
	_$litType$: e,
	strings: t,
	values: n
}))(1), I = Symbol.for("lit-noChange"), L = Symbol.for("lit-nothing"), R = /* @__PURE__ */ new WeakMap(), de = D.createTreeWalker(D, 129);
function fe(e, t) {
	if (!A(e) || !e.hasOwnProperty("raw")) throw Error("invalid template strings array");
	return ie === void 0 ? t : ie.createHTML(t);
}
var z = (e, t) => {
	let n = e.length - 1, r = [], i, a = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", o = se;
	for (let t = 0; t < n; t++) {
		let n = e[t], s, c, l = -1, u = 0;
		for (; u < n.length && (o.lastIndex = u, c = o.exec(n), c !== null);) u = o.lastIndex, o === se ? c[1] === "!--" ? o = ce : c[1] === void 0 ? c[2] === void 0 ? c[3] !== void 0 && (o = N) : (P.test(c[2]) && (i = RegExp("</" + c[2], "g")), o = N) : o = M : o === N ? c[0] === ">" ? (o = i ?? se, l = -1) : c[1] === void 0 ? l = -2 : (l = o.lastIndex - c[2].length, s = c[1], o = c[3] === void 0 ? N : c[3] === "\"" ? ue : le) : o === ue || o === le ? o = N : o === ce || o === M ? o = se : (o = N, i = void 0);
		let d = o === N && e[t + 1].startsWith("/>") ? " " : "";
		a += o === se ? n + E : l >= 0 ? (r.push(s), n.slice(0, l) + ae + n.slice(l) + w + d) : n + w + (l === -2 ? t : d);
	}
	return [fe(e, a + (e[n] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), r];
}, pe = class e {
	constructor({ strings: t, _$litType$: n }, r) {
		let i;
		this.parts = [];
		let a = 0, o = 0, s = t.length - 1, c = this.parts, [l, u] = z(t, n);
		if (this.el = e.createElement(l, r), de.currentNode = this.el.content, n === 2 || n === 3) {
			let e = this.el.content.firstChild;
			e.replaceWith(...e.childNodes);
		}
		for (; (i = de.nextNode()) !== null && c.length < s;) {
			if (i.nodeType === 1) {
				if (i.hasAttributes()) for (let e of i.getAttributeNames()) if (e.endsWith(ae)) {
					let t = u[o++], n = i.getAttribute(e).split(w), r = /([.?@])?(.*)/.exec(t);
					c.push({
						type: 1,
						index: a,
						name: r[2],
						strings: n,
						ctor: r[1] === "." ? ve : r[1] === "?" ? ye : r[1] === "@" ? be : _e
					}), i.removeAttribute(e);
				} else e.startsWith(w) && (c.push({
					type: 6,
					index: a
				}), i.removeAttribute(e));
				if (P.test(i.tagName)) {
					let e = i.textContent.split(w), t = e.length - 1;
					if (t > 0) {
						i.textContent = C ? C.emptyScript : "";
						for (let n = 0; n < t; n++) i.append(e[n], O()), de.nextNode(), c.push({
							type: 2,
							index: ++a
						});
						i.append(e[t], O());
					}
				}
			} else if (i.nodeType === 8) if (i.data === T) c.push({
				type: 2,
				index: a
			});
			else {
				let e = -1;
				for (; (e = i.data.indexOf(w, e + 1)) !== -1;) c.push({
					type: 7,
					index: a
				}), e += w.length - 1;
			}
			a++;
		}
	}
	static createElement(e, t) {
		let n = D.createElement("template");
		return n.innerHTML = e, n;
	}
};
function me(e, t, n = e, r) {
	if (t === I) return t;
	let i = r === void 0 ? n._$Cl : n._$Co?.[r], a = k(t) ? void 0 : t._$litDirective$;
	return i?.constructor !== a && (i?._$AO?.(!1), a === void 0 ? i = void 0 : (i = new a(e), i._$AT(e, n, r)), r === void 0 ? n._$Cl = i : (n._$Co ??= [])[r] = i), i !== void 0 && (t = me(e, i._$AS(e, t.values), i, r)), t;
}
var he = class {
	constructor(e, t) {
		this._$AV = [], this._$AN = void 0, this._$AD = e, this._$AM = t;
	}
	get parentNode() {
		return this._$AM.parentNode;
	}
	get _$AU() {
		return this._$AM._$AU;
	}
	u(e) {
		let { el: { content: t }, parts: n } = this._$AD, r = (e?.creationScope ?? D).importNode(t, !0);
		de.currentNode = r;
		let i = de.nextNode(), a = 0, o = 0, s = n[0];
		for (; s !== void 0;) {
			if (a === s.index) {
				let t;
				s.type === 2 ? t = new ge(i, i.nextSibling, this, e) : s.type === 1 ? t = new s.ctor(i, s.name, s.strings, this, e) : s.type === 6 && (t = new xe(i, this, e)), this._$AV.push(t), s = n[++o];
			}
			a !== s?.index && (i = de.nextNode(), a++);
		}
		return de.currentNode = D, r;
	}
	p(e) {
		let t = 0;
		for (let n of this._$AV) n !== void 0 && (n.strings === void 0 ? n._$AI(e[t]) : (n._$AI(e, n, t), t += n.strings.length - 2)), t++;
	}
}, ge = class e {
	get _$AU() {
		return this._$AM?._$AU ?? this._$Cv;
	}
	constructor(e, t, n, r) {
		this.type = 2, this._$AH = L, this._$AN = void 0, this._$AA = e, this._$AB = t, this._$AM = n, this.options = r, this._$Cv = r?.isConnected ?? !0;
	}
	get parentNode() {
		let e = this._$AA.parentNode, t = this._$AM;
		return t !== void 0 && e?.nodeType === 11 && (e = t.parentNode), e;
	}
	get startNode() {
		return this._$AA;
	}
	get endNode() {
		return this._$AB;
	}
	_$AI(e, t = this) {
		e = me(this, e, t), k(e) ? e === L || e == null || e === "" ? (this._$AH !== L && this._$AR(), this._$AH = L) : e !== this._$AH && e !== I && this._(e) : e._$litType$ === void 0 ? e.nodeType === void 0 ? j(e) ? this.k(e) : this._(e) : this.T(e) : this.$(e);
	}
	O(e) {
		return this._$AA.parentNode.insertBefore(e, this._$AB);
	}
	T(e) {
		this._$AH !== e && (this._$AR(), this._$AH = this.O(e));
	}
	_(e) {
		this._$AH !== L && k(this._$AH) ? this._$AA.nextSibling.data = e : this.T(D.createTextNode(e)), this._$AH = e;
	}
	$(e) {
		let { values: t, _$litType$: n } = e, r = typeof n == "number" ? this._$AC(e) : (n.el === void 0 && (n.el = pe.createElement(fe(n.h, n.h[0]), this.options)), n);
		if (this._$AH?._$AD === r) this._$AH.p(t);
		else {
			let e = new he(r, this), n = e.u(this.options);
			e.p(t), this.T(n), this._$AH = e;
		}
	}
	_$AC(e) {
		let t = R.get(e.strings);
		return t === void 0 && R.set(e.strings, t = new pe(e)), t;
	}
	k(t) {
		A(this._$AH) || (this._$AH = [], this._$AR());
		let n = this._$AH, r, i = 0;
		for (let a of t) i === n.length ? n.push(r = new e(this.O(O()), this.O(O()), this, this.options)) : r = n[i], r._$AI(a), i++;
		i < n.length && (this._$AR(r && r._$AB.nextSibling, i), n.length = i);
	}
	_$AR(e = this._$AA.nextSibling, t) {
		for (this._$AP?.(!1, !0, t); e !== this._$AB;) {
			let t = re(e).nextSibling;
			re(e).remove(), e = t;
		}
	}
	setConnected(e) {
		this._$AM === void 0 && (this._$Cv = e, this._$AP?.(e));
	}
}, _e = class {
	get tagName() {
		return this.element.tagName;
	}
	get _$AU() {
		return this._$AM._$AU;
	}
	constructor(e, t, n, r, i) {
		this.type = 1, this._$AH = L, this._$AN = void 0, this.element = e, this.name = t, this._$AM = r, this.options = i, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(/* @__PURE__ */ new String()), this.strings = n) : this._$AH = L;
	}
	_$AI(e, t = this, n, r) {
		let i = this.strings, a = !1;
		if (i === void 0) e = me(this, e, t, 0), a = !k(e) || e !== this._$AH && e !== I, a && (this._$AH = e);
		else {
			let r = e, o, s;
			for (e = i[0], o = 0; o < i.length - 1; o++) s = me(this, r[n + o], t, o), s === I && (s = this._$AH[o]), a ||= !k(s) || s !== this._$AH[o], s === L ? e = L : e !== L && (e += (s ?? "") + i[o + 1]), this._$AH[o] = s;
		}
		a && !r && this.j(e);
	}
	j(e) {
		e === L ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e ?? "");
	}
}, ve = class extends _e {
	constructor() {
		super(...arguments), this.type = 3;
	}
	j(e) {
		this.element[this.name] = e === L ? void 0 : e;
	}
}, ye = class extends _e {
	constructor() {
		super(...arguments), this.type = 4;
	}
	j(e) {
		this.element.toggleAttribute(this.name, !!e && e !== L);
	}
}, be = class extends _e {
	constructor(e, t, n, r, i) {
		super(e, t, n, r, i), this.type = 5;
	}
	_$AI(e, t = this) {
		if ((e = me(this, e, t, 0) ?? L) === I) return;
		let n = this._$AH, r = e === L && n !== L || e.capture !== n.capture || e.once !== n.once || e.passive !== n.passive, i = e !== L && (n === L || r);
		r && this.element.removeEventListener(this.name, this, n), i && this.element.addEventListener(this.name, this, e), this._$AH = e;
	}
	handleEvent(e) {
		typeof this._$AH == "function" ? this._$AH.call(this.options?.host ?? this.element, e) : this._$AH.handleEvent(e);
	}
}, xe = class {
	constructor(e, t, n) {
		this.element = e, this.type = 6, this._$AN = void 0, this._$AM = t, this.options = n;
	}
	get _$AU() {
		return this._$AM._$AU;
	}
	_$AI(e) {
		me(this, e);
	}
}, B = {
	M: ae,
	P: w,
	A: T,
	C: 1,
	L: z,
	R: he,
	D: j,
	V: me,
	I: ge,
	H: _e,
	N: ye,
	U: be,
	B: ve,
	F: xe
}, Se = S.litHtmlPolyfillSupport;
Se?.(pe, ge), (S.litHtmlVersions ??= []).push("3.3.2");
var Ce = (e, t, n) => {
	let r = n?.renderBefore ?? t, i = r._$litPart$;
	if (i === void 0) {
		let e = n?.renderBefore ?? null;
		r._$litPart$ = i = new ge(t.insertBefore(O(), e), e, void 0, n ?? {});
	}
	return i._$AI(e), i;
}, we = globalThis, Te = class extends x {
	constructor() {
		super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
	}
	createRenderRoot() {
		let e = super.createRenderRoot();
		return this.renderOptions.renderBefore ??= e.firstChild, e;
	}
	update(e) {
		let t = this.render();
		this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = Ce(t, this.renderRoot, this.renderOptions);
	}
	connectedCallback() {
		super.connectedCallback(), this._$Do?.setConnected(!0);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._$Do?.setConnected(!1);
	}
	render() {
		return I;
	}
};
Te._$litElement$ = !0, Te.finalized = !0, we.litElementHydrateSupport?.({ LitElement: Te });
var Ee = we.litElementPolyfillSupport;
Ee?.({ LitElement: Te }), (we.litElementVersions ??= []).push("4.2.2");
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/overlayDocumentStyle.js
var De = s`
  body > *[inert] {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    pointer-events: none;
  }

  body.overlays-scroll-lock {
    overflow: hidden;
  }

  body.overlays-scroll-lock-ios-fix {
    position: fixed;
    width: 100%;
  }

  html.overlays-scroll-lock-ios-fix {
    height: 100vh;
  }
`, Oe = {
	isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent),
	isMacSafari: navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && navigator.userAgent && navigator.userAgent.indexOf("CriOS") === -1 && navigator.userAgent.indexOf("FxiOS") === -1 && navigator.appVersion.indexOf("Mac") !== -1
}, ke = class e {
	static __createGlobalStyleNode() {
		let e = document.createElement("style");
		return e.setAttribute("data-overlays", ""), e.textContent = De.cssText, document.head.appendChild(e), e;
	}
	get list() {
		return this.__list;
	}
	get shownList() {
		return this.__shownList;
	}
	constructor() {
		this.__list = [], this.__shownList = [], this.__siblingsInert = !1, this.__blockingMap = /* @__PURE__ */ new WeakMap(), e.__globalStyleNode ||= e.__createGlobalStyleNode();
	}
	add(e) {
		if (this.list.find((t) => e === t)) throw Error("controller instance is already added");
		return this.list.push(e), e;
	}
	remove(e) {
		if (!this.list.find((t) => e === t)) throw Error("could not find controller to remove");
		this.__list = this.list.filter((t) => t !== e), this.__shownList = this.shownList.filter((t) => t !== e);
	}
	show(e) {
		this.list.find((t) => e === t) && this.hide(e), this.__shownList.unshift(e), Array.from(this.__shownList).reverse().forEach((e, t) => {
			e.elevation = t + 1;
		});
	}
	hide(e) {
		if (!this.list.find((t) => e === t)) throw Error("could not find controller to hide");
		this.__shownList = this.shownList.filter((t) => t !== e);
	}
	teardown() {
		this.list.forEach((e) => {
			e.teardown();
		}), this.__list = [], this.__shownList = [], this.__siblingsInert = !1, e.__globalStyleNode &&= (document.head.removeChild(e.__globalStyleNode), void 0);
	}
	get siblingsInert() {
		return this.__siblingsInert;
	}
	disableTrapsKeyboardFocusForAll() {
		this.shownList.forEach((e) => {
			e.trapsKeyboardFocus === !0 && e.disableTrapsKeyboardFocus && e.disableTrapsKeyboardFocus({ findNewTrap: !1 });
		});
	}
	informTrapsKeyboardFocusGotEnabled(e) {
		this.siblingsInert === !1 && e === "global" && (this.__siblingsInert = !0);
	}
	informTrapsKeyboardFocusGotDisabled({ disabledCtrl: e, findNewTrap: t = !0 } = {}) {
		let n = this.shownList.find((t) => t !== e && t.trapsKeyboardFocus === !0);
		n ? t && n.enableTrapsKeyboardFocus() : this.siblingsInert === !0 && (this.__siblingsInert = !1);
	}
	requestToPreventScroll() {
		let { isIOS: e, isMacSafari: t } = Oe;
		document.body.classList.add("overlays-scroll-lock"), (e || t) && document.body.classList.add("overlays-scroll-lock-ios-fix"), e && document.documentElement.classList.add("overlays-scroll-lock-ios-fix");
	}
	requestToEnableScroll() {
		if (this.shownList.some((e) => e.preventsScroll === !0)) return;
		let { isIOS: e, isMacSafari: t } = Oe;
		document.body.classList.remove("overlays-scroll-lock"), (e || t) && document.body.classList.remove("overlays-scroll-lock-ios-fix"), e && document.documentElement.classList.remove("overlays-scroll-lock-ios-fix");
	}
	requestToShowOnly(e) {
		let t = this.shownList.filter((t) => t !== e);
		t.forEach((e) => e.hide()), this.__blockingMap.set(e, t);
	}
	retractRequestToShowOnly(e) {
		this.__blockingMap.has(e) && this.__blockingMap.get(e).forEach((e) => e.show());
	}
};
ke.__globalStyleNode = void 0;
//#endregion
//#region ../../node_modules/.pnpm/singleton-manager@1.8.0/node_modules/singleton-manager/src/SingletonManagerClass.js
var Ae = Symbol.for("lion::SingletonManagerClassStorage"), je = globalThis || window, Me = new class {
	constructor() {
		this._map = je[Ae] ? je[Ae] : je[Ae] = /* @__PURE__ */ new Map();
	}
	set(e, t) {
		this.has(e) || this._map.set(e, t);
	}
	get(e) {
		return this._map.get(e);
	}
	has(e) {
		return this._map.has(e);
	}
}().get("@lion/ui::overlays::0.x") || new ke();
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/utils/get-deep-active-element.js
function Ne() {
	let e = document.activeElement || document.body;
	for (; e && e.shadowRoot && e.shadowRoot.activeElement;) e = e.shadowRoot.activeElement;
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/utils/is-visible.js
var Pe = ({ visibility: e, display: t }) => e !== "hidden" && t !== "none", Fe = ({ display: e }) => e === "contents";
function Ie(e) {
	if (!e || !e.isConnected || !Pe(e.style)) return !1;
	let t = window.getComputedStyle(e);
	return Pe(t) ? Fe(t) ? !0 : !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length) : !1;
}
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/utils/sort-by-tabindex.js
function Le(e, t) {
	let n = Math.max(e.tabIndex, 0), r = Math.max(t.tabIndex, 0);
	return n === 0 || r === 0 ? r > n : n > r;
}
function Re(e, t) {
	let n = [];
	for (; e.length > 0 && t.length > 0;) Le(e[0], t[0]) ? n.push(t.shift()) : n.push(e.shift());
	return [
		...n,
		...e,
		...t
	];
}
function ze(e) {
	let t = e.length;
	if (t < 2) return e;
	let n = Math.ceil(t / 2);
	return Re(ze(e.slice(0, n)), ze(e.slice(n)));
}
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/utils/get-focusable-elements.js
var Be = "matches" in Element.prototype ? "matches" : "msMatchesSelector";
function Ve(e) {
	return e[Be]("input, select, textarea, button, object") ? e[Be](":not([disabled])") : e[Be]("a[href], area[href], iframe, [tabindex], [contentEditable]");
}
function He(e) {
	return Ve(e) ? Number(e.getAttribute("tabindex") || 0) : -1;
}
function Ue(e) {
	if (e.localName === "slot") return e.assignedNodes({ flatten: !0 });
	let { children: t } = e.shadowRoot || e;
	return t || [];
}
function We(e) {
	return e.nodeType === Node.ELEMENT_NODE ? e.localName === "slot" ? !0 : Ie(e) : !1;
}
function Ge(e, t) {
	if (!We(e)) return !1;
	let n = e, r = He(n), i = r > 0;
	r >= 0 && t.push(n);
	let a = Ue(n);
	for (let e = 0; e < a.length; e += 1) i = Ge(a[e], t) || i;
	return i;
}
function Ke(e) {
	let t = [];
	return Ge(e, t) ? ze(t) : t;
}
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/utils/deep-contains.js
function qe(e, t) {
	let n = e.contains(t);
	if (n) return !0;
	function r(e) {
		for (let i = 0; i < e.children.length; i += 1) {
			let a = e.children[i];
			if (a.shadowRoot && qe(a.shadowRoot, t)) {
				n = !0;
				break;
			}
			a.children.length > 0 && r(a);
		}
	}
	return e instanceof HTMLElement && e.shadowRoot && (n = qe(e.shadowRoot, t), n) ? !0 : (r(e), n);
}
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/utils/key-codes.js
var Je = {
	enter: 13,
	space: 32,
	escape: 27,
	tab: 9
};
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/utils/contain-focus.js
function Ye(e, t) {
	let n = Ke(e), r;
	r = n.length >= 2 ? [n[0], n[n.length - 1]] : n.length === 1 ? [n[0], n[0]] : [e, e], t.shiftKey && r.reverse();
	let [i, a] = r, o = Ne();
	o === e || n.includes(o) && a !== o || (t.preventDefault(), i.focus());
}
function Xe(e) {
	let t = Ke(e), n = t.find((e) => e.hasAttribute("autofocus")) || e, r, i;
	n === e && (e.tabIndex = -1, e.style.setProperty("outline", "none")), n.focus();
	function a(t) {
		t.keyCode === Je.tab && Ye(e, t);
	}
	function o() {
		r = document.createElement("div"), r.style.display = "none", r.setAttribute("data-is-tab-detection-element", ""), e.insertBefore(r, e.children[0]), i = new MutationObserver((t) => {
			for (let n of t) if (n.type === "childList") {
				let t = !Array.from(e.children).find((e) => e.hasAttribute("data-is-tab-detection-element")), r = Array.from(n.addedNodes).find((e) => e instanceof HTMLElement && e.hasAttribute("data-is-tab-detection-element"));
				t && !r && (i.disconnect(), o());
			}
		}), i.observe(e, { childList: !0 });
	}
	function s() {
		return r.compareDocumentPosition(document.activeElement) === Node.DOCUMENT_POSITION_PRECEDING;
	}
	function c({ resetToRoot: n = !1 } = {}) {
		if (qe(e, Ne())) return;
		let r;
		r = n ? e : t[s() ? 0 : t.length - 1], r && r.focus();
	}
	function l() {
		window.removeEventListener("focusin", l), c();
	}
	function u() {
		setTimeout(() => {
			qe(e, Ne()) || c({ resetToRoot: !0 });
		}), window.addEventListener("focusin", l);
	}
	function d() {
		window.removeEventListener("keydown", a), window.removeEventListener("focusin", l), window.removeEventListener("focusout", u), i.disconnect(), Array.from(e.children).includes(r) && e.removeChild(r), e.style.removeProperty("outline");
	}
	return window.addEventListener("keydown", a), window.addEventListener("focusout", u), o(), { disconnect: d };
}
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/overlayShadowDomStyle.js
var Ze = s`
  .overlays {
    position: fixed;
    z-index: 200;
  }

  .overlays__overlay-container {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  .overlays__overlay-container::backdrop {
    display: none;
  }

  .overlays__overlay-container--top-left {
    justify-content: flex-start;
    align-items: flex-start;
  }

  .overlays__overlay-container--top {
    justify-content: center;
    align-items: flex-start;
  }

  .overlays__overlay-container--top-right {
    justify-content: flex-end;
    align-items: flex-start;
  }

  .overlays__overlay-container--right {
    justify-content: flex-end;
    align-items: center;
  }

  .overlays__overlay-container--bottom-left {
    justify-content: flex-start;
    align-items: flex-end;
  }

  .overlays__overlay-container--bottom {
    justify-content: center;
    align-items: flex-end;
  }

  .overlays__overlay-container--bottom-right {
    justify-content: flex-end;
    align-items: flex-end;
  }

  .overlays__overlay-container--left {
    justify-content: flex-start;
    align-items: center;
  }

  .overlays__overlay-container--center {
    justify-content: center;
    align-items: center;
  }

  .overlays__overlay--bottom-sheet {
    width: 100%;
  }

  ::slotted(.overlays__overlay),
  .overlays__overlay {
    pointer-events: auto;
  }

  .overlays__backdrop {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: #333333;
    display: none;
  }

  .overlays__backdrop--visible {
    display: block;
  }

  .overlays__backdrop--animation-in {
    animation: overlays-backdrop-fade-in 300ms;
    opacity: 0.3;
  }

  .overlays__backdrop--animation-out {
    animation: overlays-backdrop-fade-out 300ms;
    opacity: 0;
  }

  @keyframes overlays-backdrop-fade-in {
    from {
      opacity: 0;
    }
  }

  @keyframes overlays-backdrop-fade-out {
    from {
      opacity: 0.3;
    }
  }

  @media screen and (prefers-reduced-motion: reduce) {
    .overlays .overlays__backdrop--animation-in {
      animation: overlays-backdrop-fade-in 1ms;
    }

    .overlays .overlays__backdrop--animation-out {
      animation: overlays-backdrop-fade-out 1ms;
    }
  }

  dialog[data-overlay-outer-wrapper] {
    background-image: none;
    border-style: none;
    padding: 0px;
  }

  /** 
   * We don't want to use pseudo el ::backdrop.  
   * We have our own, that creates more flexibility wrt scrolling etc.
   */
  dialog[data-overlay-outer-wrapper]::backdrop {
    display: none;
  }
`, Qe = {
	supportsAdoptingStyleSheets: window.ShadowRoot && (window.ShadyCSS === void 0 || window.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype,
	adoptStyle: void 0,
	adoptStyles: void 0
}, $e = /* @__PURE__ */ new Map();
function et(e) {
	return Array.from(e.cssRules).map((e) => e.cssText).join("");
}
function tt(e, t, { teardown: n = !1 } = {}) {
	let r = e === document ? document.body : e, i = t.cssText || et(t);
	if (n) {
		let e = Array.from(r.querySelectorAll("style"));
		for (let t of e) if (t.textContent === i) {
			t.remove();
			break;
		}
	} else {
		let e = document.createElement("style"), t = window.litNonce;
		t !== void 0 && e.setAttribute("nonce", t), e.textContent = i, r.appendChild(e);
	}
}
function nt(e, t, { teardown: n = !1 } = {}) {
	let r = !1;
	$e.has(e) || $e.set(e, []);
	let i = $e.get(e), a = i.find((e) => t === e);
	return a && n ? i.splice(i.indexOf(t), 1) : !a && !n ? i.push(t) : (a && !n || !a && n) && (r = !0), { haltFurtherExecution: r };
}
function rt(e, t, { teardown: n = !1 } = {}) {
	let { haltFurtherExecution: r } = nt(e, t, { teardown: n });
	if (r) return;
	if (!Qe.supportsAdoptingStyleSheets) {
		tt(e, t, { teardown: n });
		return;
	}
	let i = t instanceof CSSStyleSheet ? t : t.styleSheet;
	if (!i) throw Error("Please provide a CSSResultOrNative style");
	n ? e.adoptedStyleSheets.includes(i) && e.adoptedStyleSheets.splice(e.adoptedStyleSheets.indexOf(i), 1) : e.adoptedStyleSheets = [...e.adoptedStyleSheets, i];
}
function it(e, t, { teardown: n = !1 } = {}) {
	for (let r of t) Qe.adoptStyle(e, r, { teardown: n });
}
Qe.adoptStyle = rt, Qe.adoptStyles = it;
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/OverlayController.js
function at({ wrappingDialogNodeL1: e, contentWrapperNodeL2: t, contentNodeL3: n }) {
	if (!(t.isConnected || n.isConnected)) throw Error("[OverlayController] Could not find a render target, since the provided contentNode is not connected to the DOM. Make sure that it is connected, e.g. by doing \"document.body.appendChild(contentNode)\", before passing it on.");
	let r, i = document.createComment("tempMarker");
	t.isConnected ? (r = t.parentElement || t.getRootNode(), r.insertBefore(i, t), e.appendChild(t)) : n.assignedSlot ? (r = n.assignedSlot.parentElement || n.assignedSlot.getRootNode(), r.insertBefore(i, n.assignedSlot), e.appendChild(t), t.appendChild(n.assignedSlot)) : (r = n.parentElement || n.getRootNode(), r.insertBefore(i, n), e.appendChild(t), t.appendChild(n)), r.insertBefore(e, i), r?.removeChild(i);
}
async function ot() {
	return import("./popper-DIJXjxf1.js");
}
var st = class e extends EventTarget {
	constructor(e = {}, t = Me) {
		super(), this.manager = t, this.__sharedConfig = e, this.__activeElementRightBeforeHide = null, this.config = {}, this._defaultConfig = {
			placementMode: void 0,
			contentNode: e.contentNode,
			contentWrapperNode: e.contentWrapperNode,
			invokerNode: e.invokerNode,
			backdropNode: e.backdropNode,
			referenceNode: void 0,
			elementToFocusAfterHide: e.invokerNode,
			inheritsReferenceWidth: "none",
			hasBackdrop: !1,
			isBlocking: !1,
			preventsScroll: !1,
			trapsKeyboardFocus: !1,
			hidesOnEsc: !1,
			hidesOnOutsideEsc: !1,
			hidesOnOutsideClick: !1,
			isTooltip: !1,
			invokerRelation: "description",
			visibilityTriggerFunction: void 0,
			handlesAccessibility: !1,
			popperConfig: {
				placement: "top",
				strategy: "fixed",
				modifiers: [
					{
						name: "preventOverflow",
						enabled: !0,
						options: {
							boundariesElement: "viewport",
							padding: 8
						}
					},
					{
						name: "flip",
						options: {
							boundariesElement: "viewport",
							padding: 16
						}
					},
					{
						name: "offset",
						enabled: !0,
						options: { offset: [0, 8] }
					},
					{
						name: "arrow",
						enabled: !1
					}
				]
			},
			viewportConfig: { placement: "center" },
			zIndex: 9999
		}, this.manager.add(this), this._contentId = `overlay-content--${Math.random().toString(36).slice(2, 10)}`, this.__originalAttrs = /* @__PURE__ */ new Map(), this.updateConfig(e), this.__hasActiveTrapsKeyboardFocus = !1, this.__hasActiveBackdrop = !0, this.__escKeyHandler = this.__escKeyHandler.bind(this);
	}
	get invoker() {
		return this.invokerNode;
	}
	get content() {
		return this.__wrappingDialogNode;
	}
	get placementMode() {
		return this.config?.placementMode;
	}
	get invokerNode() {
		return this.config?.invokerNode;
	}
	get referenceNode() {
		return this.config?.referenceNode;
	}
	get contentNode() {
		return this.config?.contentNode;
	}
	get contentWrapperNode() {
		return this.__contentWrapperNode || this.config?.contentWrapperNode;
	}
	get backdropNode() {
		return this.__backdropNode || this.config?.backdropNode;
	}
	get elementToFocusAfterHide() {
		return this.__elementToFocusAfterHide || this.config?.elementToFocusAfterHide;
	}
	get hasBackdrop() {
		return !!this.backdropNode || this.config?.hasBackdrop;
	}
	get isBlocking() {
		return this.config?.isBlocking;
	}
	get preventsScroll() {
		return this.config?.preventsScroll;
	}
	get trapsKeyboardFocus() {
		return this.config?.trapsKeyboardFocus;
	}
	get hidesOnEsc() {
		return this.config?.hidesOnEsc;
	}
	get hidesOnOutsideClick() {
		return this.config?.hidesOnOutsideClick;
	}
	get hidesOnOutsideEsc() {
		return this.config?.hidesOnOutsideEsc;
	}
	get inheritsReferenceWidth() {
		return this.config?.inheritsReferenceWidth;
	}
	get handlesAccessibility() {
		return this.config?.handlesAccessibility;
	}
	get isTooltip() {
		return this.config?.isTooltip;
	}
	get invokerRelation() {
		return this.config?.invokerRelation;
	}
	get popperConfig() {
		return this.config?.popperConfig;
	}
	get viewportConfig() {
		return this.config?.viewportConfig;
	}
	get visibilityTriggerFunction() {
		return this.config?.visibilityTriggerFunction;
	}
	get _referenceNode() {
		return this.referenceNode || this.invokerNode;
	}
	set elevation(e) {
		this.__wrappingDialogNode.style.zIndex = `${this.config.zIndex + e}`;
	}
	get elevation() {
		return Number(this.contentWrapperNode?.style.zIndex);
	}
	updateConfig(e) {
		this.teardown(), this.__prevConfig = this.config, this.config = {
			...this._defaultConfig,
			...this.__sharedConfig,
			...e,
			popperConfig: {
				...this._defaultConfig.popperConfig || {},
				...this.__sharedConfig.popperConfig || {},
				...e.popperConfig || {},
				modifiers: [
					...this._defaultConfig.popperConfig?.modifiers || [],
					...this.__sharedConfig.popperConfig?.modifiers || [],
					...e.popperConfig?.modifiers || []
				]
			}
		}, this.__validateConfiguration(this.config), this._init(), this.__elementToFocusAfterHide = void 0;
	}
	__validateConfiguration(e) {
		if (!e.placementMode) throw Error("[OverlayController] You need to provide a .placementMode (\"global\"|\"local\")");
		if (!["global", "local"].includes(e.placementMode)) throw Error(`[OverlayController] "${e.placementMode}" is not a valid .placementMode, use ("global"|"local")`);
		if (!e.contentNode) throw Error("[OverlayController] You need to provide a .contentNode");
		if (e.isTooltip && !e.handlesAccessibility) throw Error("[OverlayController] .isTooltip only takes effect when .handlesAccessibility is enabled");
	}
	_init() {
		this.__contentHasBeenInitialized ||= (this.__initContentDomStructure(), !0), this.contentWrapperNode.removeAttribute("style"), this.contentWrapperNode.removeAttribute("class"), this.placementMode === "local" && (e.popperModule ||= ot()), this.__handleOverlayStyles({ phase: "init" }), this._handleFeatures({ phase: "init" });
	}
	__handleOverlayStyles({ phase: e }) {
		let t = this.contentWrapperNode?.getRootNode();
		e === "init" ? Qe.adoptStyle(t, Ze) : e === "teardown" && Qe.adoptStyle(t, Ze, { teardown: !0 });
	}
	__initContentDomStructure() {
		let e = document.createElement(this.config?._noDialogEl ? "div" : "dialog");
		e.setAttribute("role", "none"), e.setAttribute("data-overlay-outer-wrapper", ""), e.style.cssText = `display:none; z-index: ${this.config.zIndex}; padding: 0;`, this.__wrappingDialogNode = e, this.config?.contentWrapperNode || (this.__contentWrapperNode = document.createElement("div")), this.contentWrapperNode.setAttribute("data-id", "content-wrapper"), at({
			wrappingDialogNodeL1: e,
			contentWrapperNodeL2: this.contentWrapperNode,
			contentNodeL3: this.contentNode
		}), e.open = !0, this.__wrappingDialogNode.style.display = "none", this.contentWrapperNode.style.zIndex = "1", getComputedStyle(this.contentNode).position === "absolute" && (this.contentNode.style.position = "static");
	}
	_handleZIndex({ phase: e }) {
		if (this.placementMode === "local" && e === "setup") {
			let e = Number(getComputedStyle(this.contentNode).zIndex);
			(e < 1 || Number.isNaN(e)) && (this.contentNode.style.zIndex = "1");
		}
	}
	__setupTeardownAccessibility({ phase: e }) {
		e === "init" ? (this.__storeOriginalAttrs(this.contentNode, ["role", "id"]), this.invokerNode && this.__storeOriginalAttrs(this.invokerNode, [
			"aria-expanded",
			"aria-labelledby",
			"aria-describedby"
		]), this.contentNode.id || this.contentNode.setAttribute("id", this._contentId), this.isTooltip ? (this.invokerNode && this.invokerNode.setAttribute(this.invokerRelation === "label" ? "aria-labelledby" : "aria-describedby", this._contentId), this.contentNode.setAttribute("role", "tooltip")) : (this.invokerNode && this.invokerNode.setAttribute("aria-expanded", `${this.isShown}`), this.contentNode.getAttribute("role") || this.contentNode.setAttribute("role", "dialog"))) : e === "teardown" && this.__restoreOriginalAttrs();
	}
	__storeOriginalAttrs(e, t) {
		let n = {};
		t.forEach((t) => {
			n[t] = e.getAttribute(t);
		}), this.__originalAttrs.set(e, n);
	}
	__restoreOriginalAttrs() {
		for (let [e, t] of this.__originalAttrs) Object.entries(t).forEach(([t, n]) => {
			n === null ? e.removeAttribute(t) : e.setAttribute(t, n);
		});
		this.__originalAttrs.clear();
	}
	get isShown() {
		return this.__wrappingDialogNode?.style.display !== "none";
	}
	async show(e = this.elementToFocusAfterHide) {
		if (this._showComplete && await this._showComplete, this._showComplete = new Promise((e) => {
			this._showResolve = e;
		}), this.manager && this.manager.show(this), this.isShown) {
			this._showResolve();
			return;
		}
		let t = new CustomEvent("before-show", { cancelable: !0 });
		this.dispatchEvent(t), t.defaultPrevented || ("HTMLDialogElement" in window && this.__wrappingDialogNode instanceof HTMLDialogElement && (this.__wrappingDialogNode.open = !0), this.__wrappingDialogNode.style.display = "", this._keepBodySize({ phase: "before-show" }), await this._handleFeatures({ phase: "show" }), this._keepBodySize({ phase: "show" }), await this._handlePosition({ phase: "show" }), this.__elementToFocusAfterHide = e, this.dispatchEvent(new Event("show")), await this._transitionShow({
			backdropNode: this.backdropNode,
			contentNode: this.contentNode
		})), this._showResolve();
	}
	async _handlePosition({ phase: e }) {
		if (this.placementMode === "global") {
			let t = `overlays__overlay-container--${this.viewportConfig.placement}`;
			e === "show" ? (this.contentWrapperNode.classList.add("overlays__overlay-container"), this.contentWrapperNode.classList.add(t), this.contentNode.classList.add("overlays__overlay")) : e === "hide" && (this.contentWrapperNode.classList.remove("overlays__overlay-container"), this.contentWrapperNode.classList.remove(t), this.contentNode.classList.remove("overlays__overlay"));
		} else this.placementMode === "local" && e === "show" && (await this.__createPopperInstance(), this._popper.forceUpdate());
	}
	_keepBodySize({ phase: e }) {
		switch (e) {
			case "before-show":
				this.__bodyClientWidth = document.body.clientWidth, this.__bodyClientHeight = document.body.clientHeight, this.__bodyMarginRightInline = document.body.style.marginRight, this.__bodyMarginBottomInline = document.body.style.marginBottom;
				break;
			case "show": {
				if (window.getComputedStyle) {
					let e = window.getComputedStyle(document.body);
					this.__bodyMarginRight = parseInt(e.getPropertyValue("margin-right"), 10), this.__bodyMarginBottom = parseInt(e.getPropertyValue("margin-bottom"), 10);
				} else this.__bodyMarginRight = 0, this.__bodyMarginBottom = 0;
				let e = document.body.clientWidth - this.__bodyClientWidth, t = document.body.clientHeight - this.__bodyClientHeight, n = this.__bodyMarginRight + e, r = this.__bodyMarginBottom + t;
				window.CSS?.number && document.body.attributeStyleMap?.set ? (document.body.attributeStyleMap.set("margin-right", CSS.px(n)), document.body.attributeStyleMap.set("margin-bottom", CSS.px(r))) : (document.body.style.marginRight = `${n}px`, document.body.style.marginBottom = `${r}px`);
				break;
			}
			case "hide":
				document.body.style.marginRight = this.__bodyMarginRightInline || "", document.body.style.marginBottom = this.__bodyMarginBottomInline || "";
				break;
		}
	}
	async hide() {
		if (this._hideComplete = new Promise((e) => {
			this._hideResolve = e;
		}), this.__activeElementRightBeforeHide = this.contentNode.getRootNode().activeElement, this.manager && this.manager.hide(this), !this.isShown) {
			this._hideResolve();
			return;
		}
		let e = new CustomEvent("before-hide", { cancelable: !0 });
		this.dispatchEvent(e), e.defaultPrevented || (await this._transitionHide({
			backdropNode: this.backdropNode,
			contentNode: this.contentNode
		}), "HTMLDialogElement" in window && this.__wrappingDialogNode instanceof HTMLDialogElement && this.__wrappingDialogNode.close(), this.__wrappingDialogNode.style.display = "none", this._handleFeatures({ phase: "hide" }), this._keepBodySize({ phase: "hide" }), this.dispatchEvent(new Event("hide")), this._restoreFocus()), this._hideResolve();
	}
	async transitionHide(e) {}
	async _transitionHide({ backdropNode: e, contentNode: t }) {
		await this.transitionHide({
			backdropNode: e,
			contentNode: t
		}), this._handlePosition({ phase: "hide" }), e && e.classList.remove("overlays__backdrop--animation-in");
	}
	async transitionShow(e) {}
	async _transitionShow(e) {
		await this.transitionShow({
			backdropNode: this.backdropNode,
			contentNode: this.contentNode
		}), e.backdropNode && e.backdropNode.classList.add("overlays__backdrop--animation-in");
	}
	_restoreFocus() {
		this.__activeElementRightBeforeHide instanceof HTMLElement && this.contentNode.contains(this.__activeElementRightBeforeHide) && (this.elementToFocusAfterHide ? (this.elementToFocusAfterHide.focus(), this.elementToFocusAfterHide.scrollIntoView({ block: "center" })) : this.__activeElementRightBeforeHide.blur());
	}
	async toggle() {
		return this.isShown ? this.hide() : this.show();
	}
	_handleFeatures({ phase: e }) {
		this._handleZIndex({ phase: e }), this.preventsScroll && this._handlePreventsScroll({ phase: e }), this.isBlocking && this._handleBlocking({ phase: e }), this.hasBackdrop && this._handleBackdrop({ phase: e }), this.trapsKeyboardFocus && this._handleTrapsKeyboardFocus({ phase: e }), this.hidesOnEsc && this._handleHidesOnEsc({ phase: e }), this.hidesOnOutsideEsc && this._handleHidesOnOutsideEsc({ phase: e }), this.hidesOnOutsideClick && this._handleHidesOnOutsideClick({ phase: e }), this.handlesAccessibility && this._handleAccessibility({ phase: e }), this.inheritsReferenceWidth && this._handleInheritsReferenceWidth(), this.visibilityTriggerFunction && this._handleVisibilityTriggers({ phase: e });
	}
	_handleVisibilityTriggers({ phase: e }) {
		typeof this.visibilityTriggerFunction == "function" && (e === "init" && (this.__visibilityTriggerHandler = this.visibilityTriggerFunction({
			phase: e,
			controller: this
		})), this.__visibilityTriggerHandler[e] && this.__visibilityTriggerHandler[e]());
	}
	_handlePreventsScroll({ phase: e }) {
		switch (e) {
			case "show":
				this.manager.requestToPreventScroll();
				break;
			case "hide":
				this.manager.requestToEnableScroll();
				break;
		}
	}
	_handleBlocking({ phase: e }) {
		switch (e) {
			case "show":
				this.manager.requestToShowOnly(this);
				break;
			case "hide":
				this.manager.retractRequestToShowOnly(this);
				break;
		}
	}
	get hasActiveBackdrop() {
		return this.__hasActiveBackdrop;
	}
	_handleBackdrop({ phase: e }) {
		switch (e) {
			case "init":
				this.__backdropInitialized ||= (this.config?.backdropNode || (this.__backdropNode = document.createElement("div"), this.__backdropNode.classList.add("overlays__backdrop")), this.__wrappingDialogNode.prepend(this.backdropNode), !0);
				break;
			case "show":
				this.config.hasBackdrop && this.backdropNode.classList.add("overlays__backdrop--visible"), this.__hasActiveBackdrop = !0;
				break;
			case "hide":
			case "teardown":
				this.backdropNode.classList.remove("overlays__backdrop--visible"), this.__hasActiveBackdrop = !1;
				break;
		}
	}
	get hasActiveTrapsKeyboardFocus() {
		return this.__hasActiveTrapsKeyboardFocus;
	}
	_handleTrapsKeyboardFocus({ phase: e }) {
		e === "show" ? ("showModal" in this.__wrappingDialogNode && (this.__wrappingDialogNode.close(), this.__wrappingDialogNode.showModal()), this.enableTrapsKeyboardFocus()) : (e === "hide" || e === "teardown") && this.disableTrapsKeyboardFocus();
	}
	enableTrapsKeyboardFocus() {
		this.__hasActiveTrapsKeyboardFocus || (this.manager && this.manager.disableTrapsKeyboardFocusForAll(), this._containFocusHandler = Xe(this.contentNode), this.__hasActiveTrapsKeyboardFocus = !0, this.manager && this.manager.informTrapsKeyboardFocusGotEnabled(this.placementMode));
	}
	disableTrapsKeyboardFocus({ findNewTrap: e = !0 } = {}) {
		this.__hasActiveTrapsKeyboardFocus && (this._containFocusHandler &&= (this._containFocusHandler.disconnect(), void 0), this.__hasActiveTrapsKeyboardFocus = !1, this.manager && this.manager.informTrapsKeyboardFocusGotDisabled({
			disabledCtrl: this,
			findNewTrap: e
		}));
	}
	__escKeyHandler(e) {
		return e.key === "Escape" && this.hide();
	}
	_handleHidesOnEsc({ phase: e }) {
		e === "show" ? (this.contentNode.addEventListener("keyup", this.__escKeyHandler), this.invokerNode && this.invokerNode.addEventListener("keyup", this.__escKeyHandler)) : e === "hide" && (this.contentNode.removeEventListener("keyup", this.__escKeyHandler), this.invokerNode && this.invokerNode.removeEventListener("keyup", this.__escKeyHandler));
	}
	_handleHidesOnOutsideEsc({ phase: e }) {
		e === "show" ? (this.__escKeyHandler = (e) => e.key === "Escape" && this.hide(), document.addEventListener("keyup", this.__escKeyHandler)) : e === "hide" && document.removeEventListener("keyup", this.__escKeyHandler);
	}
	_handleInheritsReferenceWidth() {
		if (!this._referenceNode || this.placementMode === "global") return;
		let e = `${this._referenceNode.getBoundingClientRect().width}px`;
		switch (this.inheritsReferenceWidth) {
			case "max":
				this.contentWrapperNode.style.maxWidth = e;
				break;
			case "full":
				this.contentWrapperNode.style.width = e;
				break;
			case "min":
				this.contentWrapperNode.style.minWidth = e, this.contentWrapperNode.style.width = "auto";
				break;
		}
	}
	_handleHidesOnOutsideClick({ phase: e }) {
		let t = e === "show" ? "addEventListener" : "removeEventListener";
		if (e === "show") {
			let e = !1, t = !1;
			this.__onInsideMouseDown = () => {
				e = !0;
			}, this.__onInsideMouseUp = () => {
				t = !0;
			}, this.__onDocumentMouseUp = () => {
				setTimeout(() => {
					!e && !t && this.hide(), e = !1, t = !1;
				});
			};
		}
		this.contentWrapperNode[t]("mousedown", this.__onInsideMouseDown, !0), this.contentWrapperNode[t]("mouseup", this.__onInsideMouseUp, !0), this.invokerNode && (this.invokerNode[t]("mousedown", this.__onInsideMouseDown, !0), this.invokerNode[t]("mouseup", this.__onInsideMouseUp, !0)), document.documentElement[t]("mouseup", this.__onDocumentMouseUp, !0);
	}
	_handleAccessibility({ phase: e }) {
		(e === "init" || e === "teardown") && this.__setupTeardownAccessibility({ phase: e }), this.invokerNode && !this.isTooltip && this.invokerNode.setAttribute("aria-expanded", `${e === "show"}`);
	}
	teardown() {
		this.__handleOverlayStyles({ phase: "teardown" }), this._handleFeatures({ phase: "teardown" });
	}
	async __createPopperInstance() {
		if (this._popper &&= (this._popper.destroy(), void 0), e.popperModule !== void 0) {
			let { createPopper: t } = await e.popperModule;
			this._popper = t(this._referenceNode, this.contentWrapperNode, { ...this.config?.popperConfig });
		}
	}
	_hasDisabledInvoker() {
		return this.invokerNode ? this.invokerNode.disabled || this.invokerNode.getAttribute("aria-disabled") === "true" : !1;
	}
};
st.popperModule = void 0;
//#endregion
//#region ../../node_modules/.pnpm/@open-wc+dedupe-mixin@1.4.0/node_modules/@open-wc/dedupe-mixin/src/dedupeMixin.js
var ct = /* @__PURE__ */ new WeakMap();
function lt(e, t) {
	let n = t;
	for (; n;) {
		if (ct.get(n) === e) return !0;
		n = Object.getPrototypeOf(n);
	}
	return !1;
}
function ut(e) {
	return (t) => {
		if (lt(e, t)) return t;
		let n = e(t);
		return ct.set(n, e), n;
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/utils/is-equal-config.js
function dt(e, t) {
	if (typeof e != "object" || typeof t != "object" || e === null || t === null) return e === t;
	let n = Object.keys(e), r = Object.keys(t);
	return n.length === r.length ? n.every((n) => dt(e[n], t[n])) : !1;
}
var ft = ut((e) => class extends e {
	static get properties() {
		return { opened: {
			type: Boolean,
			reflect: !0
		} };
	}
	constructor() {
		super(), this.opened = !1, this.config = {}, this.toggle = this.toggle.bind(this), this.open = this.open.bind(this), this.close = this.close.bind(this);
	}
	get config() {
		return this.__config;
	}
	set config(e) {
		let t = !dt(this.config, e);
		this._overlayCtrl && t && this._overlayCtrl.updateConfig(e), this.__config = e, this._overlayCtrl && t && this.__syncToOverlayController();
	}
	requestUpdate(e, t, n) {
		super.requestUpdate(e, t, n), e === "opened" && this.opened !== t && this.dispatchEvent(new Event("opened-changed"));
	}
	_defineOverlay({ contentNode: e, invokerNode: t, referenceNode: n, backdropNode: r, contentWrapperNode: i }) {
		let a = this._defineOverlayConfig() || {};
		return new st({
			contentNode: e,
			invokerNode: t,
			referenceNode: n,
			backdropNode: r,
			contentWrapperNode: i,
			...a,
			...this.config,
			popperConfig: {
				...a.popperConfig || {},
				...this.config?.popperConfig || {},
				modifiers: [...a.popperConfig?.modifiers || [], ...this.config?.popperConfig?.modifiers || []]
			}
		});
	}
	_defineOverlayConfig() {
		return { placementMode: "local" };
	}
	updated(e) {
		super.updated(e), e.has("opened") && this._overlayCtrl && !this.__blockSyncToOverlayCtrl && this.__syncToOverlayController();
	}
	_setupOpenCloseListeners() {
		this.__closeEventInContentNodeHandler = (e) => {
			e.stopPropagation(), this._overlayCtrl.hide();
		}, this._overlayContentNode && this._overlayContentNode.addEventListener("close-overlay", this.__closeEventInContentNodeHandler);
	}
	_teardownOpenCloseListeners() {
		this._overlayContentNode && this._overlayContentNode.removeEventListener("close-overlay", this.__closeEventInContentNodeHandler);
	}
	firstUpdated(e) {
		super.firstUpdated(e), this._setupOverlayCtrl();
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._overlayCtrl && this._teardownOverlayCtrl();
	}
	get _overlayInvokerNode() {
		return Array.from(this.children).find((e) => e.slot === "invoker");
	}
	get _overlayReferenceNode() {}
	get _overlayBackdropNode() {
		return this.__cachedOverlayBackdropNode ||= Array.from(this.children).find((e) => e.slot === "backdrop"), this.__cachedOverlayBackdropNode;
	}
	get _overlayContentNode() {
		return this._cachedOverlayContentNode ||= Array.from(this.children).find((e) => e.slot === "content") || this.config.contentNode, this._cachedOverlayContentNode;
	}
	get _overlayContentWrapperNode() {
		return this.shadowRoot?.querySelector("#overlay-content-node-wrapper");
	}
	_setupOverlayCtrl() {
		this._overlayCtrl = this._defineOverlay({
			contentNode: this._overlayContentNode,
			contentWrapperNode: this._overlayContentWrapperNode,
			invokerNode: this._overlayInvokerNode,
			referenceNode: this._overlayReferenceNode,
			backdropNode: this._overlayBackdropNode
		}), this.__syncToOverlayController(), this.__setupSyncFromOverlayController(), this._setupOpenCloseListeners();
	}
	_teardownOverlayCtrl() {
		this._teardownOpenCloseListeners(), this.__teardownSyncFromOverlayController(), this._overlayCtrl.teardown();
	}
	async _setOpenedWithoutPropertyEffects(e) {
		this.__blockSyncToOverlayCtrl = !0, this.opened = e, await this.updateComplete, this.__blockSyncToOverlayCtrl = !1;
	}
	__setupSyncFromOverlayController() {
		this.__onOverlayCtrlShow = () => {
			this.opened = !0;
		}, this.__onOverlayCtrlHide = () => {
			this.opened = !1;
		}, this.__onBeforeShow = (e) => {
			let t = new CustomEvent("before-opened", { cancelable: !0 });
			this.dispatchEvent(t), t.defaultPrevented && (this._setOpenedWithoutPropertyEffects(this._overlayCtrl.isShown), e.preventDefault());
		}, this.__onBeforeHide = (e) => {
			let t = new CustomEvent("before-closed", { cancelable: !0 });
			this.dispatchEvent(t), t.defaultPrevented && (this._setOpenedWithoutPropertyEffects(this._overlayCtrl.isShown), e.preventDefault());
		}, this._overlayCtrl.addEventListener("show", this.__onOverlayCtrlShow), this._overlayCtrl.addEventListener("hide", this.__onOverlayCtrlHide), this._overlayCtrl.addEventListener("before-show", this.__onBeforeShow), this._overlayCtrl.addEventListener("before-hide", this.__onBeforeHide);
	}
	__teardownSyncFromOverlayController() {
		this._overlayCtrl.removeEventListener("show", this.__onOverlayCtrlShow), this._overlayCtrl.removeEventListener("hide", this.__onOverlayCtrlHide), this._overlayCtrl.removeEventListener("before-show", this.__onBeforeShow), this._overlayCtrl.removeEventListener("before-hide", this.__onBeforeHide);
	}
	__syncToOverlayController() {
		this.opened ? this._overlayCtrl.show() : this._overlayCtrl.hide();
	}
	async toggle() {
		await this._overlayCtrl.toggle();
	}
	async open() {
		await this._overlayCtrl.show();
	}
	async close() {
		await this._overlayCtrl.hide();
	}
	repositionOverlay() {
		let e = this._overlayCtrl;
		e.placementMode === "local" && e._popper && e._popper.update();
	}
});
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/configurations/visibility-trigger-partials/withClickInteraction.js
function pt() {
	return { visibilityTriggerFunction: ({ controller: e }) => {
		function t() {
			e._hasDisabledInvoker() || e.toggle();
		}
		return {
			init: () => {
				e.invokerNode?.addEventListener("click", t);
			},
			teardown: () => {
				e.invokerNode?.removeEventListener("click", t);
			}
		};
	} };
}
//#endregion
//#region ../../node_modules/.pnpm/@lion+ui@0.4.2/node_modules/@lion/ui/components/overlays/src/configurations/withModalDialogConfig.js
var mt = () => ({
	placementMode: "global",
	viewportConfig: { placement: "center" },
	hasBackdrop: !0,
	preventsScroll: !0,
	trapsKeyboardFocus: !0,
	hidesOnEsc: !0,
	handlesAccessibility: !0,
	...pt()
}), ht = (e) => (t, n) => {
	n === void 0 ? customElements.define(e, t) : n.addInitializer(() => {
		customElements.define(e, t);
	});
}, gt = {
	attribute: !0,
	type: String,
	converter: y,
	reflect: !1,
	hasChanged: b
}, _t = (e = gt, t, n) => {
	let { kind: r, metadata: i } = n, a = globalThis.litPropertyMetadata.get(i);
	if (a === void 0 && globalThis.litPropertyMetadata.set(i, a = /* @__PURE__ */ new Map()), r === "setter" && ((e = Object.create(e)).wrapped = !0), a.set(n.name, e), r === "accessor") {
		let { name: r } = n;
		return {
			set(n) {
				let i = t.get.call(this);
				t.set.call(this, n), this.requestUpdate(r, i, e, !0, n);
			},
			init(t) {
				return t !== void 0 && this.C(r, void 0, e, t), t;
			}
		};
	}
	if (r === "setter") {
		let { name: r } = n;
		return function(n) {
			let i = this[r];
			t.call(this, n), this.requestUpdate(r, i, e, !0, n);
		};
	}
	throw Error("Unsupported decorator location: " + r);
};
function V(e) {
	return (t, n) => typeof n == "object" ? _t(e, t, n) : ((e, t, n) => {
		let r = t.hasOwnProperty(n);
		return t.constructor.createProperty(n, e), r ? Object.getOwnPropertyDescriptor(t, n) : void 0;
	})(e, t, n);
}
//#endregion
//#region ../../node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/decorators/state.js
function vt(e) {
	return V({
		...e,
		state: !0,
		attribute: !1
	});
}
//#endregion
//#region src/mixins/tailwind-component.ts
var yt = o("@supports not (translate:0){:host,*,:before,:after{--tw-legacy-translate-x:0;--tw-legacy-translate-y:0;--tw-legacy-rotate:0deg;--tw-legacy-scale-x:1;--tw-legacy-scale-y:1}::backdrop{--tw-legacy-translate-x:0;--tw-legacy-translate-y:0;--tw-legacy-rotate:0deg;--tw-legacy-scale-x:1;--tw-legacy-scale-y:1}}:host,*,:before,:after{--tw-translate-x:0;--tw-translate-y:0;--tw-translate-z:0;--tw-rotate-x:initial;--tw-rotate-y:initial;--tw-rotate-z:initial;--tw-skew-x:initial;--tw-skew-y:initial;--tw-border-style:solid;--tw-leading:initial;--tw-font-weight:initial;--tw-tracking:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-blur:initial;--tw-brightness:initial;--tw-contrast:initial;--tw-grayscale:initial;--tw-hue-rotate:initial;--tw-invert:initial;--tw-opacity:initial;--tw-saturate:initial;--tw-sepia:initial;--tw-drop-shadow:initial;--tw-drop-shadow-color:initial;--tw-drop-shadow-alpha:100%;--tw-drop-shadow-size:initial;--tw-duration:initial;--tw-scale-x:1;--tw-scale-y:1;--tw-scale-z:1}::backdrop{--tw-translate-x:0;--tw-translate-y:0;--tw-translate-z:0;--tw-rotate-x:initial;--tw-rotate-y:initial;--tw-rotate-z:initial;--tw-skew-x:initial;--tw-skew-y:initial;--tw-border-style:solid;--tw-leading:initial;--tw-font-weight:initial;--tw-tracking:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-blur:initial;--tw-brightness:initial;--tw-contrast:initial;--tw-grayscale:initial;--tw-hue-rotate:initial;--tw-invert:initial;--tw-opacity:initial;--tw-saturate:initial;--tw-sepia:initial;--tw-drop-shadow:initial;--tw-drop-shadow-color:initial;--tw-drop-shadow-alpha:100%;--tw-drop-shadow-size:initial;--tw-duration:initial;--tw-scale-x:1;--tw-scale-y:1;--tw-scale-z:1}:root,:host{--font-sans:ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Noto Sans\", Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";--font-mono:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;--spacing:4px;--text-xs:12px;--text-xs--line-height:16px;--text-sm:14px;--text-sm--line-height:calc(1.25 / .875);--text-base:16px;--text-base--line-height:calc(1.5 / 1);--text-lg:18px;--text-lg--line-height:calc(1.75 / 1.125);--text-xl:20px;--text-xl--line-height:calc(1.75 / 1.25);--text-2xl:24px;--text-2xl--line-height:32px;--text-3xl:30px;--text-3xl--line-height:calc(2.25 / 1.875);--text-5xl:48px;--text-5xl--line-height:1;--font-weight-normal:400;--font-weight-medium:500;--font-weight-semibold:600;--font-weight-bold:700;--tracking-wide:.025em;--leading-tight:1.25;--radius-md:6px;--radius-lg:8px;--radius-2xl:16px;--animate-spin:spin 1s linear infinite;--default-transition-duration:.15s;--default-transition-timing-function:cubic-bezier(.4, 0, .2, 1);--default-font-family:var(--font-sans);--default-mono-font-family:var(--font-mono);--color-black:#000;--color-white:#fff;--color-gray-50:#f9fafb;--color-gray-100:#f3f4f6;--color-gray-200:#e5e7eb;--color-gray-300:#d1d5db;--color-gray-400:#9ca3af;--color-gray-500:#6b7280;--color-gray-600:#4b5563;--color-gray-700:#374151;--color-gray-900:#111827;--color-blue-500:#3b82f6;--color-blue-600:#2563eb}*,:after,:before{box-sizing:border-box;border:0 solid;margin:0;padding:0}::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::-webkit-file-upload-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;-moz-tab-size:4;tab-size:4;line-height:1.5;font-family:var(--default-font-family,-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\");font-feature-settings:var(--default-font-feature-settings,normal);font-variation-settings:var(--default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family,ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace);font-feature-settings:var(--default-mono-font-feature-settings,normal);font-variation-settings:var(--default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring:where(:not(iframe)){outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::-webkit-file-upload-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::-webkit-file-upload-button{margin-inline-end:4px}::file-selector-button{margin-inline-end:4px}::placeholder{opacity:1}@supports (not ((-webkit-appearance:-apple-pay-button))) or (contain-intrinsic-size:1px){::placeholder{color:currentColor}@supports (color:color-mix(in lab, red, red)){::placeholder{color:color-mix(in oklab, currentcolor 50%, transparent)}}}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block-start:0;padding-block-end:0}::-webkit-datetime-edit-year-field{padding-block-start:0;padding-block-end:0}::-webkit-datetime-edit-month-field{padding-block-start:0;padding-block-end:0}::-webkit-datetime-edit-day-field{padding-block-start:0;padding-block-end:0}::-webkit-datetime-edit-hour-field{padding-block-start:0;padding-block-end:0}::-webkit-datetime-edit-minute-field{padding-block-start:0;padding-block-end:0}::-webkit-datetime-edit-second-field{padding-block-start:0;padding-block-end:0}::-webkit-datetime-edit-millisecond-field{padding-block-start:0;padding-block-end:0}::-webkit-datetime-edit-meridiem-field{padding-block-start:0;padding-block-end:0}::-webkit-calendar-picker-indicator{line-height:1}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){-webkit-appearance:button;-moz-appearance:button;appearance:button}::-webkit-file-upload-button{-webkit-appearance:button;-moz-appearance:button;appearance:button}::file-selector-button{-webkit-appearance:button;-moz-appearance:button;appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}*,:after,:before{border-color:var(--color-gray-200,currentcolor)}::backdrop{border-color:var(--color-gray-200,currentcolor)}::-webkit-file-upload-button{border-color:var(--color-gray-200,currentcolor)}::file-selector-button{border-color:var(--color-gray-200,currentcolor)}input::placeholder,textarea::placeholder{color:var(--color-gray-400)}:where(button:not(:disabled),[role=button]:not(:disabled)){cursor:pointer}button,input,select,optgroup,textarea{font-variant:normal;font-style:normal}::-webkit-file-upload-button{font-variant:normal;font-style:normal}::file-selector-button{font-variant:normal;font-style:normal}dialog{margin:auto}.pointer-events-auto{pointer-events:auto}.visible{visibility:visible}.absolute{position:absolute}.fixed{position:fixed}.relative{position:relative}.static{position:static}.top-0{top:0}.top-1\\/2{top:50%}.top-3{top:calc(var(--spacing) * 3)}.right-0{right:0}.left-1\\/2{left:50%}.isolate{isolation:isolate}.z-10{z-index:10}.z-2147483598{z-index:2147483598}.m-auto{margin:auto}.mx-auto{margin-inline-start:auto;margin-inline-end:auto}.mt-1{margin-top:var(--spacing)}.mt-4{margin-top:calc(var(--spacing) * 4)}.mr-2{margin-right:calc(var(--spacing) * 2)}.mr-4{margin-right:calc(var(--spacing) * 4)}.mr-auto{margin-right:auto}.-mb-px{margin-bottom:-1px}.mb-1{margin-bottom:var(--spacing)}.mb-2{margin-bottom:calc(var(--spacing) * 2)}.mb-3{margin-bottom:calc(var(--spacing) * 3)}.mb-10{margin-bottom:calc(var(--spacing) * 10)}.ml-auto{margin-left:auto}.block{display:block}.flex{display:flex}.hidden{display:none}.inline{display:inline}.inline-block{display:inline-block}.inline-flex{display:inline-flex}.table{display:table}.h-1\\.5{height:calc(var(--spacing) * 1.5)}.h-4{height:calc(var(--spacing) * 4)}.h-5{height:calc(var(--spacing) * 5)}.h-6{height:calc(var(--spacing) * 6)}.h-7{height:calc(var(--spacing) * 7)}.h-8{height:calc(var(--spacing) * 8)}.h-32{height:calc(var(--spacing) * 32)}.h-auto{height:auto}.h-dvh{height:100dvh}.h-full{height:100%}.h-full\\!{height:100%!important}.max-h-dvh{max-height:100dvh}.w-4{width:calc(var(--spacing) * 4)}.w-5{width:calc(var(--spacing) * 5)}.w-7{width:calc(var(--spacing) * 7)}.w-8{width:calc(var(--spacing) * 8)}.w-64{width:calc(var(--spacing) * 64)}.w-\\[400px\\]{width:400px}.w-fit{width:-moz-fit-content;width:fit-content}.w-full{width:100%}.w-screen\\!{width:100vw!important}.max-w-\\[420px\\]{max-width:420px}.max-w-\\[620px\\]{max-width:620px}.max-w-full{max-width:100%}.min-w-12{min-width:calc(var(--spacing) * 12)}.flex-1{flex:1}.grow{flex-grow:1}.border-collapse{border-collapse:collapse}.-translate-x-1\\/2{--tw-translate-x:calc(calc(1 / 2 * 100%) * -1);translate:var(--tw-translate-x) var(--tw-translate-y)}@supports not (translate:0){.-translate-x-1\\/2{--tw-legacy-translate-x:calc(calc(1 / 2 * 100%) * -1);transform:translate(var(--tw-legacy-translate-x), var(--tw-legacy-translate-y)) rotate(var(--tw-legacy-rotate)) scale(var(--tw-legacy-scale-x), var(--tw-legacy-scale-y)) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,)}}.translate-x-0{--tw-translate-x:0px;translate:var(--tw-translate-x) var(--tw-translate-y)}@supports not (translate:0){.translate-x-0{--tw-legacy-translate-x:0px;transform:translate(var(--tw-legacy-translate-x), var(--tw-legacy-translate-y)) rotate(var(--tw-legacy-rotate)) scale(var(--tw-legacy-scale-x), var(--tw-legacy-scale-y)) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,)}}.-translate-y-1\\/2{--tw-translate-y:calc(calc(1 / 2 * 100%) * -1);translate:var(--tw-translate-x) var(--tw-translate-y)}@supports not (translate:0){.-translate-y-1\\/2{--tw-legacy-translate-y:calc(calc(1 / 2 * 100%) * -1);transform:translate(var(--tw-legacy-translate-x), var(--tw-legacy-translate-y)) rotate(var(--tw-legacy-rotate)) scale(var(--tw-legacy-scale-x), var(--tw-legacy-scale-y)) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,)}}.transform{transform:var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,)}@supports not (translate:0){.transform{transform:translate(var(--tw-legacy-translate-x), var(--tw-legacy-translate-y)) rotate(var(--tw-legacy-rotate)) scale(var(--tw-legacy-scale-x), var(--tw-legacy-scale-y)) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,)}}.animate-spin{animation:var(--animate-spin)}.cursor-pointer{cursor:pointer}.resize{resize:both}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-baseline{align-items:baseline}.items-center{align-items:center}.items-end{align-items:flex-end}.items-start{align-items:flex-start}.justify-between{justify-content:space-between}.justify-center{justify-content:center}.gap-1{gap:var(--spacing)}.gap-1\\.5{gap:calc(var(--spacing) * 1.5)}.gap-2{gap:calc(var(--spacing) * 2)}.gap-3{gap:calc(var(--spacing) * 3)}.gap-4{gap:calc(var(--spacing) * 4)}.gap-x-2{column-gap:calc(var(--spacing) * 2)}.truncate{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-visible{overflow:visible}.rounded-2xl{border-radius:var(--radius-2xl)}.rounded-full{border-radius:3.40282e38px}.rounded-lg{border-radius:var(--radius-lg)}.rounded-md{border-radius:var(--radius-md)}.rounded-t-2xl{border-top-left-radius:var(--radius-2xl);border-top-right-radius:var(--radius-2xl)}.rounded-b-2xl{border-bottom-right-radius:var(--radius-2xl);border-bottom-left-radius:var(--radius-2xl)}.border{border-style:var(--tw-border-style);border-width:1px}.border-t{border-top-style:var(--tw-border-style);border-top-width:1px}.border-t-0{border-top-style:var(--tw-border-style);border-top-width:0}.border-dashed{--tw-border-style:dashed;border-style:dashed}.border-gray-100{border-color:var(--color-gray-100)}.border-gray-300{border-color:var(--color-gray-300)}.border-b-gray-100{border-bottom-color:var(--color-gray-100)}.bg-gray-50{background-color:var(--color-gray-50)}.bg-gray-100{background-color:var(--color-gray-100)}.bg-gray-200{background-color:var(--color-gray-200)}.bg-gray-900\\/75{background-color:#111827bf}@supports (color:color-mix(in lab, red, red)){.bg-gray-900\\/75{background-color:color-mix(in oklab, var(--color-gray-900) 75%, transparent)}}.bg-transparent{background-color:#0000}.bg-white{background-color:var(--color-white)}.fill-blue-500{fill:var(--color-blue-500)}.p-1{padding:var(--spacing)}.p-2{padding:calc(var(--spacing) * 2)}.p-4{padding:calc(var(--spacing) * 4)}.p-6{padding:calc(var(--spacing) * 6)}.p-10{padding:calc(var(--spacing) * 10)}.p-12{padding:calc(var(--spacing) * 12)}.p-20{padding:calc(var(--spacing) * 20)}.px-3{padding-inline:calc(var(--spacing) * 3)}.px-4{padding-inline:calc(var(--spacing) * 4)}.py-1{padding-block:var(--spacing)}.py-3{padding-block:calc(var(--spacing) * 3)}.py-4{padding-block:calc(var(--spacing) * 4)}.py-6{padding-block:calc(var(--spacing) * 6)}.text-center{text-align:center}.text-left{text-align:left}.text-right{text-align:right}.align-\\[-0\\.125em\\]{vertical-align:-.125em}.font-sans{font-family:var(--font-sans)}.text-2xl{font-size:var(--text-2xl);line-height:var(--tw-leading,var(--text-2xl--line-height))}.text-3xl{font-size:var(--text-3xl);line-height:var(--tw-leading,var(--text-3xl--line-height))}.text-5xl{font-size:var(--text-5xl);line-height:var(--tw-leading,var(--text-5xl--line-height))}.text-base{font-size:var(--text-base);line-height:var(--tw-leading,var(--text-base--line-height))}.text-lg{font-size:var(--text-lg);line-height:var(--tw-leading,var(--text-lg--line-height))}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.text-xl{font-size:var(--text-xl);line-height:var(--tw-leading,var(--text-xl--line-height))}.text-xs{font-size:var(--text-xs);line-height:var(--tw-leading,var(--text-xs--line-height))}.leading-tight{--tw-leading:var(--leading-tight);line-height:var(--leading-tight)}.font-bold{--tw-font-weight:var(--font-weight-bold);font-weight:var(--font-weight-bold)}.font-medium{--tw-font-weight:var(--font-weight-medium);font-weight:var(--font-weight-medium)}.font-normal{--tw-font-weight:var(--font-weight-normal);font-weight:var(--font-weight-normal)}.font-semibold{--tw-font-weight:var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.tracking-wide{--tw-tracking:var(--tracking-wide);letter-spacing:var(--tracking-wide)}.whitespace-nowrap{white-space:nowrap}.text-\\[\\#B42318\\]{color:#b42318}.text-\\[\\#ffb730\\]{color:#ffb730}.text-black{color:var(--color-black)}.text-blue-600{color:var(--color-blue-600)}.text-gray-200{color:var(--color-gray-200)}.text-gray-500{color:var(--color-gray-500)}.text-gray-700{color:var(--color-gray-700)}.text-gray-900{color:var(--color-gray-900)}.text-gray-900\\!{color:var(--color-gray-900)!important}.text-white{color:var(--color-white)}.uppercase{text-transform:uppercase}.italic{font-style:italic}.no-underline\\!{text-decoration-line:none!important}.underline{text-decoration-line:underline}.opacity-40{opacity:.4}.opacity-50{opacity:.5}.opacity-60{opacity:.6}.shadow{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a), 0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)}.drop-shadow{--tw-drop-shadow-size:drop-shadow(0 1px 2px var(--tw-drop-shadow-color,#0000001a)) drop-shadow(0 1px 1px var(--tw-drop-shadow-color,#0000000f));--tw-drop-shadow:drop-shadow(0 1px 2px #0000001a) drop-shadow(0 1px 1px #0000000f);filter:var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,)}.drop-shadow-md{--tw-drop-shadow-size:drop-shadow(0 4px 3px var(--tw-drop-shadow-color,#00000012)) drop-shadow(0 2px 2px var(--tw-drop-shadow-color,#0000000f));--tw-drop-shadow:drop-shadow(0 4px 3px #00000012) drop-shadow(0 2px 2px #0000000f);filter:var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,)}.filter{filter:var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,)}.transition{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to,opacity,box-shadow,transform,translate,scale,rotate,filter,-webkit-backdrop-filter,backdrop-filter,display,content-visibility,overlay,pointer-events;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-all{transition-property:all;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.duration-300{--tw-duration:.3s;transition-duration:.3s}.hover\\:scale-105:hover{--tw-scale-x:105%;--tw-scale-y:105%;--tw-scale-z:105%;scale:var(--tw-scale-x) var(--tw-scale-y)}@supports not (translate:0){.hover\\:scale-105:hover{--tw-legacy-scale-x:1.05;--tw-legacy-scale-y:1.05;transform:translate(var(--tw-legacy-translate-x), var(--tw-legacy-translate-y)) rotate(var(--tw-legacy-rotate)) scale(var(--tw-legacy-scale-x), var(--tw-legacy-scale-y)) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,)}}.focus\\:outline-hidden:focus{--tw-outline-style:none;outline-style:none}@media (forced-colors:active){.focus\\:outline-hidden:focus{outline-offset:2px;outline:2px solid #0000}}@media (min-width:32.5625rem){.modal-desktop\\:h-auto{height:auto}.modal-desktop\\:max-h-\\[90dvh\\]{max-height:90dvh}.modal-desktop\\:max-h-\\[90vh\\]{max-height:90vh}.modal-desktop\\:max-h-\\[min\\(90dvh\\,725px\\)\\]{max-height:min(90dvh,725px)}.modal-desktop\\:w-auto{width:auto}.modal-desktop\\:overflow-auto{overflow:auto}.modal-desktop\\:text-white{color:var(--color-white)}}@media (min-width:40rem){.sm\\:flex-row{flex-direction:row}}@media (min-width:48rem){.md\\:shadow-md{--tw-shadow:0 4px 6px -1px var(--tw-shadow-color,#0000001a), 0 2px 4px -2px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)}}@media (prefers-color-scheme:dark){.dark\\:text-gray-600{color:var(--color-gray-600)}}@media (max-width:520px){.max-modal-desktop\\:h-full\\!{height:100%!important}}:host{font-family:Matter,sans-serif;font-size:16px}@property --tw-translate-x{syntax:\"*\";inherits:false;initial-value:0}@property --tw-translate-y{syntax:\"*\";inherits:false;initial-value:0}@property --tw-translate-z{syntax:\"*\";inherits:false;initial-value:0}@property --tw-rotate-x{syntax:\"*\";inherits:false}@property --tw-rotate-y{syntax:\"*\";inherits:false}@property --tw-rotate-z{syntax:\"*\";inherits:false}@property --tw-skew-x{syntax:\"*\";inherits:false}@property --tw-skew-y{syntax:\"*\";inherits:false}@property --tw-border-style{syntax:\"*\";inherits:false;initial-value:solid}@property --tw-leading{syntax:\"*\";inherits:false}@property --tw-font-weight{syntax:\"*\";inherits:false}@property --tw-tracking{syntax:\"*\";inherits:false}@property --tw-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:\"*\";inherits:false}@property --tw-shadow-alpha{syntax:\"<percentage>\";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:\"*\";inherits:false}@property --tw-inset-shadow-alpha{syntax:\"<percentage>\";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:\"*\";inherits:false}@property --tw-ring-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:\"*\";inherits:false}@property --tw-inset-ring-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:\"*\";inherits:false}@property --tw-ring-offset-width{syntax:\"<length>\";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:\"*\";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-blur{syntax:\"*\";inherits:false}@property --tw-brightness{syntax:\"*\";inherits:false}@property --tw-contrast{syntax:\"*\";inherits:false}@property --tw-grayscale{syntax:\"*\";inherits:false}@property --tw-hue-rotate{syntax:\"*\";inherits:false}@property --tw-invert{syntax:\"*\";inherits:false}@property --tw-opacity{syntax:\"*\";inherits:false}@property --tw-saturate{syntax:\"*\";inherits:false}@property --tw-sepia{syntax:\"*\";inherits:false}@property --tw-drop-shadow{syntax:\"*\";inherits:false}@property --tw-drop-shadow-color{syntax:\"*\";inherits:false}@property --tw-drop-shadow-alpha{syntax:\"<percentage>\";inherits:false;initial-value:100%}@property --tw-drop-shadow-size{syntax:\"*\";inherits:false}@property --tw-duration{syntax:\"*\";inherits:false}@property --tw-scale-x{syntax:\"*\";inherits:false;initial-value:1}@property --tw-scale-y{syntax:\"*\";inherits:false;initial-value:1}@property --tw-scale-z{syntax:\"*\";inherits:false;initial-value:1}@keyframes spin{to{transform:rotate(360deg)}}"), bt = (e) => {
	class t extends e {
		connectedCallback() {
			super.connectedCallback(), this.shadowRoot && c(this.shadowRoot, [yt]);
		}
	}
	return t;
};
//#endregion
//#region \0@oxc-project+runtime@0.138.0/helpers/esm/decorate.js
function H(e, t, n, r) {
	var i = arguments.length, a = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
	if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(e, t, n, r);
	else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
	return i > 3 && a && Object.defineProperty(t, n, a), a;
}
//#endregion
//#region src/components/dialog.ts
var xt = /* @__PURE__ */ function(e) {
	return e[e.MANUAL = 0] = "MANUAL", e[e.TIMED = 1] = "TIMED", e;
}({}), St = class extends bt(ft(Te)) {
	constructor(...e) {
		super(...e), this.trigger = 0, this.openDelay = 5e3, this.closeButton = !1, this.hideOnEsc = !0, this.hideOnOutsideClick = !1;
	}
	_defineOverlayConfig() {
		let e = document.createElement("div");
		return e.id = "overlays-backdrop", {
			...mt(),
			hidesOnOutsideEsc: this.hideOnEsc,
			hidesOnOutsideClick: this.hideOnOutsideClick,
			backdropNode: e
		};
	}
	connectedCallback() {
		super.connectedCallback(), this.trigger === 1 && setTimeout(() => {
			this.toggle();
		}, this.openDelay);
	}
	render() {
		return F`
      ${this.getBackdropStyles()}
      <slot name="invoker"></slot>
      <div id="overlay-content-node-wrapper">
        ${this.closeButton ? this.renderCloseIcon() : ""}
        <slot name="content"></slot>
      </div>
    `;
	}
	renderCloseIcon() {
		return F`
      <div
        class="pointer-events-auto absolute top-0 right-0 z-10 cursor-pointer p-4 modal-desktop:text-white"
        @click="${this.close}"
      >
        <svg class="h-7 w-7" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
          <path
            d="M242.7 256l100.1-100.1c12.3-12.3 12.3-32.2 0-44.5s-32.2-12.3-44.5 0L198.2 211.5 98.1 111.4c-12.3-12.3-32.2-12.3-44.5 0s-12.3 32.2 0 44.5L153.7 256 53.6 356.1c-12.3 12.3-12.3 32.2 0 44.5 6.2 6.2 14.3 9.3 22.3 9.3s16.1-3.1 22.3-9.3L198.2 300.5l100.1 100.1c6.2 6.2 14.3 9.3 22.3 9.3s16.1-3.1 22.3-9.3c12.3-12.3 12.3-32.2 0-44.5L242.7 256z"
            fill="currentColor"
          />
        </svg>
      </div>
    `;
	}
	getBackdropStyles() {
		return F`
      <style>
        #overlays-backdrop {
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #fff;
          position: fixed;
          opacity: 1;
        }

        #overlays-backdrop.overlays__backdrop--visible {
          display: block;
        }

        #overlays-backdrop.overlays__backdrop--animation-in {
          animation: overlays-backdrop-fade-in 300ms;
        }

        #overlays-backdrop.overlays__backdrop--animation-out {
          animation: overlays-backdrop-fade-out 300ms;
          opacity: 0;
        }

        @media (max-width: 520px) {
          dialog {
            width: 100%;
            height: 100%;
            max-width: 100vw;
            max-width: 100svw;
            max-height: 100vh;
            max-height: 100svh;
          }

          #overlay-content-node-wrapper {
            overflow-y: auto;
          }
        }

        @media (min-width: 521px) {
          #overlays-backdrop {
            background-color: #000;
            opacity: 0.7;
          }

          #overlay-content-node-wrapper {
            height: 100%;
          }
        }

        @keyframes overlays-backdrop-fade-in {
          from {
            opacity: 0;
          }
        }

        @keyframes overlays-backdrop-fade-out {
          from {
            opacity: 0.7;
          }
        }
      </style>
    `;
	}
};
H([V({
	type: Number,
	attribute: "trigger"
})], St.prototype, "trigger", void 0), H([V({
	type: Number,
	attribute: "open-delay"
})], St.prototype, "openDelay", void 0), H([V({
	type: Boolean,
	attribute: "close-button"
})], St.prototype, "closeButton", void 0), H([V({
	type: Boolean,
	attribute: "hide-on-esc"
})], St.prototype, "hideOnEsc", void 0), H([V({
	type: Boolean,
	attribute: "hide-on-outside-click"
})], St.prototype, "hideOnOutsideClick", void 0), St = H([ht("givebutter-dialog")], St);
//#endregion
//#region ../../node_modules/.pnpm/@lit-labs+observers@2.1.0/node_modules/@lit-labs/observers/mutation-controller.js
var Ct = class {
	constructor(e, { target: t, config: n, callback: r, skipInitial: i }) {
		this.t = /* @__PURE__ */ new Set(), this.o = !1, this.i = !1, this.h = e, t !== null && this.t.add(t ?? e), this.l = n, this.o = i ?? this.o, this.callback = r, window.MutationObserver ? (this.u = new MutationObserver((e) => {
			this.handleChanges(e), this.h.requestUpdate();
		}), e.addController(this)) : console.warn("MutationController error: browser does not support MutationObserver.");
	}
	handleChanges(e) {
		this.value = this.callback?.(e, this.u);
	}
	hostConnected() {
		for (let e of this.t) this.observe(e);
	}
	hostDisconnected() {
		this.disconnect();
	}
	async hostUpdated() {
		let e = this.u.takeRecords();
		(e.length || !this.o && this.i) && this.handleChanges(e), this.i = !1;
	}
	observe(e) {
		this.t.add(e), this.u.observe(e, this.l), this.i = !0, this.h.requestUpdate();
	}
	disconnect() {
		this.u.disconnect();
	}
}, wt = (e) => e ?? L, { I: Tt } = B, Et = (e) => e.strings === void 0, Dt = {
	ATTRIBUTE: 1,
	CHILD: 2,
	PROPERTY: 3,
	BOOLEAN_ATTRIBUTE: 4,
	EVENT: 5,
	ELEMENT: 6
}, Ot = (e) => (...t) => ({
	_$litDirective$: e,
	values: t
}), kt = class {
	constructor(e) {}
	get _$AU() {
		return this._$AM._$AU;
	}
	_$AT(e, t, n) {
		this._$Ct = e, this._$AM = t, this._$Ci = n;
	}
	_$AS(e, t) {
		return this.update(e, t);
	}
	update(e, t) {
		return this.render(...t);
	}
}, At = (e, t) => {
	let n = e._$AN;
	if (n === void 0) return !1;
	for (let e of n) e._$AO?.(t, !1), At(e, t);
	return !0;
}, jt = (e) => {
	let t, n;
	do {
		if ((t = e._$AM) === void 0) break;
		n = t._$AN, n.delete(e), e = t;
	} while (n?.size === 0);
}, Mt = (e) => {
	for (let t; t = e._$AM; e = t) {
		let n = t._$AN;
		if (n === void 0) t._$AN = n = /* @__PURE__ */ new Set();
		else if (n.has(e)) break;
		n.add(e), Ft(t);
	}
};
function Nt(e) {
	this._$AN === void 0 ? this._$AM = e : (jt(this), this._$AM = e, Mt(this));
}
function Pt(e, t = !1, n = 0) {
	let r = this._$AH, i = this._$AN;
	if (i !== void 0 && i.size !== 0) if (t) if (Array.isArray(r)) for (let e = n; e < r.length; e++) At(r[e], !1), jt(r[e]);
	else r != null && (At(r, !1), jt(r));
	else At(this, e);
}
var Ft = (e) => {
	e.type == Dt.CHILD && (e._$AP ??= Pt, e._$AQ ??= Nt);
}, It = class extends kt {
	constructor() {
		super(...arguments), this._$AN = void 0;
	}
	_$AT(e, t, n) {
		super._$AT(e, t, n), Mt(this), this.isConnected = e._$AU;
	}
	_$AO(e, t = !0) {
		e !== this.isConnected && (this.isConnected = e, e ? this.reconnected?.() : this.disconnected?.()), t && (At(this, e), jt(this));
	}
	setValue(e) {
		if (Et(this._$Ct)) this._$Ct._$AI(e, this);
		else {
			let t = [...this._$Ct._$AH];
			t[this._$Ci] = e, this._$Ct._$AI(t, this, 0);
		}
	}
	disconnected() {}
	reconnected() {}
}, Lt = () => new Rt(), Rt = class {}, zt = /* @__PURE__ */ new WeakMap(), Bt = Ot(class extends It {
	render(e) {
		return L;
	}
	update(e, [t]) {
		let n = t !== this.G;
		return n && this.G !== void 0 && this.rt(void 0), (n || this.lt !== this.ct) && (this.G = t, this.ht = e.options?.host, this.rt(this.ct = e.element)), L;
	}
	rt(e) {
		if (this.isConnected || (e = void 0), typeof this.G == "function") {
			let t = this.ht ?? globalThis, n = zt.get(t);
			n === void 0 && (n = /* @__PURE__ */ new WeakMap(), zt.set(t, n)), n.get(this.G) !== void 0 && this.G.call(this.ht, void 0), n.set(this.G, e), e !== void 0 && this.G.call(this.ht, e);
		} else this.G.value = e;
	}
	get lt() {
		return typeof this.G == "function" ? zt.get(this.ht ?? globalThis)?.get(this.G) : this.G?.value;
	}
	disconnected() {
		this.lt === this.ct && this.rt(void 0);
	}
	reconnected() {
		this.rt(this.ct);
	}
}), Vt = "important", Ht = " !important", Ut = Ot(class extends kt {
	constructor(e) {
		if (super(e), e.type !== Dt.ATTRIBUTE || e.name !== "style" || e.strings?.length > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
	}
	render(e) {
		return Object.keys(e).reduce((t, n) => {
			let r = e[n];
			return r == null ? t : t + `${n = n.includes("-") ? n : n.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${r};`;
		}, "");
	}
	update(e, [t]) {
		let { style: n } = e.element;
		if (this.ft === void 0) return this.ft = new Set(Object.keys(t)), this.render(t);
		for (let e of this.ft) t[e] ?? (this.ft.delete(e), e.includes("-") ? n.removeProperty(e) : n[e] = null);
		for (let e in t) {
			let r = t[e];
			if (r != null) {
				this.ft.add(e);
				let t = typeof r == "string" && r.endsWith(Ht);
				e.includes("-") || t ? n.setProperty(e, t ? r.slice(0, -11) : r, t ? Vt : "") : n[e] = r;
			}
		}
		return I;
	}
}), Wt = class {
	constructor(e, t) {
		this.icon = e, this.labelColor = t;
	}
	getSVG() {
		switch (this.icon) {
			case "none": return "";
			case "ticket": return this.ticketIcon();
			case "gift": return this.giftIcon();
			case "giving_hands": return this.givingHandsIcon();
			default: return this.heartIcon();
		}
	}
	ticketIcon() {
		return F`
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 2H16C17.0938 2 18 2.90625 18 4V6.5C17.1562 6.5 16.5 7.1875 16.5 8C16.5 8.84375 17.1562 9.5 18 9.5V12C18 13.125 17.0938 14 16 14H2C0.875 14 0 13.125 0 12V9.5C0.8125 9.5 1.5 8.84375 1.5 8C1.5 7.1875 0.8125 6.5 0 6.5V4C0 2.90625 0.875 2 2 2ZM4 5H14V11H4V5ZM3 5V11C3 11.5625 3.4375 12 4 12H14C14.5312 12 15 11.5625 15 11V5C15 4.46875 14.5312 4 14 4H4C3.4375 4 3 4.46875 3 5Z"
          fill="${this.labelColor}"
        />
      </svg>
    `;
	}
	heartIcon() {
		return F`
      <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 8L1.21875 7.25C0.4375 6.46875 0 5.375 0 4.25C0 1.90625 1.875 0 4.21875 0C5.34375 0 6.4375 0.46875 7.21875 1.25L8 2L8.75 1.25C9.53125 0.46875 10.625 0 11.75 0C14.0938 0 16 1.90625 16 4.25C16 5.375 15.5312 6.46875 14.75 7.25L14 8L8 14L2 8Z"
          fill="${this.labelColor}"
        />
      </svg>
    `;
	}
	giftIcon() {
		return F`
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.9375 2.15625C5.71875 1.75 5.28125 1.5 4.8125 1.5H4.75C4.03125 1.5 3.5 2.0625 3.5 2.75C3.5 3.46875 4.03125 4 4.75 4H7H7.03125L5.9375 2.15625ZM2 2.75C2 1.25 3.21875 0 4.75 0H4.8125C5.8125 0 6.71875 0.53125 7.21875 1.40625L8 2.6875L8.75 1.40625C9.25 0.53125 10.1562 0 11.1562 0H11.25C12.75 0 14 1.25 14 2.75C14 3.21875 13.875 3.625 13.6875 4H16V8H0V4H2.28125C2.09375 3.625 2 3.21875 2 2.75ZM12.5 2.75C12.5 2.0625 11.9375 1.5 11.25 1.5H11.1562C10.6875 1.5 10.2812 1.75 10.0312 2.15625L8.9375 4H9H11.25C11.9375 4 12.5 3.46875 12.5 2.75ZM1 9H7V16H1V9ZM9 16V9H15V16H9Z"
          fill="${this.labelColor}"
        />
      </svg>
    `;
	}
	givingHandsIcon() {
		return F`
      <svg
        width="20"
        height="17"
        viewBox="0 0 20 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.625 2.3125C5.625 1.0625 6.65625 0 7.9375 0H8.03125C8.625 0 9.25 0.25 9.6875 0.6875L10 0.96875L10.2812 0.6875C10.7188 0.25 11.3438 0 11.9688 0H12.0625C13.3125 0 14.375 1.0625 14.375 2.3125C14.375 2.96875 14.0938 3.5625 13.6562 4L10.4062 7.09375L10 7.53125L9.5625 7.09375L6.3125 4C5.875 3.5625 5.625 2.96875 5.625 2.3125ZM2.5 2V3.25V3.5V4.5V7V9.09375L5.125 11.7188L6.40625 10.8438L5.28125 9.71875L4.5625 9L4.28125 8.71875L3.5625 8L5 6.59375L5.6875 7.3125L6 7.59375L6.6875 8.3125L8.6875 10.3125L9 10.5938V11V13V14V15V16H8H5H4.5625L4.28125 15.7188L0.28125 11.7188L0 11.4375V11V7V5V4V3.25V2H2.5ZM17.5 2H20V3.25V4V5V7V11V11.4375L19.6875 11.7188L15.6875 15.7188L15.4062 16.0312H15H12H11V15V14V13V11V10.5938L11.2812 10.3125L13.2812 8.3125L14 7.59375L14.2812 7.3125L15 6.59375L16.4062 8L15.6875 8.71875L15.4062 9L14.6875 9.71875L13.5625 10.8438L14.8438 11.7188L17.5 9.09375V7V4.5V3.5V3.25V2Z"
          fill="${this.labelColor}"
        />
      </svg>
    `;
	}
}, U = {
	debug: (...e) => console.debug("[widgets-core]", ...e),
	info: (...e) => console.info("[widgets-core]", ...e),
	warn: (...e) => console.warn("[widgets-core]", ...e),
	error: (...e) => console.error("[widgets-core]", ...e)
}, Gt = /* @__PURE__ */ function(e) {
	return e.godaddy = "godaddy", e.salesforce = "salesforce", e.wix = "wix", e.unknown = "unknown", e;
}(Gt || {}), Kt = /* @__PURE__ */ function(e) {
	return e.dynamicElementReplacement = "dynamic", e;
}(Kt || {}), qt = class {
	static getQueryParams(e) {
		let t;
		try {
			t = new URLSearchParams(new URL(e).search);
		} catch {
			let n = e.indexOf("?") + 1, r = e.indexOf("#") === -1 ? e.length : e.indexOf("#");
			t = new URLSearchParams(e.substring(n, r));
		}
		let n = {};
		for (let [e, r] of t.entries()) n[e] = r;
		return n;
	}
	static isValidEmbedUrl(e) {
		return e.startsWith(K.apiUrl);
	}
	static isCurrentHostnameGivebutter() {
		for (let e of [
			"givebutter.com",
			"givebutter.test",
			"churn.butterslice.tech"
		]) if (window.location.hostname.endsWith(e)) return !0;
		return !1;
	}
	static isPreviewHostAllowed() {
		let e = ["sanity.io"];
		if (this.isCurrentHostnameGivebutter()) return !0;
		for (let t of e) if (window.location.hostname.endsWith(t)) return !0;
		return !1;
	}
	static getParentHostUrl() {
		try {
			return window.parent.location.href;
		} catch {
			return null;
		}
	}
}, Jt = null, W = class {
	static captureScriptSrc(e) {
		Jt = e ?? null;
	}
	static isLocalEnv() {
		return !1;
	}
	static isInsideIframe() {
		return window.top !== window.self;
	}
	static isWixEditorPreview() {
		return this.getPlatform() === Gt.wix && this.isInsideIframe();
	}
	static isGoDaddyBackoffice() {
		return window.parent.location.hostname.endsWith(".godaddy.com");
	}
	static isDynamicElementReplacementMode() {
		return this.getPlatform() === Gt.salesforce || this.isMode(Kt.dynamicElementReplacement);
	}
	static getAccountId() {
		if (!K.aid) {
			let e = this.getConfigParam("acct");
			if (e && typeof e == "string") {
				let t = decodeURIComponent(e).trim();
				/^[a-zA-Z0-9]{16}$/.test(t) || this.isLocalEnv() ? K.aid = t : U.error(`Invalid ?acct= format: ${t}`);
			}
			!K.aid && !qt.isCurrentHostnameGivebutter() && U.warn("Could not find ?acct= attribute in script url");
		}
		return K.aid;
	}
	static getPlatform() {
		return (!K.platform || K.platform === Gt.unknown) && (K.platform = this.getConfigParam("p", Gt.unknown)), K.platform;
	}
	static isMode(e) {
		return K.mode ||= this.getConfigParam("mode") ?? "", K.mode.includes(e);
	}
	static getConfigParam(e, t = null) {
		let n = Jt ?? this.getCurrentScriptSrc();
		if (!n) return t;
		try {
			return new URL(n).searchParams.get(e) ?? t;
		} catch {
			return t;
		}
	}
	static getCurrentScriptSrc() {
		let e = document.currentScript;
		return e instanceof HTMLScriptElement ? e.src : null;
	}
}, Yt = () => {
	try {
		return window.localStorage ?? null;
	} catch {
		return null;
	}
}, Xt = class {
	static loadObjectFromLocalStorage(e, t) {
		let n = Yt();
		if (!n) return U.warn("localStorage is not available. Can't load data."), {};
		try {
			let r = n.getItem(e);
			return t ? JSON.parse(r ?? "{}") : {};
		} catch (e) {
			return U.error(e), {};
		}
	}
	static saveObjectToLocalStorage(e, t) {
		let n = Yt();
		if (!n) return U.warn("localStorage is not available. Can't save data."), !1;
		try {
			return n.setItem(e, JSON.stringify(t)), !0;
		} catch (e) {
			return U.error(e), !1;
		}
	}
}, Zt = "givebutter.analytics:0.0.0", Qt = {
	maxAge: 1440 * 30,
	qsPrefix: "gba_",
	temporaryKeyPrefix: "tmp_",
	qsThirdPartyKeys: [
		"utm_source",
		"utm_medium",
		"utm_campaign",
		"utm_term",
		"utm_content",
		"gclid",
		"wbraid",
		"gbraid",
		"gclsrc",
		"dclid",
		"fbclid"
	],
	widgetFormKeys: [
		"amount",
		"frequency",
		"fund",
		"promo"
	]
}, $t = class {
	constructor() {
		this._filterTemporaryKeys = function(e) {
			e = { ...e };
			for (let t of Object.keys(e)) t.startsWith("gb.element.") && (W.isLocalEnv() && U.debug("_filterTemporaryKeys) Filtering " + t), delete e[t]), t.toLowerCase().startsWith(Qt.temporaryKeyPrefix) && (W.isLocalEnv() && U.debug("_filterTemporaryKeys) Filtering " + t), delete e[t]);
			return e;
		}, this.analyticsData = {}, this.loadFromStorage(), this.cleanup(), this.loadFromUrl(window.location.href);
	}
	getQueryString() {
		let e = this.getAll();
		return Object.keys(e).length === 0 ? "" : this.objToQueryString(e, null);
	}
	loadFromStorage() {
		this.analyticsData = Xt.loadObjectFromLocalStorage(Zt, this.analyticsData);
	}
	set(e, t) {
		let n = Date.now();
		return e = e.toLowerCase(), this.analyticsData[e] = {
			v: t,
			c: n,
			e: n + Qt.maxAge * 60 * 1e3
		}, this.saveToStorage();
	}
	remove(e) {
		delete this.analyticsData[e], this.saveToStorage();
	}
	cleanup() {
		let e = Date.now(), t = !1;
		for (let n in this.analyticsData) if (this.analyticsData[n].e <= e) {
			W.isLocalEnv() && U.debug("cleanup() Key '" + n + "' expired at " + this.analyticsData[n].e + " (" + (this.analyticsData[n].e - e) + ")"), delete this.analyticsData[n], t = !0;
			break;
		}
		return t ? (this.saveToStorage(), !0) : !1;
	}
	saveToStorage() {
		W.isLocalEnv() && U.debug("saveToStorage() - userAllowsTracking = false");
		let e = this._filterTemporaryKeys(this.analyticsData);
		return Xt.saveObjectToLocalStorage(Zt, e);
	}
	loadFromUrl(e) {
		let t = qt.getQueryParams(e);
		for (let e in t) if (e.toLowerCase().startsWith(Qt.qsPrefix)) {
			let n = t[e];
			W.isLocalEnv() && U.debug("loadFromUrl() qsPrefix match: " + e + " = " + n), this.set(e, n);
		}
		for (let e of Qt.qsThirdPartyKeys) t.hasOwnProperty(e) && (W.isLocalEnv() && U.debug("loadFromUrl() qsThirdPartyKeys match: " + e + " = " + t[e]), this.set(e, t[e]));
		for (let e of Qt.widgetFormKeys) t.hasOwnProperty(e) ? (W.isLocalEnv() && U.debug("loadFromUrl() widgetFormKeys match: " + e + " = " + t[e]), this.set(e, t[e])) : this.analyticsData.hasOwnProperty(e) && this.remove(e);
	}
	getAll() {
		let e = Date.now(), t = {};
		for (let n in this.analyticsData) this.analyticsData[n].e >= e && (t[n] = this.analyticsData[n].v);
		return t;
	}
	serializeKey(e, t) {
		return e && e.length > 0 ? `${e}.${t}` : t;
	}
	objToQueryString(e, t = null) {
		let n = [];
		for (let r in e) if (e.hasOwnProperty(r)) {
			let i = t ? this.serializeKey(t, r) : r, a = e[r];
			n.push(typeof a == "object" && a ? this.objToQueryString(a, i) : `${encodeURIComponent(i)}=${encodeURIComponent(a)}`);
		}
		return n.join("&");
	}
}, en = [
	"givebutter.test",
	"legendairy.xyz",
	"givebutter.com",
	"churn.butterslice.tech"
], tn = (e) => {
	try {
		let { hostname: t } = new URL(e);
		return en.some((e) => t === e || t.endsWith(`.${e}`));
	} catch {
		return !1;
	}
}, G = {
	init: !1,
	analytics: null,
	aid: null,
	platform: Gt.unknown,
	mode: "",
	apiUrl: null
}, K = {
	get init() {
		return G.init;
	},
	set init(e) {
		G.init = e;
	},
	get analytics() {
		return G.analytics ||= new $t(), G.analytics;
	},
	get aid() {
		return G.aid;
	},
	set aid(e) {
		G.aid = e;
	},
	get platform() {
		return G.platform;
	},
	set platform(e) {
		G.platform = e;
	},
	get mode() {
		return G.mode;
	},
	set mode(e) {
		G.mode = e;
	},
	get apiUrl() {
		return G.apiUrl ?? void 0 ?? "";
	},
	set apiUrl(e) {
		if (!tn(e)) {
			U.warn(`Invalid apiUrl domain: ${e}`);
			return;
		}
		G.apiUrl = e;
	},
	reset() {
		G.init = !1, G.analytics = null, G.aid = null, G.platform = Gt.unknown, G.mode = "", G.apiUrl = null;
	}
};
//#endregion
//#region src/utils/validation.ts
function nn(e) {
	return e == null;
}
var rn = class {
	static string(e, t, n, r) {
		return nn(t) ? !1 : r.includes(t) ? t !== n : (U.error(`Attribute ${e} is invalid. Accepted: ${r.join(", ")}.`), !1);
	}
	static number(e, t, n) {
		return nn(t) ? !1 : typeof t != "number" || isNaN(t) ? (U.error(`Attribute ${e} must be a number`), !1) : t !== n;
	}
	static checkRequiredProps(e, t, n) {
		for (let r of n) if (t.has(r) && (!e[`${r}`] || e[`${r}`].length === 0)) {
			let e = `${r} attribute is required.`;
			return U.error(e.charAt(0).toUpperCase() + e.slice(1)), !1;
		}
		return !0;
	}
}, an = /* @__PURE__ */ function(e) {
	return e[e.BUTTON = 0] = "BUTTON", e[e.DYNAMIC = 1] = "DYNAMIC", e[e.GIVING_FORM = 2] = "GIVING_FORM", e[e.SIGNUP_FORM = 3] = "SIGNUP_FORM", e[e.GOAL_BAR = 4] = "GOAL_BAR", e;
}(an || {}), on = bt(((e) => {
	class t extends e {
		constructor(...e) {
			super(...e), this.analytics = K.analytics, this.componentType = null, this.account = W.getAccountId(), this.campaign = "", this.widgetId = "", this.embedUrl = "";
		}
		shouldUpdate(e) {
			let t = this.componentType === 1 || this.componentType === 3 ? ["account", "id"] : ["account", "campaign"];
			return rn.checkRequiredProps(this, e, t);
		}
	}
	return H([V({
		type: String,
		attribute: "account"
	})], t.prototype, "account", void 0), H([V({
		type: String,
		attribute: "campaign"
	})], t.prototype, "campaign", void 0), H([V({
		type: String,
		attribute: "id"
	})], t.prototype, "widgetId", void 0), H([V({
		type: String,
		attribute: "embed-url"
	})], t.prototype, "embedUrl", void 0), t;
})(Te)), sn = class {
	static {
		this._boolean = {
			fromAttribute: (e) => e === "true",
			toAttribute: (e) => e ? "true" : "false"
		};
	}
	static {
		this._booleanUnlessFalse = {
			fromAttribute: (e) => e !== null && e !== "false",
			toAttribute: (e) => e ? "true" : "false"
		};
	}
}, cn = "z-2147483598", ln = /* @__PURE__ */ function(e) {
	return e.LINK = "link", e.MODAL = "modal", e;
}(ln || {}), un = /* @__PURE__ */ function(e) {
	return e.GIFT = "gift", e.GIVING_HANDS = "giving_hands", e.HEART = "heart", e.NONE = "none", e.TICKET = "ticket", e;
}(un || {}), dn = /* @__PURE__ */ function(e) {
	return e.LEFT = "left", e.RIGHT = "right", e;
}(dn || {}), fn = /* @__PURE__ */ function(e) {
	return e.BOTTOM_LEFT = "bottom-left", e.BOTTOM_RIGHT = "bottom-right", e.MIDDLE_LEFT = "middle-left", e.MIDDLE_RIGHT = "middle-right", e.NONE = "", e.TOP_LEFT = "top-left", e.TOP_RIGHT = "top-right", e;
}(fn || {}), q = class extends on {
	constructor() {
		super(), this.isOpen = !1, this._embedUrl = "", this._type = "modal", this._hideButton = !1, this._label = "Donate", this._hideLabel = !1, this._labelColor = "#FFFFFF", this._backgroundColor = "#3366FF", this._icon = "heart", this._iconPosition = "left", this._dropShadow = !0, this._borderRadius = 100, this._borderColor = "", this._borderWidth = 0, this._buttonClass = "", this._position = "", this._verticalOffset = 16, this._horizontalOffset = 16, this._buttonTransformShow = "scale(1)", this._buttonTransformHide = "scale(0)", this._maxWidth = "560px", this.isEventTicketsFlow = !1, this.contentRef = Lt(), this.observer = new Ct(this, {
			config: {
				childList: !0,
				subtree: !0
			},
			target: document.querySelector("[data-overlay-outer-wrapper]"),
			callback: (e) => {
				let t = e[0];
				t && (this.isOpen = t.removedNodes.length <= 0);
			}
		}), this.componentType = an.BUTTON;
	}
	set embedUrl(e) {
		this._embedUrl = e;
	}
	get embedUrl() {
		return this._embedUrl;
	}
	set type(e) {
		rn.string("type", e, this._type, Object.values(ln)) && (this._type = e);
	}
	get type() {
		return this._type;
	}
	set hideButton(e) {
		this._hideButton = e;
	}
	get hideButton() {
		return this._hideButton;
	}
	set label(e) {
		this._label = e;
	}
	get label() {
		return this._label;
	}
	set hideLabel(e) {
		this._hideLabel = e;
	}
	get hideLabel() {
		return this._hideLabel;
	}
	set labelColor(e) {
		this._labelColor = e;
	}
	get labelColor() {
		return this._labelColor;
	}
	set backgroundColor(e) {
		this._backgroundColor = e;
	}
	get backgroundColor() {
		return this._backgroundColor;
	}
	set icon(e) {
		rn.string("icon", e, this._icon, Object.values(un)) && (this._icon = e);
	}
	get icon() {
		return this._icon;
	}
	set iconPosition(e) {
		rn.string("icon-position", e, this._iconPosition, Object.values(dn)) && (this._iconPosition = e);
	}
	get iconPosition() {
		return this._iconPosition;
	}
	set dropShadow(e) {
		this._dropShadow = e;
	}
	get dropShadow() {
		return this._dropShadow;
	}
	set borderRadius(e) {
		rn.number("border-radius", e, this._borderRadius) && (this._borderRadius = e);
	}
	get borderRadius() {
		return this._borderRadius;
	}
	set borderColor(e) {
		this._borderColor = e;
	}
	get borderColor() {
		return this._borderColor;
	}
	set borderWidth(e) {
		rn.number("border-width", e, this._borderWidth) && (this._borderWidth = e);
	}
	get borderWidth() {
		return this._borderWidth;
	}
	set buttonClass(e) {
		this._buttonClass = e;
	}
	get buttonClass() {
		return this._buttonClass;
	}
	set position(e) {
		rn.string("position", e, this._position, Object.values(fn)) && (this._position = e);
	}
	get position() {
		return this._position;
	}
	set verticalOffset(e) {
		rn.number("vertical-offset", e, this._verticalOffset) && (this._verticalOffset = e);
	}
	get verticalOffset() {
		return this._verticalOffset;
	}
	set horizontalOffset(e) {
		rn.number("horizontal-offset", e, this._horizontalOffset) && (this._horizontalOffset = e);
	}
	get horizontalOffset() {
		return this._horizontalOffset;
	}
	set buttonTransformShow(e) {
		this._buttonTransformShow = e;
	}
	get buttonTransformShow() {
		return this._buttonTransformShow;
	}
	set buttonTransformHide(e) {
		this._buttonTransformHide = e;
	}
	get buttonTransformHide() {
		return this._buttonTransformHide;
	}
	set maxWidth(e) {
		this._maxWidth = e;
	}
	get maxWidth() {
		return this._maxWidth;
	}
	firstUpdated() {
		this.contentRef.value && this.observer.observe(this.contentRef.value);
	}
	render() {
		let e = `${this.getDropShadowClass()} ${this.buttonClass} w-fit transition transform hover:scale-105 flex h-4 min-w-12 cursor-pointer items-center justify-center gap-1.5 bg-transparent px-4 py-6 font-sans text-base font-semibold`;
		if (this.type === "link") {
			let t = "?source=widgets";
			return this.widgetId.length > 0 && (t += `&gba_gb.element.id=${this.widgetId}`), F`
        <div
          class="${cn} ${this.getPosition()}"
          style=${Ut(this.getPositionStyles())}
        >
          <a
            href="${K.apiUrl}/c/${this.campaign}${t}"
            slot="trigger"
            data-testID="givebutter-button"
            class="${e}"
            aria-label="${this.label}"
            style=${Ut(this.getButtonStyles())}
          >
            ${this.renderLabel()}
          </a>
        </div>
      `;
		}
		return F`
      <givebutter-dialog>
        <button
          slot="invoker"
          data-testID="givebutter-button"
          class="${e} ${cn} ${this.getPosition()}"
          role="button"
          aria-label="${this.label}"
          style=${Ut({
			...this.getButtonStyles(),
			...this.getPositionStyles()
		})}
        >
          ${this.renderLabel()}
        </button>
        <div ${Bt(this.contentRef)} slot="content" role="dialog" aria-label="Campaign donation">
          ${this.isOpen ? F`<givebutter-giving-form
                  id="${this.widgetId}"
                  max-width="${this.maxWidth}"
                  account="${this.account}"
                  campaign="${this.campaign}"
                  embed-url="${wt(this.getEmbedUrl())}"
                  .isEventTicketsFlow="${this.isEventTicketsFlow}"
                  closable
                ></givebutter-giving-form> ` : ""}
        </div>
      </givebutter-dialog>
    `;
	}
	renderLabel() {
		return this.iconPosition === "left" ? F`${this.showIcon()} ${this.showLabel()}` : F`${this.showLabel()} ${this.showIcon()}`;
	}
	getButtonStyles() {
		return this.hideButton ? {
			display: "none",
			pointerEvents: "none"
		} : {
			color: this.labelColor,
			backgroundColor: this.backgroundColor,
			borderColor: this.borderColor,
			borderRadius: `${this.borderRadius}px`,
			borderWidth: `${this.borderWidth}px`
		};
	}
	showLabel() {
		return this.hideLabel || this.label.length === 0 ? "" : F`<span class="overflow-visible whitespace-nowrap transition-all duration-300"
          >${this.label}</span
        >`;
	}
	showIcon() {
		return new Wt(this.icon, this.labelColor).getSVG();
	}
	getDropShadowClass() {
		return this.dropShadow ? "drop-shadow-md" : "";
	}
	getPosition() {
		let e = this.position, t = [];
		e.length > 0 && t.push("fixed");
		let [n] = e.toLowerCase().split("-");
		return n === "middle" && (t.push("top-1/2"), t.push("translate-x-0"), t.push("-translate-y-1/2")), t.join(" ");
	}
	getPositionStyles() {
		let [e, t] = this.position.toLowerCase().split("-"), n = {};
		return e === "top" && (n.top = `${this.verticalOffset}px`), e === "bottom" && (n.bottom = `${this.verticalOffset}px`), t === "left" && (n.left = `${this.horizontalOffset}px`), t === "right" && (n.right = `${this.horizontalOffset}px`), n;
	}
	getEmbedUrl() {
		return this.embedUrl.length > 0 ? this.embedUrl : void 0;
	}
};
H([vt()], q.prototype, "isOpen", void 0), H([V({
	type: String,
	attribute: "embed-url"
})], q.prototype, "embedUrl", null), H([V({
	type: String,
	attribute: "type"
})], q.prototype, "type", null), H([V({
	type: Boolean,
	attribute: "hide-button"
})], q.prototype, "hideButton", null), H([V({
	type: String,
	attribute: "label"
})], q.prototype, "label", null), H([V({
	type: Boolean,
	attribute: "hide-label",
	converter: sn._booleanUnlessFalse
})], q.prototype, "hideLabel", null), H([V({
	type: String,
	attribute: "label-color"
})], q.prototype, "labelColor", null), H([V({
	type: String,
	attribute: "background-color"
})], q.prototype, "backgroundColor", null), H([V({
	type: String,
	attribute: "icon"
})], q.prototype, "icon", null), H([V({
	type: String,
	attribute: "icon-position"
})], q.prototype, "iconPosition", null), H([V({
	type: Boolean,
	attribute: "drop-shadow",
	converter: sn._boolean
})], q.prototype, "dropShadow", null), H([V({
	type: Number,
	attribute: "border-radius"
})], q.prototype, "borderRadius", null), H([V({
	type: String,
	attribute: "border-color"
})], q.prototype, "borderColor", null), H([V({
	type: Number,
	attribute: "border-width"
})], q.prototype, "borderWidth", null), H([V({
	type: String,
	attribute: "button-class"
})], q.prototype, "buttonClass", null), H([V({
	type: String,
	attribute: "position"
})], q.prototype, "position", null), H([V({
	type: Number,
	attribute: "vertical-offset"
})], q.prototype, "verticalOffset", null), H([V({
	type: Number,
	attribute: "horizontal-offset"
})], q.prototype, "horizontalOffset", null), H([V({
	type: String,
	attribute: "button-transform-show"
})], q.prototype, "buttonTransformShow", null), H([V({
	type: String,
	attribute: "button-transform-hide"
})], q.prototype, "buttonTransformHide", null), H([V({
	type: String,
	attribute: "max-width"
})], q.prototype, "maxWidth", null), H([V({ type: Boolean })], q.prototype, "isEventTicketsFlow", void 0), q = H([ht("givebutter-button")], q);
//#endregion
//#region ../../node_modules/.pnpm/iframe-resizer@4.4.5/node_modules/iframe-resizer/js/iframeResizer.js
var pn = /* @__PURE__ */ e(((e, t) => {
	console.info("\nIFRAME-RESIZER\n\nIframe-Resizer 5 is now available via the following two packages:\n\n * @iframe-resizer/parent\n * @iframe-resizer/child\n\nAdditionally their are also new versions of iframe-resizer for React, Vue, and jQuery.\n\nVersion 5 of iframe-resizer has been extensively rewritten to use modern browser APIs, which has enabled significantly better performance and greater accuracy in the detection of content resizing events.\n\nPlease see https://iframe-resizer.com/upgrade for more details.\n"), (function(e) {
		if (typeof window > "u") return;
		var n = 0, r, i = !1, a = !1, o = 7, s = "[iFrameSizer]", c = s.length, l = null, u = window.requestAnimationFrame, d = Object.freeze({
			max: 1,
			scroll: 1,
			bodyScroll: 1,
			documentElementScroll: 1
		}), f = {}, p = null, m = Object.freeze({
			autoResize: !0,
			bodyBackground: null,
			bodyMargin: null,
			bodyMarginV1: 8,
			bodyPadding: null,
			checkOrigin: !0,
			inPageLinks: !1,
			enablePublicMethods: !0,
			heightCalculationMethod: "bodyOffset",
			id: "iFrameResizer",
			interval: 32,
			license: "1jqr0si6pnt",
			log: !1,
			maxHeight: Infinity,
			maxWidth: Infinity,
			minHeight: 0,
			minWidth: 0,
			mouseEvents: !0,
			resizeFrom: "parent",
			scrolling: !1,
			sizeHeight: !0,
			sizeWidth: !1,
			warningTimeout: 5e3,
			tolerance: 0,
			widthCalculationMethod: "scroll",
			onClose: function() {
				return !0;
			},
			onClosed: function() {},
			onInit: function() {},
			onMessage: function() {
				x("onMessage function not defined");
			},
			onMouseEnter: function() {},
			onMouseLeave: function() {},
			onResized: function() {},
			onScroll: function() {
				return !0;
			}
		});
		function h() {
			return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
		}
		function g(e, t, n) {
			e.addEventListener(t, n, !1);
		}
		function ee(e, t, n) {
			e.removeEventListener(t, n, !1);
		}
		function te() {
			var e = [
				"moz",
				"webkit",
				"o",
				"ms"
			], t;
			for (t = 0; t < e.length && !u; t += 1) u = window[e[t] + "RequestAnimationFrame"];
			u ? u = u.bind(window) : b("setup", "RequestAnimationFrame not supported");
		}
		function _(e) {
			var t = "Host page: " + e;
			return window.top !== window.self && (t = window.parentIFrame && window.parentIFrame.getId ? window.parentIFrame.getId() + ": " + e : "Nested host page: " + e), t;
		}
		function v(e) {
			return s + "[" + _(e) + "]";
		}
		function y(e) {
			return f[e] ? f[e].log : i;
		}
		function b(e, t) {
			S("log", e, t, y(e));
		}
		function ne(e, t) {
			S("info", e, t, y(e));
		}
		function x(e, t) {
			S("warn", e, t, !0);
		}
		function S(e, t, n, r) {
			!0 === r && typeof window.console == "object" && console[e](v(t), n);
		}
		function re(e) {
			function t() {
				function e() {
					O(L), T(R), M("onResized", L);
				}
				a("Height"), a("Width"), k(e, L, "init");
			}
			function n() {
				var e = I.slice(c).split(":"), t = e[1] ? parseInt(e[1], 10) : 0, n = f[e[0]] && f[e[0]].iframe, a = getComputedStyle(n);
				return {
					iframe: n,
					id: e[0],
					height: t + r(a) + i(a),
					width: e[2],
					type: e[3]
				};
			}
			function r(e) {
				return e.boxSizing === "border-box" ? (e.paddingTop ? parseInt(e.paddingTop, 10) : 0) + (e.paddingBottom ? parseInt(e.paddingBottom, 10) : 0) : 0;
			}
			function i(e) {
				return e.boxSizing === "border-box" ? (e.borderTopWidth ? parseInt(e.borderTopWidth, 10) : 0) + (e.borderBottomWidth ? parseInt(e.borderBottomWidth, 10) : 0) : 0;
			}
			function a(e) {
				var t = Number(f[R]["max" + e]), n = Number(f[R]["min" + e]), r = e.toLowerCase(), i = Number(L[r]);
				b(R, "Checking " + r + " is in range " + n + "-" + t), i < n && (i = n, b(R, "Set " + r + " to min value")), i > t && (i = t, b(R, "Set " + r + " to max value")), L[r] = "" + i;
			}
			function u() {
				function t() {
					function e() {
						var e = 0, t = !1;
						for (b(R, "Checking connection is from allowed list of origins: " + r); e < r.length; e++) if (r[e] === n) {
							t = !0;
							break;
						}
						return t;
					}
					function t() {
						var e = f[R] && f[R].remoteHost;
						return b(R, "Checking connection is from: " + e), n === e;
					}
					return r.constructor === Array ? e() : t();
				}
				var n = e.origin, r = f[R] && f[R].checkOrigin;
				if (r && "" + n != "null" && !t()) throw Error("Unexpected message received from: " + n + " for " + L.iframe.id + ". Message was: " + e.data + ". This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.");
				return !0;
			}
			function d() {
				return s === ("" + I).slice(0, c) && I.slice(c).split(":")[0] in f;
			}
			function p() {
				var e = L.type in {
					true: 1,
					false: 1,
					undefined: 1
				};
				return e && b(R, "Ignoring init message from meta parent page"), e;
			}
			function m(e) {
				return I.slice(I.indexOf(":") + o + e);
			}
			function h(e) {
				b(R, "onMessage passed: {iframe: " + L.iframe.id + ", message: " + e + "}"), M("onMessage", {
					iframe: L.iframe,
					message: JSON.parse(e)
				}), b(R, "--");
			}
			function te() {
				var e = document.body.getBoundingClientRect(), t = L.iframe.getBoundingClientRect();
				return JSON.stringify({
					iframeHeight: t.height,
					iframeWidth: t.width,
					clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
					clientWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
					offsetTop: parseInt(t.top - e.top, 10),
					offsetLeft: parseInt(t.left - e.left, 10),
					scrollTop: window.pageYOffset,
					scrollLeft: window.pageXOffset,
					documentHeight: document.documentElement.clientHeight,
					documentWidth: document.documentElement.clientWidth,
					windowHeight: window.innerHeight,
					windowWidth: window.innerWidth
				});
			}
			function _(e, t) {
				function n() {
					A("Send Page Info", "pageInfo:" + te(), e, t);
				}
				N(n, 32, t);
			}
			function v() {
				function e(e, n) {
					function i() {
						f[r] ? _(f[r].iframe, r) : t();
					}
					["scroll", "resize"].forEach(function(t) {
						b(r, e + t + " listener for sendPageInfo"), n(window, t, i);
					});
				}
				function t() {
					e("Remove ", ee);
				}
				function n() {
					e("Add ", g);
				}
				var r = R;
				n(), f[r] && (f[r].stopPageInfo = t);
			}
			function y() {
				f[R] && f[R].stopPageInfo && (f[R].stopPageInfo(), delete f[R].stopPageInfo);
			}
			function S() {
				var e = !0;
				return L.iframe === null && (x(R, "IFrame (" + L.id + ") not found"), e = !1), e;
			}
			function re(e) {
				var t = e.getBoundingClientRect();
				return w(R), {
					x: Math.floor(Number(t.left) + Number(l.x)),
					y: Math.floor(Number(t.top) + Number(l.y))
				};
			}
			function ie(e) {
				/* istanbul ignore next */ function t() {
					l = a, oe(), b(R, "--");
				}
				function n() {
					return {
						x: Number(L.width) + i.x,
						y: Number(L.height) + i.y
					};
				}
				function r() {
					window.parentIFrame ? window.parentIFrame["scrollTo" + (e ? "Offset" : "")](a.x, a.y) : x(R, "Unable to scroll to requested position, window.parentIFrame not found");
				}
				var i = e ? re(L.iframe) : {
					x: 0,
					y: 0
				}, a = n();
				b(R, "Reposition requested from iFrame (offset x:" + i.x + " y:" + i.y + ")"), window.top === window.self ? t() : r();
			}
			function oe() {
				!1 === M("onScroll", l) ? E() : T(R);
			}
			function se(e) {
				function t() {
					var e = re(a);
					b(R, "Moving to in page link (#" + r + ") at x: " + e.x + " y: " + e.y), l = {
						x: e.x,
						y: e.y
					}, oe(), b(R, "--");
				}
				function n() {
					window.parentIFrame ? window.parentIFrame.moveToAnchor(r) : b(R, "In page link #" + r + " not found and window.parentIFrame not found");
				}
				var r = e.split("#")[1] || "", i = decodeURIComponent(r), a = document.getElementById(i) || document.getElementsByName(i)[0];
				a ? t() : window.top === window.self ? b(R, "In page link #" + r + " not found") : n();
			}
			function ce(e) {
				var t = {};
				if (Number(L.width) === 0 && Number(L.height) === 0) {
					var n = m(9).split(":");
					t = {
						x: n[1],
						y: n[0]
					};
				} else t = {
					x: L.width,
					y: L.height
				};
				M(e, {
					iframe: L.iframe,
					screenX: Number(t.x),
					screenY: Number(t.y),
					type: L.type
				});
			}
			function M(e, t) {
				return C(R, e, t);
			}
			function le() {
				switch (f[R] && f[R].firstRun && F(), L.type) {
					case "close":
						ae(L.iframe);
						break;
					case "message":
						h(m(6));
						break;
					case "mouseenter":
						ce("onMouseEnter");
						break;
					case "mouseleave":
						ce("onMouseLeave");
						break;
					case "autoResize":
						f[R].autoResize = JSON.parse(m(9));
						break;
					case "scrollTo":
						ie(!1);
						break;
					case "scrollToOffset":
						ie(!0);
						break;
					case "pageInfo":
						_(f[R] && f[R].iframe, R), v();
						break;
					case "pageInfoStop":
						y();
						break;
					case "inPageLink":
						se(m(9));
						break;
					case "reset":
						D(L);
						break;
					case "init":
						t(), M("onInit", L.iframe);
						break;
					default: Number(L.width) === 0 && Number(L.height) === 0 ? x("Unsupported message received (" + L.type + "), this is likely due to the iframe containing a later version of iframe-resizer than the parent page") : t();
				}
			}
			function ue(e) {
				var t = !0;
				return f[e] || (t = !1, x(L.type + " No settings for " + e + ". Message was: " + I)), t;
			}
			function P() {
				for (var e in f) A("iFrame requested init", j(e), f[e].iframe, e);
			}
			function F() {
				f[R] && (f[R].firstRun = !1);
			}
			var I = e.data, L = {}, R = null;
			I === "[iFrameResizerChild]Ready" ? P() : d() ? (L = n(), R = L.id, f[R] && (f[R].loaded = !0), !p() && ue(R) && (b(R, "Received: " + I), S() && u() && le())) : ne(R, "Ignored: " + I);
		}
		function C(e, t, n) {
			var r = null, i = null;
			if (f[e]) if (r = f[e][t], typeof r == "function") i = r(n);
			else throw TypeError(t + " on iFrame[" + e + "] is not a function");
			return i;
		}
		function ie(e) {
			var t = e.id;
			delete f[t];
		}
		function ae(e) {
			var t = e.id;
			if (C(t, "onClose", t) === !1) {
				b(t, "Close iframe cancelled by onClose event");
				return;
			}
			b(t, "Removing iFrame: " + t);
			try {
				e.parentNode && e.parentNode.removeChild(e);
			} catch (e) {
				x(e);
			}
			C(t, "onClosed", t), b(t, "--"), ie(e), r &&= (r.disconnect(), null);
		}
		function w(t) {
			l === null && (l = {
				x: window.pageXOffset === e ? document.documentElement.scrollLeft : window.pageXOffset,
				y: window.pageYOffset === e ? document.documentElement.scrollTop : window.pageYOffset
			}, b(t, "Get page position: " + l.x + "," + l.y));
		}
		function T(e) {
			l !== null && (window.scrollTo(l.x, l.y), b(e, "Set page position: " + l.x + "," + l.y), E());
		}
		function E() {
			l = null;
		}
		function D(e) {
			function t() {
				O(e), A("reset", "reset", e.iframe, e.id);
			}
			b(e.id, "Size reset requested by " + (e.type === "init" ? "host page" : "iFrame")), w(e.id), k(t, e, "reset");
		}
		function O(e) {
			function t(t) {
				if (!e.id) {
					b("undefined", "messageData id not set");
					return;
				}
				e.iframe.style[t] = e[t] + "px", b(e.id, "IFrame (" + i + ") " + t + " set to " + e[t] + "px");
			}
			function n(t) {
				/* istanbul ignore next */ !a && e[t] === "0" && (a = !0, b(i, "Hidden iFrame detected, creating visibility listener"), le());
			}
			function r(e) {
				t(e), n(e);
			}
			var i = e.iframe.id;
			f[i] && (f[i].sizeHeight && r("height"), f[i].sizeWidth && r("width"));
		}
		function k(e, t, n) {
			/* istanbul ignore if */ n !== t.type && u && !window.jasmine ? (b(t.id, "Requesting animation frame"), u(e)) : e();
		}
		function A(e, t, n, r, i) {
			function a() {
				var i = f[r] && f[r].targetOrigin;
				b(r, "[" + e + "] Sending msg to iframe[" + r + "] (" + t + ") targetOrigin: " + i), n.contentWindow.postMessage(s + t, i);
			}
			function o() {
				x(r, "[" + e + "] IFrame(" + r + ") not found");
			}
			function c() {
				n && "contentWindow" in n && n.contentWindow !== null ? a() : o();
			}
			function l() {
				function e() {
					f[r] && !f[r].loaded && !u && (u = !0, x(r, "IFrame has not responded within " + f[r].warningTimeout / 1e3 + " seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning."));
				}
				i && f[r] && f[r].warningTimeout && (f[r].msgTimeout = setTimeout(e, f[r].warningTimeout));
			}
			var u = !1;
			r ||= n.id, f[r] && (c(), l());
		}
		function j(e) {
			return e + ":" + f[e].bodyMarginV1 + ":" + f[e].sizeWidth + ":" + f[e].log + ":" + f[e].interval + ":" + f[e].enablePublicMethods + ":" + f[e].autoResize + ":" + f[e].bodyMargin + ":" + f[e].heightCalculationMethod + ":" + f[e].bodyBackground + ":" + f[e].bodyPadding + ":" + f[e].tolerance + ":" + f[e].inPageLinks + ":" + f[e].resizeFrom + ":" + f[e].widthCalculationMethod + ":" + f[e].mouseEvents;
		}
		function oe(e) {
			return typeof e == "number";
		}
		function se(t, a) {
			function o() {
				function e(e) {
					var n = f[C][e];
					n !== Infinity && n !== 0 && (t.style[e] = oe(n) ? n + "px" : n, b(C, "Set " + e + " = " + t.style[e]));
				}
				function n(e) {
					if (f[C]["min" + e] > f[C]["max" + e]) throw Error("Value for min" + e + " can not be greater than max" + e);
				}
				n("Height"), n("Width"), e("maxHeight"), e("minHeight"), e("maxWidth"), e("minWidth");
			}
			function s() {
				var e = a && a.id || m.id + n++;
				return document.getElementById(e) !== null && (e += n++), e;
			}
			function c(e) {
				if (typeof e != "string") throw TypeError("Invaild id for iFrame. Expected String");
				return e === "" && (t.id = e = s(), i = (a || {}).log, b(e, "Added missing iframe ID: " + e + " (" + t.src + ")")), e;
			}
			function l() {
				switch (b(C, "IFrame scrolling " + (f[C] && f[C].scrolling ? "enabled" : "disabled") + " for " + C), t.style.overflow = !1 === (f[C] && f[C].scrolling) ? "hidden" : "auto", f[C] && f[C].scrolling) {
					case "omit": break;
					case !0:
						t.scrolling = "yes";
						break;
					case !1:
						t.scrolling = "no";
						break;
					default: t.scrolling = f[C] ? f[C].scrolling : "no";
				}
			}
			function u() {
				(typeof (f[C] && f[C].bodyMargin) == "number" || (f[C] && f[C].bodyMargin) === "0") && (f[C].bodyMarginV1 = f[C].bodyMargin, f[C].bodyMargin = "" + f[C].bodyMargin + "px");
			}
			function p() {
				var e = f[C] && f[C].firstRun, n = f[C] && f[C].heightCalculationMethod in d;
				!e && n && D({
					iframe: t,
					height: 0,
					width: 0,
					type: "init"
				});
			}
			function ee() {
				f[C] && (f[C].iframe.iFrameResizer = {
					close: ae.bind(null, f[C].iframe),
					removeListeners: ie.bind(null, f[C].iframe),
					resize: A.bind(null, "Window resize", "resize", f[C].iframe),
					moveToAnchor: function(e) {
						A("Move to anchor", "moveToAnchor:" + e, f[C].iframe, C);
					},
					sendMessage: function(e) {
						e = JSON.stringify(e), A("Send Message", "message:" + e, f[C].iframe, C);
					}
				});
			}
			function te(n) {
				function i() {
					A("iFrame.onload", n, t, e, !0), p();
				}
				function a(e) {
					if (!t.parentNode) return null;
					var n = new e(function(e) {
						e.forEach(function(e) {
							Array.prototype.slice.call(e.removedNodes).forEach(function(e) {
								e === t && ae(t);
							});
						});
					});
					return n.observe(t.parentNode, { childList: !0 }), n;
				}
				var o = h();
				o && (r = a(o)), g(t, "load", i), A("init", n, t, e, !0);
			}
			function _(e) {
				if (typeof e != "object") throw TypeError("Options is not an object");
			}
			function v(e) {
				for (var t in m) Object.prototype.hasOwnProperty.call(m, t) && (f[C][t] = Object.prototype.hasOwnProperty.call(e, t) ? e[t] : m[t]);
			}
			function y(e) {
				return e === "" || e.match(/^(about:blank|javascript:|file:\/\/)/) !== null ? "*" : e;
			}
			function ne(e) {
				var t = e.split("Callback");
				if (t.length === 2) {
					var n = "on" + t[0].charAt(0).toUpperCase() + t[0].slice(1);
					this[n] = this[e], delete this[e], x(C, "Deprecated: '" + e + "' has been renamed '" + n + "'. The old method will be removed in the next major version.");
				}
			}
			function S(e) {
				e ||= {}, f[C] = Object.create(null), f[C].iframe = t, f[C].firstRun = !0, f[C].remoteHost = t.src && t.src.split("/").slice(0, 3).join("/"), _(e), Object.keys(e).forEach(ne, e), v(e), f[C] && (f[C].targetOrigin = !0 === f[C].checkOrigin ? y(f[C].remoteHost) : "*");
			}
			function re() {
				return C in f && "iFrameResizer" in t;
			}
			var C = c(t.id);
			re() ? x(C, "Ignored iFrame, already setup.") : (S(a), l(), o(), u(), te(j(C)), ee());
		}
		function ce(e, t) {
			p === null && (p = setTimeout(function() {
				p = null, e();
			}, t));
		}
		var M = {};
		function N(e, t, n) {
			M[n] || (M[n] = setTimeout(function() {
				M[n] = null, e();
			}, t));
		}
		/* istanbul ignore next */
		function le() {
			function e() {
				function e(e) {
					function t(t) {
						return (f[e] && f[e].iframe.style[t]) === "0px";
					}
					function n(e) {
						return e.offsetParent !== null;
					}
					f[e] && n(f[e].iframe) && (t("height") || t("width")) && A("Visibility change", "resize", f[e].iframe, e);
				}
				Object.keys(f).forEach(function(t) {
					e(t);
				});
			}
			function t(t) {
				b("window", "Mutation observed: " + t[0].target + " " + t[0].type), ce(e, 16);
			}
			function n() {
				var e = document.querySelector("body");
				new r(t).observe(e, {
					attributes: !0,
					attributeOldValue: !1,
					characterData: !0,
					characterDataOldValue: !1,
					childList: !0,
					subtree: !0
				});
			}
			var r = h();
			r && n();
		}
		function ue(e) {
			function t() {
				F("Window " + e, "resize");
			}
			b("window", "Trigger event: " + e), ce(t, 16);
		}
		/* istanbul ignore next */
		function P() {
			function e() {
				F("Tab Visible", "resize");
			}
			document.visibilityState !== "hidden" && (b("document", "Trigger event: Visibility change"), ce(e, 16));
		}
		function F(e, t) {
			function n(e) {
				return f[e] && f[e].resizeFrom === "parent" && f[e].autoResize && !f[e].firstRun;
			}
			Object.keys(f).forEach(function(r) {
				n(r) && A(e, t, f[r].iframe, r);
			});
		}
		function I() {
			g(window, "message", re), g(window, "resize", function() {
				ue("resize");
			}), g(document, "visibilitychange", P), g(document, "-webkit-visibilitychange", P);
		}
		function L() {
			function t(e, t) {
				function n() {
					if (!t.tagName) throw TypeError("Object is not a valid DOM element");
					if (t.tagName.toUpperCase() !== "IFRAME") throw TypeError("Expected <IFRAME> tag, found <" + t.tagName + ">");
				}
				t && (n(), se(t, e), r.push(t));
			}
			function n(e) {
				e && e.enablePublicMethods && x("enablePublicMethods option has been removed, public methods are now always available in the iFrame");
			}
			var r;
			return te(), I(), function(i, a) {
				switch (r = [], n(i), typeof a) {
					case "undefined":
					case "string":
						Array.prototype.forEach.call(document.querySelectorAll(a || "iframe"), t.bind(e, i));
						break;
					case "object":
						t(i, a);
						break;
					default: throw TypeError("Unexpected data type (" + typeof a + ")");
				}
				return r;
			};
		}
		function R(e) {
			e.fn ? e.fn.iFrameResize || (e.fn.iFrameResize = function(e) {
				function t(t, n) {
					se(n, e);
				}
				return this.filter("iframe").each(t).end();
			}) : ne("", "Unable to bind to jQuery, it is not fully loaded.");
		}
		window.jQuery !== e && R(window.jQuery), typeof define == "function" && define.amd ? define([], L) : typeof t == "object" && typeof t.exports == "object" && (t.exports = L()), window.iFrameResize = window.iFrameResize || L();
	})();
})), mn = /* @__PURE__ */ e(((e, t) => {
	(function(e) {
		if (typeof window > "u") return;
		var n = !0, r = 10, i = "", a = 0, o = "", s = null, c = "", l = !1, u = {
			resize: 1,
			click: 1
		}, d = 128, f = !0, p = 1, m = "bodyOffset", h = m, g = !0, ee = "", te = {}, _ = 32, v = null, y = !1, b = !1, ne = "[iFrameSizer]", x = ne.length, S = "", re = {
			max: 1,
			min: 1,
			bodyScroll: 1,
			documentElementScroll: 1
		}, C = "child", ie = !0, ae = window.parent, w = "*", T = 0, E = !1, D = null, O = 16, k = 1, A = "scroll", j = A, oe = window, se = function() {
			pe("onMessage function not defined");
		}, ce = function() {}, M = function() {}, N = {
			height: function() {
				return pe("Custom height calculation function not defined"), document.documentElement.offsetHeight;
			},
			width: function() {
				return pe("Custom width calculation function not defined"), document.body.scrollWidth;
			}
		}, le = {}, ue = !1;
		function P() {}
		try {
			var F = Object.create({}, { passive: { get: function() {
				ue = !0;
			} } });
			window.addEventListener("test", P, F), window.removeEventListener("test", P, F);
		} catch {}
		function I(e, t, n, r) {
			e.addEventListener(t, n, ue ? r || {} : !1);
		}
		function L(e, t, n) {
			e.removeEventListener(t, n, !1);
		}
		function R(e) {
			return e.charAt(0).toUpperCase() + e.slice(1);
		}
		function de(e) {
			var t, n, r, i = null, a = 0, o = function() {
				a = Date.now(), i = null, r = e.apply(t, n), i || (t = n = null);
			};
			return function() {
				var s = Date.now();
				a ||= s;
				var c = O - (s - a);
				return t = this, n = arguments, c <= 0 || c > O ? (i &&= (clearTimeout(i), null), a = s, r = e.apply(t, n), i || (t = n = null)) : i ||= setTimeout(o, c), r;
			};
		}
		function fe(e) {
			return ne + "[" + S + "] " + e;
		}
		function z(e) {
			y && typeof window.console == "object" && console.log(fe(e));
		}
		function pe(e) {
			typeof window.console == "object" && console.warn(fe(e));
		}
		function me() {
			he(), z("Initialising iFrame (" + window.location.href + ")"), _e(), be(), ye("background", i), ye("padding", c), ke(), we(), Te(), xe(), Me(), je(), Ee(), te = Ae(), Ke("init", "Init message from host page"), ce();
		}
		function he() {
			function t(e) {
				return e === "true";
			}
			var r = ee.slice(x).split(":");
			S = r[0], a = e === r[1] ? a : Number(r[1]), l = e === r[2] ? l : t(r[2]), y = e === r[3] ? y : t(r[3]), _ = e === r[4] ? _ : Number(r[4]), n = e === r[6] ? n : t(r[6]), o = r[7], h = e === r[8] ? h : r[8], i = r[9], c = r[10], T = e === r[11] ? T : Number(r[11]), te.enable = e === r[12] ? !1 : t(r[12]), C = e === r[13] ? C : r[13], j = e === r[14] ? j : r[14], b = e === r[15] ? b : t(r[15]);
		}
		function ge(e) {
			var t = e.split("Callback");
			if (t.length === 2) {
				var n = "on" + t[0].charAt(0).toUpperCase() + t[0].slice(1);
				this[n] = this[e], delete this[e], pe("Deprecated: '" + e + "' has been renamed '" + n + "'. The old method will be removed in the next major version.");
			}
		}
		function _e() {
			function e() {
				var e = window.iFrameResizer;
				z("Reading data from page: " + JSON.stringify(e)), Object.keys(e).forEach(ge, e), se = "onMessage" in e ? e.onMessage : se, ce = "onReady" in e ? e.onReady : ce, w = "targetOrigin" in e ? e.targetOrigin : w, h = "heightCalculationMethod" in e ? e.heightCalculationMethod : h, j = "widthCalculationMethod" in e ? e.widthCalculationMethod : j;
			}
			function t(e, t) {
				return typeof e == "function" && (z("Setup custom " + t + "CalcMethod"), N[t] = e, e = "custom"), e;
			}
			"iFrameResizer" in window && Object === window.iFrameResizer.constructor && (e(), h = t(h, "height"), j = t(j, "width")), z("TargetOrigin for parent set to: " + w);
		}
		function ve(e, t) {
			return t.indexOf("-") !== -1 && (pe("Negative CSS value ignored for " + e), t = ""), t;
		}
		function ye(t, n) {
			e !== n && n !== "" && n !== "null" && (document.body.style[t] = n, z("Body " + t + " set to \"" + n + "\""));
		}
		function be() {
			e === o && (o = a + "px"), ye("margin", ve("margin", o));
		}
		function xe() {
			document.documentElement.style.height = "", document.body.style.height = "", z("HTML & body height set to \"auto\"");
		}
		function B(e) {
			var t = {
				add: function(t) {
					function n() {
						Ke(e.eventName, e.eventType);
					}
					le[t] = n, I(window, t, n, { passive: !0 });
				},
				remove: function(e) {
					var t = le[e];
					delete le[e], L(window, e, t);
				}
			};
			e.eventNames && Array.prototype.map ? (e.eventName = e.eventNames[0], e.eventNames.map(t[e.method])) : t[e.method](e.eventName), z(R(e.method) + " event listener: " + e.eventType);
		}
		function Se(e) {
			B({
				method: e,
				eventType: "Animation Start",
				eventNames: ["animationstart", "webkitAnimationStart"]
			}), B({
				method: e,
				eventType: "Animation Iteration",
				eventNames: ["animationiteration", "webkitAnimationIteration"]
			}), B({
				method: e,
				eventType: "Animation End",
				eventNames: ["animationend", "webkitAnimationEnd"]
			}), B({
				method: e,
				eventType: "Input",
				eventName: "input"
			}), B({
				method: e,
				eventType: "Mouse Up",
				eventName: "mouseup"
			}), B({
				method: e,
				eventType: "Mouse Down",
				eventName: "mousedown"
			}), B({
				method: e,
				eventType: "Orientation Change",
				eventName: "orientationchange"
			}), B({
				method: e,
				eventType: "Print",
				eventNames: ["afterprint", "beforeprint"]
			}), B({
				method: e,
				eventType: "Ready State Change",
				eventName: "readystatechange"
			}), B({
				method: e,
				eventType: "Touch Start",
				eventName: "touchstart"
			}), B({
				method: e,
				eventType: "Touch End",
				eventName: "touchend"
			}), B({
				method: e,
				eventType: "Touch Cancel",
				eventName: "touchcancel"
			}), B({
				method: e,
				eventType: "Transition Start",
				eventNames: [
					"transitionstart",
					"webkitTransitionStart",
					"MSTransitionStart",
					"oTransitionStart",
					"otransitionstart"
				]
			}), B({
				method: e,
				eventType: "Transition Iteration",
				eventNames: [
					"transitioniteration",
					"webkitTransitionIteration",
					"MSTransitionIteration",
					"oTransitionIteration",
					"otransitioniteration"
				]
			}), B({
				method: e,
				eventType: "Transition End",
				eventNames: [
					"transitionend",
					"webkitTransitionEnd",
					"MSTransitionEnd",
					"oTransitionEnd",
					"otransitionend"
				]
			}), C === "child" && B({
				method: e,
				eventType: "IFrame Resized",
				eventName: "resize"
			});
		}
		function Ce(e, t, n, r) {
			return t !== e && (e in n || (pe(e + " is not a valid option for " + r + "CalculationMethod."), e = t), z(r + " calculation method set to \"" + e + "\"")), e;
		}
		function we() {
			h = Ce(h, m, He, "height");
		}
		function Te() {
			j = Ce(j, A, Ue, "width");
		}
		function Ee() {
			!0 === n ? (Se("add"), Fe()) : z("Auto Resize disabled");
		}
		function De() {
			s !== null && s.disconnect();
		}
		function Oe() {
			Se("remove"), De(), clearInterval(v);
		}
		function ke() {
			var e = document.createElement("div");
			e.style.clear = "both", e.style.display = "block", e.style.height = "0", document.body.appendChild(e);
		}
		function Ae() {
			function t() {
				return {
					x: window.pageXOffset === e ? document.documentElement.scrollLeft : window.pageXOffset,
					y: window.pageYOffset === e ? document.documentElement.scrollTop : window.pageYOffset
				};
			}
			function n(e) {
				var n = e.getBoundingClientRect(), r = t();
				return {
					x: parseInt(n.left, 10) + parseInt(r.x, 10),
					y: parseInt(n.top, 10) + parseInt(r.y, 10)
				};
			}
			function r(t) {
				function r(e) {
					var t = n(e);
					z("Moving to in page link (#" + i + ") at x: " + t.x + " y: " + t.y), Xe(t.y, t.x, "scrollToOffset");
				}
				var i = t.split("#")[1] || t, a = decodeURIComponent(i), o = document.getElementById(a) || document.getElementsByName(a)[0];
				e === o ? (z("In page link (#" + i + ") not found in iFrame, so sending to parent"), Xe(0, 0, "inPageLink", "#" + i)) : r(o);
			}
			function i() {
				var e = window.location.hash, t = window.location.href;
				e !== "" && e !== "#" && r(t);
			}
			function a() {
				function e(e) {
					function t(e) {
						e.preventDefault(), r(this.getAttribute("href"));
					}
					e.getAttribute("href") !== "#" && I(e, "click", t);
				}
				Array.prototype.forEach.call(document.querySelectorAll("a[href^=\"#\"]"), e);
			}
			function o() {
				I(window, "hashchange", i);
			}
			function s() {
				setTimeout(i, d);
			}
			function c() {
				/* istanbul ignore else */ Array.prototype.forEach && document.querySelectorAll ? (z("Setting up location.hash handlers"), a(), o(), s()) : pe("In page linking not fully supported in this browser! (See README.md for IE8 workaround)");
			}
			return te.enable ? c() : z("In page linking not enabled"), { findTarget: r };
		}
		function je() {
			if (b !== !0) return;
			function e(e) {
				Xe(0, 0, e.type, e.screenY + ":" + e.screenX);
			}
			function t(t, n) {
				z("Add event listener: " + n), I(window.document, t, e);
			}
			t("mouseenter", "Mouse Enter"), t("mouseleave", "Mouse Leave");
		}
		function Me() {
			z("Enable public methods"), oe.parentIFrame = {
				autoResize: function(e) {
					return !0 === e && !1 === n ? (n = !0, Ee()) : !1 === e && !0 === n && (n = !1, Oe()), Xe(0, 0, "autoResize", JSON.stringify(n)), n;
				},
				close: function() {
					Xe(0, 0, "close");
				},
				getId: function() {
					return S;
				},
				getPageInfo: function(e) {
					typeof e == "function" ? (M = e, Xe(0, 0, "pageInfo")) : (M = function() {}, Xe(0, 0, "pageInfoStop"));
				},
				moveToAnchor: function(e) {
					te.findTarget(e);
				},
				reset: function() {
					Ye("parentIFrame.reset");
				},
				scrollTo: function(e, t) {
					Xe(t, e, "scrollTo");
				},
				scrollToOffset: function(e, t) {
					Xe(t, e, "scrollToOffset");
				},
				sendMessage: function(e, t) {
					Xe(0, 0, "message", JSON.stringify(e), t);
				},
				setHeightCalculationMethod: function(e) {
					h = e, we();
				},
				setWidthCalculationMethod: function(e) {
					j = e, Te();
				},
				setTargetOrigin: function(e) {
					z("Set targetOrigin: " + e), w = e;
				},
				size: function(e, t) {
					Ke("size", "parentIFrame.size(" + ("" + (e || "") + (t ? "," + t : "")) + ")", e, t);
				}
			};
		}
		function Ne() {
			_ !== 0 && (z("setInterval: " + _ + "ms"), v = setInterval(function() {
				Ke("interval", "setInterval: " + _);
			}, Math.abs(_)));
		}
		/* istanbul ignore next */
		function Pe() {
			function e(e) {
				function t(e) {
					!1 === e.complete && (z("Attach listeners to " + e.src), e.addEventListener("load", i, !1), e.addEventListener("error", a, !1), c.push(e));
				}
				e.type === "attributes" && e.attributeName === "src" ? t(e.target) : e.type === "childList" && Array.prototype.forEach.call(e.target.querySelectorAll("img"), t);
			}
			function t(e) {
				c.splice(c.indexOf(e), 1);
			}
			function n(e) {
				z("Remove listeners from " + e.src), e.removeEventListener("load", i, !1), e.removeEventListener("error", a, !1), t(e);
			}
			function r(e, t, r) {
				n(e.target), Ke(t, r + ": " + e.target.src);
			}
			function i(e) {
				r(e, "imageLoad", "Image loaded");
			}
			function a(e) {
				r(e, "imageLoadFailed", "Image load failed");
			}
			function o(t) {
				Ke("mutationObserver", "mutationObserver: " + t[0].target + " " + t[0].type), t.forEach(e);
			}
			function s() {
				var e = document.querySelector("body");
				return u = new l(o), z("Create body MutationObserver"), u.observe(e, {
					attributes: !0,
					attributeOldValue: !1,
					characterData: !0,
					characterDataOldValue: !1,
					childList: !0,
					subtree: !0
				}), u;
			}
			var c = [], l = window.MutationObserver || window.WebKitMutationObserver, u = s();
			return { disconnect: function() {
				"disconnect" in u && (z("Disconnect body MutationObserver"), u.disconnect(), c.forEach(n));
			} };
		}
		function Fe() {
			var e = 0 > _;
			/* istanbul ignore if */ window.MutationObserver || window.WebKitMutationObserver ? e ? Ne() : s = Pe() : (z("MutationObserver not supported in this browser!"), Ne());
		}
		function Ie(e, t) {
			var n = 0;
			return t ||= document.body, n = document.defaultView.getComputedStyle(t, null), n = n === null ? 0 : n[e], parseInt(n, r);
		}
		function Le(e) {
			e > O / 2 && (O = 2 * e, z("Event throttle increased to " + O + "ms"));
		}
		function Re(e, t) {
			for (var n = t.length, r = 0, i = 0, a = R(e), o = Date.now(), s = 0; s < n; s++) r = t[s].getBoundingClientRect()[e] + Ie("margin" + a, t[s]), r > i && (i = r);
			return o = Date.now() - o, z("Parsed " + n + " HTML elements"), z("Element position calculated in " + o + "ms"), Le(o), i;
		}
		function ze(e) {
			return [
				e.bodyOffset(),
				e.bodyScroll(),
				e.documentElementOffset(),
				e.documentElementScroll()
			];
		}
		function Be(e, t) {
			function n() {
				return pe("No tagged elements (" + t + ") found on page"), document.querySelectorAll("body *");
			}
			var r = document.querySelectorAll("[" + t + "]");
			return r.length === 0 && n(), Re(e, r);
		}
		function Ve() {
			return document.querySelectorAll("body *");
		}
		var He = {
			bodyOffset: function() {
				return document.body.offsetHeight + Ie("marginTop") + Ie("marginBottom");
			},
			offset: function() {
				return He.bodyOffset();
			},
			bodyScroll: function() {
				return document.body.scrollHeight;
			},
			custom: function() {
				return N.height();
			},
			documentElementOffset: function() {
				return document.documentElement.offsetHeight;
			},
			documentElementScroll: function() {
				return document.documentElement.scrollHeight;
			},
			max: function() {
				return Math.max.apply(null, ze(He));
			},
			min: function() {
				return Math.min.apply(null, ze(He));
			},
			grow: function() {
				return He.max();
			},
			lowestElement: function() {
				return Math.max(He.bodyOffset() || He.documentElementOffset(), Re("bottom", Ve()));
			},
			taggedElement: function() {
				return Be("bottom", "data-iframe-height");
			}
		}, Ue = {
			bodyScroll: function() {
				return document.body.scrollWidth;
			},
			bodyOffset: function() {
				return document.body.offsetWidth;
			},
			custom: function() {
				return N.width();
			},
			documentElementScroll: function() {
				return document.documentElement.scrollWidth;
			},
			documentElementOffset: function() {
				return document.documentElement.offsetWidth;
			},
			scroll: function() {
				return Math.max(Ue.bodyScroll(), Ue.documentElementScroll());
			},
			max: function() {
				return Math.max.apply(null, ze(Ue));
			},
			min: function() {
				return Math.min.apply(null, ze(Ue));
			},
			rightMostElement: function() {
				return Re("right", Ve());
			},
			taggedElement: function() {
				return Be("right", "data-iframe-width");
			}
		};
		function We(t, n, r, i) {
			function a() {
				p = f, k = m, Xe(p, k, t);
			}
			function o() {
				function t(e, t) {
					return !(Math.abs(e - t) <= T);
				}
				return f = e === r ? He[h]() : r, m = e === i ? Ue[j]() : i, t(p, f) || l && t(k, m);
			}
			function s() {
				return !(t in {
					init: 1,
					interval: 1,
					size: 1
				});
			}
			function c() {
				return h in re || l && j in re;
			}
			function u() {
				z("No change in size detected");
			}
			function d() {
				s() && c() ? Ye(n) : t in { interval: 1 } || u();
			}
			var f, m;
			o() || t === "init" ? (qe(), a()) : d();
		}
		var Ge = de(We);
		function Ke(e, t, n, r) {
			function i() {
				e in {
					reset: 1,
					resetPage: 1,
					init: 1
				} || z("Trigger event: " + t);
			}
			function a() {
				return E && e in u;
			}
			a() ? z("Trigger event cancelled: " + e) : (i(), e === "init" ? We(e, t, n, r) : Ge(e, t, n, r));
		}
		function qe() {
			E || (E = !0, z("Trigger event lock on")), clearTimeout(D), D = setTimeout(function() {
				E = !1, z("Trigger event lock off"), z("--");
			}, d);
		}
		function Je(e) {
			p = He[h](), k = Ue[j](), Xe(p, k, e);
		}
		function Ye(e) {
			var t = h;
			h = m, z("Reset trigger event: " + e), qe(), Je("reset"), h = t;
		}
		function Xe(t, n, r, i, a) {
			function o() {
				e === a ? a = w : z("Message targetOrigin: " + a);
			}
			function s() {
				var o = t + ":" + n, s = S + ":" + o + ":" + r + (e === i ? "" : ":" + i);
				z("Sending message to host page (" + s + ")"), ae.postMessage(ne + s, a);
			}
			!0 === ie && (o(), s());
		}
		function Ze(n) {
			var r = {
				init: function() {
					ee = n.data, ae = n.source, me(), f = !1, setTimeout(function() {
						g = !1;
					}, d);
				},
				reset: function() {
					g ? z("Page reset ignored by init") : (z("Page size reset by host page"), Je("resetPage"));
				},
				resize: function() {
					Ke("resizeParent", "Parent window requested size check");
				},
				moveToAnchor: function() {
					te.findTarget(o());
				},
				inPageLink: function() {
					this.moveToAnchor();
				},
				pageInfo: function() {
					var e = o();
					z("PageInfoFromParent called from parent: " + e), M(JSON.parse(e)), z(" --");
				},
				message: function() {
					var e = o();
					z("onMessage called from parent: " + e), se(JSON.parse(e)), z(" --");
				}
			};
			function i() {
				return ne === ("" + n.data).slice(0, x);
			}
			function a() {
				return n.data.split("]")[1].split(":")[0];
			}
			function o() {
				return n.data.slice(n.data.indexOf(":") + 1);
			}
			function s() {
				return !(t !== void 0 && t.exports) && "iFrameResize" in window || window.jQuery !== e && "iFrameResize" in window.jQuery.prototype;
			}
			function c() {
				return n.data.split(":")[2] in {
					true: 1,
					false: 1
				};
			}
			function l() {
				var e = a();
				e in r ? r[e]() : !s() && !c() && pe("Unexpected message (" + n.data + ")");
			}
			function u() {
				!1 === f ? l() : c() ? r.init() : z("Ignored message of type \"" + a() + "\". Received before initialization.");
			}
			i() && u();
		}
		function Qe() {
			document.readyState !== "loading" && window.parent.postMessage("[iFrameResizerChild]Ready", "*");
		}
		"iframeResizer" in window || (window.iframeChildListener = function(e) {
			Ze({
				data: e,
				sameDomian: !0
			});
		}, I(window, "message", Ze), I(window, "readystatechange", Qe), Qe());
	})();
})), hn = (/* @__PURE__ */ e(((e, t) => {
	var n = pn();
	t.exports = {
		iframeResize: n,
		iframeResizer: n,
		contentWindow: mn()
	};
})))(), gn = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, _n = (e, t) => ({
	classGroupId: e,
	validator: t
}), vn = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), yn = "-", bn = [], xn = "arbitrary..", Sn = (e) => {
	let t = Tn(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return wn(e);
			let n = e.split(yn);
			return Cn(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? gn(i, t) : t : i || bn;
			}
			return n[e] || bn;
		}
	};
}, Cn = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = Cn(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(yn) : e.slice(t).join(yn), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, wn = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? xn + r : void 0;
})(), Tn = (e) => {
	let { theme: t, classGroups: n } = e;
	return En(n, t);
}, En = (e, t) => {
	let n = vn();
	for (let r in e) {
		let i = e[r];
		Dn(i, n, r, t);
	}
	return n;
}, Dn = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		On(i, t, n, r);
	}
}, On = (e, t, n, r) => {
	if (typeof e == "string") {
		kn(e, t, n);
		return;
	}
	if (typeof e == "function") {
		An(e, t, n, r);
		return;
	}
	jn(e, t, n, r);
}, kn = (e, t, n) => {
	let r = e === "" ? t : Mn(t, e);
	r.classGroupId = n;
}, An = (e, t, n, r) => {
	if (Nn(e)) {
		Dn(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(_n(n, e));
}, jn = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		Dn(o, Mn(t, a), n, r);
	}
}, Mn = (e, t) => {
	let n = e, r = t.split(yn), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = vn(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, Nn = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, Pn = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, Fn = "!", In = ":", Ln = [], Rn = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), zn = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === In) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(Fn) ? (c = s.slice(0, -1), l = !0) : s.startsWith(Fn) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return Rn(t, l, c, u);
	};
	if (t) {
		let e = t + In, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : Rn(Ln, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, Bn = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, Vn = (e) => ({
	cache: Pn(e.cacheSize),
	parseClassName: zn(e),
	sortModifiers: Bn(e),
	postfixLookupClassGroupIds: Hn(e),
	...Sn(e)
}), Hn = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, Un = /\s+/, Wn = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split(Un), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			if (g = r(p), !g) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let ee = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), te = f ? ee + Fn : ee, _ = te + g;
		if (s.indexOf(_) > -1) continue;
		s.push(_);
		let v = i(g, h);
		for (let e = 0; e < v.length; ++e) {
			let t = v[e];
			s.push(te + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, Gn = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = Kn(n)) && (i && (i += " "), i += r);
	return i;
}, Kn = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = Kn(e[r])) && (n && (n += " "), n += t);
	return n;
}, qn = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = Vn(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = Wn(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(Gn(...e));
}, Jn = [], J = (e) => {
	let t = (t) => t[e] || Jn;
	return t.isThemeGetter = !0, t.themeKey = e, t;
}, Yn = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Xn = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Zn = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, Qn = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, $n = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, er = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/, tr = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, nr = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, rr = (e) => Zn.test(e), Y = (e) => !!e && !Number.isNaN(Number(e)), ir = (e) => !!e && Number.isInteger(Number(e)), ar = (e) => e.endsWith("%") && Y(e.slice(0, -1)), or = (e) => Qn.test(e), sr = () => !0, cr = (e) => $n.test(e) && !er.test(e), lr = () => !1, ur = (e) => tr.test(e), dr = (e) => nr.test(e), fr = (e) => !X(e) && !Z(e), pr = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), mr = (e) => kr(e, Nr, lr), X = (e) => Yn.test(e), hr = (e) => kr(e, Pr, cr), gr = (e) => kr(e, Fr, Y), _r = (e) => kr(e, Lr, sr), vr = (e) => kr(e, Ir, lr), yr = (e) => kr(e, jr, lr), br = (e) => kr(e, Mr, dr), xr = (e) => kr(e, Rr, ur), Z = (e) => Xn.test(e), Sr = (e) => Ar(e, Pr), Cr = (e) => Ar(e, Ir), wr = (e) => Ar(e, jr), Tr = (e) => Ar(e, Nr), Er = (e) => Ar(e, Mr), Dr = (e) => Ar(e, Rr, !0), Or = (e) => Ar(e, Lr, !0), kr = (e, t, n) => {
	let r = Yn.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Ar = (e, t, n = !1) => {
	let r = Xn.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, jr = (e) => e === "position" || e === "percentage", Mr = (e) => e === "image" || e === "url", Nr = (e) => e === "length" || e === "size" || e === "bg-size", Pr = (e) => e === "length", Fr = (e) => e === "number", Ir = (e) => e === "family-name", Lr = (e) => e === "number" || e === "weight", Rr = (e) => e === "shadow", zr = /*#__PURE__*/ qn(() => {
	let e = J("color"), t = J("font"), n = J("text"), r = J("font-weight"), i = J("tracking"), a = J("leading"), o = J("breakpoint"), s = J("container"), c = J("spacing"), l = J("radius"), u = J("shadow"), d = J("inset-shadow"), f = J("text-shadow"), p = J("drop-shadow"), m = J("blur"), h = J("perspective"), g = J("aspect"), ee = J("ease"), te = J("animate"), _ = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], v = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], y = () => [
		...v(),
		Z,
		X
	], b = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], ne = () => [
		"auto",
		"contain",
		"none"
	], x = () => [
		Z,
		X,
		c
	], S = () => [
		rr,
		"full",
		"auto",
		...x()
	], re = () => [
		ir,
		"none",
		"subgrid",
		Z,
		X
	], C = () => [
		"auto",
		{ span: [
			"full",
			ir,
			Z,
			X
		] },
		ir,
		Z,
		X
	], ie = () => [
		ir,
		"auto",
		Z,
		X
	], ae = () => [
		"auto",
		"min",
		"max",
		"fr",
		Z,
		X
	], w = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], T = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], E = () => ["auto", ...x()], D = () => [
		rr,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...x()
	], O = () => [
		s,
		rr,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...x()
	], k = () => [
		rr,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...x()
	], A = () => [
		e,
		Z,
		X
	], j = () => [
		...v(),
		wr,
		yr,
		{ position: [Z, X] }
	], oe = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], se = () => [
		"auto",
		"cover",
		"contain",
		Tr,
		mr,
		{ size: [Z, X] }
	], ce = () => [
		ar,
		Sr,
		hr
	], M = () => [
		"",
		"none",
		"full",
		l,
		Z,
		X
	], N = () => [
		"",
		Y,
		Sr,
		hr
	], le = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], ue = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], P = () => [
		Y,
		ar,
		wr,
		yr
	], F = () => [
		"",
		"none",
		m,
		Z,
		X
	], I = () => [
		"none",
		Y,
		Z,
		X
	], L = () => [
		"none",
		Y,
		Z,
		X
	], R = () => [
		Y,
		Z,
		X
	], de = () => [
		rr,
		"full",
		...x()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [or],
			breakpoint: [or],
			color: [sr],
			container: [or],
			"drop-shadow": [or],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [fr],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [or],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [or],
			shadow: [or],
			spacing: ["px", Y],
			text: [or],
			"text-shadow": [or],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				rr,
				X,
				Z,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				Z,
				X
			] }],
			"container-named": [pr],
			columns: [{ columns: [
				Y,
				"auto",
				X,
				Z,
				s
			] }],
			"break-after": [{ "break-after": _() }],
			"break-before": [{ "break-before": _() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: y() }],
			overflow: [{ overflow: b() }],
			"overflow-x": [{ "overflow-x": b() }],
			"overflow-y": [{ "overflow-y": b() }],
			overscroll: [{ overscroll: ne() }],
			"overscroll-x": [{ "overscroll-x": ne() }],
			"overscroll-y": [{ "overscroll-y": ne() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: S() }],
			"inset-x": [{ "inset-x": S() }],
			"inset-y": [{ "inset-y": S() }],
			start: [{
				"inset-s": S(),
				start: S()
			}],
			end: [{
				"inset-e": S(),
				end: S()
			}],
			"inset-bs": [{ "inset-bs": S() }],
			"inset-be": [{ "inset-be": S() }],
			top: [{ top: S() }],
			right: [{ right: S() }],
			bottom: [{ bottom: S() }],
			left: [{ left: S() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				ir,
				"auto",
				Z,
				X
			] }],
			basis: [{ basis: [
				rr,
				"full",
				"auto",
				s,
				...x()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				Y,
				rr,
				"auto",
				"initial",
				"none",
				X
			] }],
			grow: [{ grow: [
				"",
				Y,
				Z,
				X
			] }],
			shrink: [{ shrink: [
				"",
				Y,
				Z,
				X
			] }],
			order: [{ order: [
				ir,
				"first",
				"last",
				"none",
				Z,
				X
			] }],
			"grid-cols": [{ "grid-cols": re() }],
			"col-start-end": [{ col: C() }],
			"col-start": [{ "col-start": ie() }],
			"col-end": [{ "col-end": ie() }],
			"grid-rows": [{ "grid-rows": re() }],
			"row-start-end": [{ row: C() }],
			"row-start": [{ "row-start": ie() }],
			"row-end": [{ "row-end": ie() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": ae() }],
			"auto-rows": [{ "auto-rows": ae() }],
			gap: [{ gap: x() }],
			"gap-x": [{ "gap-x": x() }],
			"gap-y": [{ "gap-y": x() }],
			"justify-content": [{ justify: [...w(), "normal"] }],
			"justify-items": [{ "justify-items": [...T(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...T()] }],
			"align-content": [{ content: ["normal", ...w()] }],
			"align-items": [{ items: [...T(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...T(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": w() }],
			"place-items": [{ "place-items": [...T(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...T()] }],
			p: [{ p: x() }],
			px: [{ px: x() }],
			py: [{ py: x() }],
			ps: [{ ps: x() }],
			pe: [{ pe: x() }],
			pbs: [{ pbs: x() }],
			pbe: [{ pbe: x() }],
			pt: [{ pt: x() }],
			pr: [{ pr: x() }],
			pb: [{ pb: x() }],
			pl: [{ pl: x() }],
			m: [{ m: E() }],
			mx: [{ mx: E() }],
			my: [{ my: E() }],
			ms: [{ ms: E() }],
			me: [{ me: E() }],
			mbs: [{ mbs: E() }],
			mbe: [{ mbe: E() }],
			mt: [{ mt: E() }],
			mr: [{ mr: E() }],
			mb: [{ mb: E() }],
			ml: [{ ml: E() }],
			"space-x": [{ "space-x": x() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": x() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: D() }],
			"inline-size": [{ inline: ["auto", ...O()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...O()] }],
			"max-inline-size": [{ "max-inline": ["none", ...O()] }],
			"block-size": [{ block: ["auto", ...k()] }],
			"min-block-size": [{ "min-block": ["auto", ...k()] }],
			"max-block-size": [{ "max-block": ["none", ...k()] }],
			w: [{ w: [
				s,
				"screen",
				...D()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...D()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...D()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...D()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...D()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				"none",
				...D()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				Sr,
				hr
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				Or,
				_r
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				ar,
				X
			] }],
			"font-family": [{ font: [
				Cr,
				vr,
				t
			] }],
			"font-features": [{ "font-features": [X] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				Z,
				X
			] }],
			"line-clamp": [{ "line-clamp": [
				Y,
				"none",
				Z,
				gr
			] }],
			leading: [{ leading: [
				"none",
				a,
				...x()
			] }],
			"list-image": [{ "list-image": [
				"none",
				Z,
				X
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				Z,
				X
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: A() }],
			"text-color": [{ text: A() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...le(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				Y,
				"from-font",
				"auto",
				Z,
				hr
			] }],
			"text-decoration-color": [{ decoration: A() }],
			"underline-offset": [{ "underline-offset": [
				Y,
				"auto",
				Z,
				X
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: x() }],
			"tab-size": [{ tab: [
				ir,
				Z,
				X
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				Z,
				X
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				Z,
				X
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: j() }],
			"bg-repeat": [{ bg: oe() }],
			"bg-size": [{ bg: se() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						ir,
						Z,
						X
					],
					radial: [
						"",
						Z,
						X
					],
					conic: [
						"",
						ir,
						Z,
						X
					]
				},
				Er,
				br
			] }],
			"bg-color": [{ bg: A() }],
			"gradient-from-pos": [{ from: ce() }],
			"gradient-via-pos": [{ via: ce() }],
			"gradient-to-pos": [{ to: ce() }],
			"gradient-from": [{ from: A() }],
			"gradient-via": [{ via: A() }],
			"gradient-to": [{ to: A() }],
			rounded: [{ rounded: M() }],
			"rounded-s": [{ "rounded-s": M() }],
			"rounded-e": [{ "rounded-e": M() }],
			"rounded-t": [{ "rounded-t": M() }],
			"rounded-r": [{ "rounded-r": M() }],
			"rounded-b": [{ "rounded-b": M() }],
			"rounded-l": [{ "rounded-l": M() }],
			"rounded-ss": [{ "rounded-ss": M() }],
			"rounded-se": [{ "rounded-se": M() }],
			"rounded-ee": [{ "rounded-ee": M() }],
			"rounded-es": [{ "rounded-es": M() }],
			"rounded-tl": [{ "rounded-tl": M() }],
			"rounded-tr": [{ "rounded-tr": M() }],
			"rounded-br": [{ "rounded-br": M() }],
			"rounded-bl": [{ "rounded-bl": M() }],
			"border-w": [{ border: N() }],
			"border-w-x": [{ "border-x": N() }],
			"border-w-y": [{ "border-y": N() }],
			"border-w-s": [{ "border-s": N() }],
			"border-w-e": [{ "border-e": N() }],
			"border-w-bs": [{ "border-bs": N() }],
			"border-w-be": [{ "border-be": N() }],
			"border-w-t": [{ "border-t": N() }],
			"border-w-r": [{ "border-r": N() }],
			"border-w-b": [{ "border-b": N() }],
			"border-w-l": [{ "border-l": N() }],
			"divide-x": [{ "divide-x": N() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": N() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...le(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...le(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: A() }],
			"border-color-x": [{ "border-x": A() }],
			"border-color-y": [{ "border-y": A() }],
			"border-color-s": [{ "border-s": A() }],
			"border-color-e": [{ "border-e": A() }],
			"border-color-bs": [{ "border-bs": A() }],
			"border-color-be": [{ "border-be": A() }],
			"border-color-t": [{ "border-t": A() }],
			"border-color-r": [{ "border-r": A() }],
			"border-color-b": [{ "border-b": A() }],
			"border-color-l": [{ "border-l": A() }],
			"divide-color": [{ divide: A() }],
			"outline-style": [{ outline: [
				...le(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				Y,
				Z,
				X
			] }],
			"outline-w": [{ outline: [
				"",
				Y,
				Sr,
				hr
			] }],
			"outline-color": [{ outline: A() }],
			shadow: [{ shadow: [
				"",
				"inner",
				"none",
				u,
				Dr,
				xr
			] }],
			"shadow-color": [{ shadow: A() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				Dr,
				xr
			] }],
			"inset-shadow-color": [{ "inset-shadow": A() }],
			"ring-w": [{ ring: N() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: A() }],
			"ring-offset-w": [{ "ring-offset": [Y, hr] }],
			"ring-offset-color": [{ "ring-offset": A() }],
			"inset-ring-w": [{ "inset-ring": N() }],
			"inset-ring-color": [{ "inset-ring": A() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				Dr,
				xr
			] }],
			"text-shadow-color": [{ "text-shadow": A() }],
			opacity: [{ opacity: [
				Y,
				Z,
				X
			] }],
			"mix-blend": [{ "mix-blend": [
				...ue(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": ue() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [Y] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": P() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": P() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": A() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": A() }],
			"mask-image-t-from-pos": [{ "mask-t-from": P() }],
			"mask-image-t-to-pos": [{ "mask-t-to": P() }],
			"mask-image-t-from-color": [{ "mask-t-from": A() }],
			"mask-image-t-to-color": [{ "mask-t-to": A() }],
			"mask-image-r-from-pos": [{ "mask-r-from": P() }],
			"mask-image-r-to-pos": [{ "mask-r-to": P() }],
			"mask-image-r-from-color": [{ "mask-r-from": A() }],
			"mask-image-r-to-color": [{ "mask-r-to": A() }],
			"mask-image-b-from-pos": [{ "mask-b-from": P() }],
			"mask-image-b-to-pos": [{ "mask-b-to": P() }],
			"mask-image-b-from-color": [{ "mask-b-from": A() }],
			"mask-image-b-to-color": [{ "mask-b-to": A() }],
			"mask-image-l-from-pos": [{ "mask-l-from": P() }],
			"mask-image-l-to-pos": [{ "mask-l-to": P() }],
			"mask-image-l-from-color": [{ "mask-l-from": A() }],
			"mask-image-l-to-color": [{ "mask-l-to": A() }],
			"mask-image-x-from-pos": [{ "mask-x-from": P() }],
			"mask-image-x-to-pos": [{ "mask-x-to": P() }],
			"mask-image-x-from-color": [{ "mask-x-from": A() }],
			"mask-image-x-to-color": [{ "mask-x-to": A() }],
			"mask-image-y-from-pos": [{ "mask-y-from": P() }],
			"mask-image-y-to-pos": [{ "mask-y-to": P() }],
			"mask-image-y-from-color": [{ "mask-y-from": A() }],
			"mask-image-y-to-color": [{ "mask-y-to": A() }],
			"mask-image-radial": [{ "mask-radial": [Z, X] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": P() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": P() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": A() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": A() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": v() }],
			"mask-image-conic-pos": [{ "mask-conic": [Y] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": P() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": P() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": A() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": A() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: j() }],
			"mask-repeat": [{ mask: oe() }],
			"mask-size": [{ mask: se() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				Z,
				X
			] }],
			filter: [{ filter: [
				"",
				"none",
				Z,
				X
			] }],
			blur: [{ blur: F() }],
			brightness: [{ brightness: [
				Y,
				Z,
				X
			] }],
			contrast: [{ contrast: [
				Y,
				Z,
				X
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				Dr,
				xr
			] }],
			"drop-shadow-color": [{ "drop-shadow": A() }],
			grayscale: [{ grayscale: [
				"",
				Y,
				Z,
				X
			] }],
			"hue-rotate": [{ "hue-rotate": [
				Y,
				Z,
				X
			] }],
			invert: [{ invert: [
				"",
				Y,
				Z,
				X
			] }],
			saturate: [{ saturate: [
				Y,
				Z,
				X
			] }],
			sepia: [{ sepia: [
				"",
				Y,
				Z,
				X
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				Z,
				X
			] }],
			"backdrop-blur": [{ "backdrop-blur": F() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				Y,
				Z,
				X
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				Y,
				Z,
				X
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				Y,
				Z,
				X
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				Y,
				Z,
				X
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				Y,
				Z,
				X
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				Y,
				Z,
				X
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				Y,
				Z,
				X
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				Y,
				Z,
				X
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": x() }],
			"border-spacing-x": [{ "border-spacing-x": x() }],
			"border-spacing-y": [{ "border-spacing-y": x() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				Z,
				X
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				Y,
				"initial",
				Z,
				X
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				ee,
				Z,
				X
			] }],
			delay: [{ delay: [
				Y,
				Z,
				X
			] }],
			animate: [{ animate: [
				"none",
				te,
				Z,
				X
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				Z,
				X
			] }],
			"perspective-origin": [{ "perspective-origin": y() }],
			rotate: [{ rotate: I() }],
			"rotate-x": [{ "rotate-x": I() }],
			"rotate-y": [{ "rotate-y": I() }],
			"rotate-z": [{ "rotate-z": I() }],
			scale: [{ scale: L() }],
			"scale-x": [{ "scale-x": L() }],
			"scale-y": [{ "scale-y": L() }],
			"scale-z": [{ "scale-z": L() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: R() }],
			"skew-x": [{ "skew-x": R() }],
			"skew-y": [{ "skew-y": R() }],
			transform: [{ transform: [
				Z,
				X,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: y() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: de() }],
			"translate-x": [{ "translate-x": de() }],
			"translate-y": [{ "translate-y": de() }],
			"translate-z": [{ "translate-z": de() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				ir,
				Z,
				X
			] }],
			accent: [{ accent: A() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: A() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				Z,
				X
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": A() }],
			"scrollbar-track-color": [{ "scrollbar-track": A() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": x() }],
			"scroll-mx": [{ "scroll-mx": x() }],
			"scroll-my": [{ "scroll-my": x() }],
			"scroll-ms": [{ "scroll-ms": x() }],
			"scroll-me": [{ "scroll-me": x() }],
			"scroll-mbs": [{ "scroll-mbs": x() }],
			"scroll-mbe": [{ "scroll-mbe": x() }],
			"scroll-mt": [{ "scroll-mt": x() }],
			"scroll-mr": [{ "scroll-mr": x() }],
			"scroll-mb": [{ "scroll-mb": x() }],
			"scroll-ml": [{ "scroll-ml": x() }],
			"scroll-p": [{ "scroll-p": x() }],
			"scroll-px": [{ "scroll-px": x() }],
			"scroll-py": [{ "scroll-py": x() }],
			"scroll-ps": [{ "scroll-ps": x() }],
			"scroll-pe": [{ "scroll-pe": x() }],
			"scroll-pbs": [{ "scroll-pbs": x() }],
			"scroll-pbe": [{ "scroll-pbe": x() }],
			"scroll-pt": [{ "scroll-pt": x() }],
			"scroll-pr": [{ "scroll-pr": x() }],
			"scroll-pb": [{ "scroll-pb": x() }],
			"scroll-pl": [{ "scroll-pl": x() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				Z,
				X
			] }],
			fill: [{ fill: ["none", ...A()] }],
			"stroke-w": [{ stroke: [
				Y,
				Sr,
				hr,
				gr
			] }],
			stroke: [{ stroke: ["none", ...A()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": [
				"start",
				"end",
				"right",
				"left"
			],
			"inset-y": [
				"inset-bs",
				"inset-be",
				"top",
				"bottom"
			],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: [
				"ps",
				"pe",
				"pr",
				"pl"
			],
			py: [
				"pbs",
				"pbe",
				"pt",
				"pb"
			],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: [
				"ms",
				"me",
				"mr",
				"ml"
			],
			my: [
				"mbs",
				"mbe",
				"mt",
				"mb"
			],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": [
				"border-w-s",
				"border-w-e",
				"border-w-r",
				"border-w-l"
			],
			"border-w-y": [
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-b"
			],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": [
				"border-color-s",
				"border-color-e",
				"border-color-r",
				"border-color-l"
			],
			"border-color-y": [
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-b"
			],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": [
				"scroll-ms",
				"scroll-me",
				"scroll-mr",
				"scroll-ml"
			],
			"scroll-my": [
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mb"
			],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": [
				"scroll-ps",
				"scroll-pe",
				"scroll-pr",
				"scroll-pl"
			],
			"scroll-py": [
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pb"
			],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
}), Br = /* @__PURE__ */ function(e) {
	return e.CHANNEL_SETTINGS = "channel-settings", e.BUTTON_SETTINGS = "button-settings", e;
}({}), Vr = /* @__PURE__ */ function(e) {
	return e.FORM_LOADED = "givebutter-form-loaded", e.CLOSE_MODAL = "close-givebutter-modal", e.DONATION_BUTTON_CLOSE = "donation.button.close", e.DONATION_BUTTON_NEXT = "donation.button.next", e.DONATION_BUTTON_BACK = "donation.button.back", e.DONATION_GO_TO_STEP = "donation.go.to.step", e.POST_CHECKOUT_REDIRECT = "post_checkout.redirect", e;
}({}), Hr = /* @__PURE__ */ function(e) {
	return e.CLOSE_OVERLAY = "close-overlay", e;
}({}), Ur = /* @__PURE__ */ function(e) {
	return e.READY = "givebutter-widget-ready", e;
}({}), Wr = /* @__PURE__ */ function(e) {
	return e.STARTED = "donation.started", e.PAYING = "donation.paying", e.COMPLETE = "donation.complete", e;
}({}), Gr = class extends bt(Te) {
	constructor(...e) {
		super(...e), this.isLoading = !0, this.src = "", this.overrideIsLoading = !1, this.showPoweredByGivebutter = !0, this.showBorder = !0, this.closable = !1, this.maxWidth = "560px", this.maxHeight = "", this.iframeClass = "", this.footerClass = "";
	}
	resizeIframe() {
		this.iframe?.iFrameResizer?.resize();
	}
	willUpdate(e) {
		this.overrideIsLoading || (this.isLoading = !1, this.iframe?.iFrameResizer?.resize());
	}
	updated(e) {
		e.has("isLoading") && !this.isLoading && !this.error && requestAnimationFrame(() => this.dispatchEvent(new Event(Ur.READY, {
			bubbles: !0,
			composed: !0
		})));
	}
	render() {
		return this.error ? this.renderError() : F`
      <div
        style=${Ut({ maxWidth: this.maxWidth })}
        class="${this.isLoading ? "" : "hidden"} ${this.iframeClass} flex w-full grow items-center justify-center p-20"
      >
        <svg
          aria-hidden="true"
          class="mr-2 h-7 w-7 animate-spin fill-blue-500 text-gray-200 dark:text-gray-600"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
      </div>
      <iframe
        ${Bt(this.iframeChanged)}
        name="givebutter"
        title="givebutter-iframe"
        class="${this.getIframeClass()}"
        style=${Ut(this.getIframeStyles())}
        src="${this.src}"
        allowpaymentrequest="true"
        allow="payment"
      ></iframe>
      ${this.renderPoweredByGivebutter()}
    `;
	}
	renderPoweredByGivebutter() {
		return this.showPoweredByGivebutter ? F`
      <div
        class="${this.showBorder ? "rounded-b-2xl border border-t-0 border-gray-300" : "border-t border-gray-100"} ${this.isLoading ? "hidden" : this.footerClass} flex w-full items-center justify-center bg-gray-100 py-3 text-center"
        style=${Ut({ maxWidth: this.maxWidth })}
      >
        <a
          class="text-gray-900! no-underline!"
          href="https://givebutter.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            class="block"
            alt="Powered by Givebutter"
            width="182"
            height="18"
            src="https://givebutter.com/assets/brand/givebutter/Powered/Givebutter_H_Text.svg"
            draggable="false"
          />
        </a>
      </div>
    ` : "";
	}
	iframeChanged(e) {
		e && (this.iframe = e, setTimeout(() => (0, hn.iframeResizer)({
			checkOrigin: !1,
			scrolling: this.closable || this.maxHeight.length > 0 ? "auto" : !1,
			initCallback: () => {
				this.overrideIsLoading || (this.isLoading = !1);
			},
			closedCallback: () => {
				this.isLoading = !1;
			}
		}, e), 0));
	}
	getIframeClass() {
		return zr("w-full bg-white", this.isLoading && "hidden", this.showBorder && "border border-gray-300 rounded-t-2xl", this.showBorder && !this.showPoweredByGivebutter && "rounded-b-2xl", this.showBorder && this.showPoweredByGivebutter && "border-b-gray-100", this.iframeClass);
	}
	getIframeStyles() {
		return {
			maxWidth: this.maxWidth,
			maxHeight: this.maxHeight
		};
	}
	renderError() {
		return F`
      <div class="relative w-[400px] rounded-md bg-white p-12 text-center font-sans">
        <button
          aria-label="close"
          onclick="window.postMessage('close-givebutter-modal')"
          class="absolute top-0 right-0 mt-4 mr-4 rounded-md p-2 focus:outline-hidden"
        >
          <svg class="h-5 w-5 text-gray-500" fill="currentColor" viewBox="-2 -2 24 24">
            <path
              fill-rule="evenodd"
              d="M13.414 6l5.293-5.293a1 1 0 1 0-1.414-1.414L12 4.586 6.707-.707a1 1 0 1 0-1.414 1.414L10.586 6l-5.293 5.293a1 1 0 1 0 1.414 1.414L12 7.414l5.293 5.293a1 1 0 1 0 1.414-1.414L13.414 6z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
        <div class="mb-2 inline-flex items-center">
          <img
            height="40px"
            alt="Warning"
            src="https://givebuttercdn.com/widgets/icons/warning-icon.svg"
          />
        </div>
        <div class="mb-10 text-lg">
          <strong>Uh-oh!</strong>
        </div>
        <div class="mb-10">
          <p class="mb-3">There was an error loading this widget.</p>
          <p>
            Please check your widget<br />
            configuration.
          </p>
        </div>
        <div class="mb-10">
          <a
            class="inline-flex items-center text-blue-600"
            href="https://givebutter.com/contact"
            target="_blank"
          >
            Contact Support
            <img
              height="25px"
              alt="Arrow symbol"
              src="https://givebuttercdn.com/widgets/icons/arrow-right-blue.svg"
            />
          </a>
        </div>
        <div class="flex flex-col items-center gap-4">
          <img
            height="20px"
            alt="Givebutter logo"
            src="https://givebuttercdn.com/widgets/icons/gb-logo-square.svg"
          />
          <img
            height="15px"
            alt="Powered by Givebutter"
            src="https://givebuttercdn.com/widgets/icons/powered-by-givebutter.svg"
          />
        </div>
      </div>
    `;
	}
};
H([vt()], Gr.prototype, "isLoading", void 0), H([V({ type: String })], Gr.prototype, "src", void 0), H([V({
	type: Boolean,
	converter: sn._boolean
})], Gr.prototype, "overrideIsLoading", void 0), H([V({
	type: Boolean,
	converter: sn._boolean
})], Gr.prototype, "showPoweredByGivebutter", void 0), H([V({
	type: Boolean,
	converter: sn._boolean
})], Gr.prototype, "showBorder", void 0), H([V({ type: String })], Gr.prototype, "error", void 0), H([V({
	type: Boolean,
	converter: sn._boolean
})], Gr.prototype, "closable", void 0), H([V({
	type: String,
	attribute: "max-width"
})], Gr.prototype, "maxWidth", void 0), H([V({
	type: String,
	attribute: "max-height"
})], Gr.prototype, "maxHeight", void 0), H([V({
	type: String,
	attribute: "iframe-class"
})], Gr.prototype, "iframeClass", void 0), H([V({
	type: String,
	attribute: "footer-class"
})], Gr.prototype, "footerClass", void 0), Gr = H([ht("givebutter-iframe")], Gr);
//#endregion
//#region src/controllers/fetch-data-controller.ts
var Kr = 300 * 1e3, qr = class {
	constructor({ host: e, queryFn: t, cacheTime: n = Kr, retryCount: r = 3, onSuccess: i, onError: a, shouldStopInterval: o }) {
		this.destroyed = !1, this.host = e, this.queryFn = t, this.cacheTime = n, this.intervalId = null, this.retryCount = r, this.handleWindowFocus = this.handleWindowFocus.bind(this), this.host.addController(this), this.onSuccess = i, this.onError = a, this.shouldStopInterval = o;
	}
	async hostConnected() {
		await this.fetchData(), this.setRefetchInterval(), window.addEventListener("focus", this.handleWindowFocus);
	}
	hostDisconnected() {
		this.stopInterval(), window.removeEventListener("focus", this.handleWindowFocus);
	}
	async refetch() {
		await this.fetchData();
	}
	destroy() {
		this.destroyed = !0, this.stopInterval(), window.removeEventListener("focus", this.handleWindowFocus), this.host.removeController(this);
	}
	async fetchData(e = this.retryCount) {
		try {
			let e = await this.queryFn();
			if (this.destroyed) return;
			this.data = e, this.error = void 0, this.errorStatus = void 0, this.onSuccess?.(this.data), this.shouldStopInterval?.(this.data) && this.stopInterval();
		} catch (t) {
			if (this.destroyed) return;
			this.shouldRetry(t?.response?.status) && e > 0 ? await this.fetchData(e - 1) : (this.error = t?.message ?? "Something went wrong.", this.errorStatus = t?.response?.status, this.stopInterval(), this.onError?.(this.error ?? "Unknown error occurred"));
		} finally {
			this.destroyed || this.host.requestUpdate();
		}
	}
	setRefetchInterval() {
		this.intervalId = setInterval(async () => {
			await this.fetchData();
		}, this.cacheTime);
	}
	async handleWindowFocus() {
		await this.fetchData();
	}
	stopInterval() {
		this.intervalId !== null && clearInterval(this.intervalId);
	}
	shouldRetry(e) {
		return e !== 404 && e !== 422;
	}
}, Jr = [
	3e3,
	8e3,
	15e3
], Yr = class {
	constructor(e) {
		this.attempt = 0, this.timers = [], this.startedFor = null, this.host = e, e.addController(this);
	}
	hostDisconnected() {
		this.clear(), this.startedFor = null;
	}
	start(e) {
		!e || this.startedFor === e || (this.clear(), this.startedFor = e, this.attempt = 0, this.timers = Jr.map((e, t) => setTimeout(() => {
			this.attempt = t + 1, this.host.requestUpdate();
		}, e)));
	}
	clear() {
		this.timers.forEach((e) => clearTimeout(e)), this.timers = [];
	}
}, Xr = () => `${K.apiUrl}/elements/api/v2`, Zr = 204, Qr = class extends Error {
	constructor(e, t, n) {
		super(e), this.url = t, this.response = n;
	}
}, $r = async (e, t) => {
	let n = decodeURIComponent(t).trim();
	return /^[a-zA-Z0-9]{6,}$/.test(n) || n === void 0 ? await ai(`${e}/elements/${n}${W.isWixEditorPreview() ? `?_=${Date.now()}&preview_image=1` : ""}`) : {};
}, ei = async (e, t) => await ai(`${e}/campaigns/${t}`), ti = async (e, t) => await ai(`${e}/campaigns/${t}/goal-status`), ni = async (e, t, n = "members", r = 5) => await ai(`${e}/campaigns/${t}/leaderboard?type=${encodeURIComponent(n)}&limit=${encodeURIComponent(String(r))}`), ri = (e) => ({
	status: e.status,
	statusText: e.statusText,
	headers: [...e.headers.entries()].reduce((e, [t, n]) => (e[t] = n, e), {})
}), ii = async (e) => {
	let t = await fetch(e), n = ri(t);
	if (!t.ok) throw new Qr(`HTTP error with status: ${t.status}`, e, n);
	return t.status === Zr ? {} : t.json();
}, ai = async (e) => await ii(`${Xr()}/${e}`), oi = class {
	static sendEcommerceEvent(e, t) {
		if (typeof window.gtag == "function") {
			window.gtag("event", e, t);
			return;
		}
		if (Array.isArray(window.dataLayer)) {
			window.dataLayer.push({ ecommerce: null }), window.dataLayer.push({
				event: e,
				ecommerce: t
			});
			return;
		}
		U.debug(`No gtag or dataLayer on the host page, skipping "${e}"`);
	}
}, si = class {
	static send(e, t, n) {
		if (typeof window.fbq != "function") {
			U.debug(`No fbq on the host page, skipping "${e}"`);
			return;
		}
		window.fbq("track", e, t, n ? { eventID: n } : void 0);
	}
}, ci = Object.values(Wr);
function li(e) {
	let t = Number(e ?? 0);
	return Number.isFinite(t) ? t : 0;
}
function ui(e) {
	return String(e.campaign?.id ?? e.campaign?.code ?? "");
}
var di = {
	[Wr.STARTED]: "add_to_cart",
	[Wr.PAYING]: "begin_checkout",
	[Wr.COMPLETE]: "purchase"
}, fi = {
	[Wr.STARTED]: "AddToCart",
	[Wr.PAYING]: "InitiateCheckout",
	[Wr.COMPLETE]: "Purchase"
}, pi = class {
	static isDonationMessage(e) {
		let t = e;
		return !!t && t.givebutter === !0 && ci.includes(t.event);
	}
	static dispatch(e) {
		if (!ui(e)) {
			U.debug(`Donation message "${e.event}" has no campaign identifier, skipping`);
			return;
		}
		let t = this.toGa4Event(e);
		t && oi.sendEcommerceEvent(t.name, t.params);
		let n = this.toMetaEvent(e);
		n && si.send(n.name, n.params, e.transactionId);
	}
	static toGa4Event(e) {
		let t = di[e.event];
		if (!t) return null;
		let n = li(e.total), r = {
			item_id: ui(e),
			item_name: e.campaign?.title ?? "",
			price: n,
			quantity: 1
		}, i = {
			currency: e.currency ?? "USD",
			value: n,
			items: [r]
		};
		return t === "purchase" && (e.transactionId ? i.transaction_id = e.transactionId : U.debug("Purchase message has no transactionId, GA4 dedup will not apply")), {
			name: t,
			params: i
		};
	}
	static toMetaEvent(e) {
		let t = fi[e.event];
		return t ? {
			name: t,
			params: {
				content_type: "product",
				content_ids: [ui(e)],
				content_name: e.campaign?.title ?? "",
				currency: e.currency ?? "USD",
				value: li(e.total)
			}
		} : null;
	}
}, mi = "gba_gb.element.id", hi = "gba_gb.element.platform", gi = (e, t) => {
	if (!qt.isValidEmbedUrl(e)) return "";
	let n = new URL(e), r = new URLSearchParams(n.search);
	return new URLSearchParams(t.analyticsQueryString).forEach((e, t) => {
		r.has(t) || r.set(t, e);
	}), r.set("goalBar", "false"), t.closable && r.set("closeButton", "true"), t.widgetId.length > 0 && r.set(mi, t.widgetId), r.set(hi, t.platform), `${n.origin + n.pathname}?${r.toString()}`;
}, _i = class {
	static parseRedirectUrl(e) {
		let t = e;
		if (!t || typeof t != "object" || t.givebutter !== !0 || t.event !== Vr.POST_CHECKOUT_REDIRECT || typeof t.redirectUrl != "string") return null;
		try {
			let e = new URL(t.redirectUrl);
			return e.protocol === "https:" ? e : null;
		} catch {
			return null;
		}
	}
	static isFromEmbedOrigin(e, t) {
		try {
			return typeof e == "string" && e === new URL(t).origin;
		} catch {
			return !1;
		}
	}
	static navigateTop(e) {
		try {
			window.top?.location.assign(e.href);
		} catch {
			return;
		}
	}
};
//#endregion
//#region src/components/partials/wix-editor-preview-image.ts
function vi({ src: e, alt: t, maxWidth: n, attempt: r = 0 }) {
	return F`
    <div class="flex h-full w-full items-start justify-center">
      <div class="relative w-full" style="max-width: ${n}">
        <img class="h-auto w-full" src="${r > 0 ? `${e}?r=${r}` : e}" alt="${t}" loading="eager" />
        <p
          class="absolute top-3 left-1/2 -translate-x-1/2 rounded-full bg-gray-900/75 px-3 py-1 font-sans text-xs font-semibold tracking-wide text-white uppercase"
        >
          Static Preview
        </p>
      </div>
    </div>
  `;
}
//#endregion
//#region src/components/partials/wix-editor-preview-notice.ts
function yi({ title: e, description: t, maxWidthPx: n }) {
	return F`
    <div class="flex h-full w-full items-center justify-center">
      <div
        class="mx-auto flex w-full flex-col items-center gap-1.5 rounded-2xl border border-dashed border-gray-300 bg-gray-50 p-10 text-center font-sans"
        style="max-width: ${n}px"
      >
        <p class="text-base font-semibold text-gray-900">${e}</p>
        <p class="text-sm text-gray-500">${t}</p>
      </div>
    </div>
  `;
}
//#endregion
//#region src/components/giving-form.ts
var bi = class extends bt(on) {
	constructor() {
		super(), this.hasRedirected = !1, this.isLoading = !0, this.themeColor = "", this.maxWidth = "", this.maxHeight = "", this.closable = !1, this.showGoalBar = !1, this.iframeClass = "", this.footerClass = "", this.previewImageUrl = "", this.previewRetry = new Yr(this), this.isEventTicketsFlow = !1, this.receiveMessageEvent = (e) => {
			let t = e.data.event || e.data, n = this.iframe?.shadowRoot?.querySelector("iframe");
			if (t === Vr.DONATION_BUTTON_CLOSE || t === Vr.CLOSE_MODAL) {
				this.shadowRoot?.dispatchEvent(new Event(Hr.CLOSE_OVERLAY, {
					bubbles: !0,
					composed: !0
				}));
				return;
			}
			if (this.iframe && n?.contentWindow && n.contentWindow === e.source && t === Vr.FORM_LOADED) {
				this.isLoading = !1;
				return;
			}
			if (this.iframe && n?.contentWindow && n.contentWindow === e.source && _i.isFromEmbedOrigin(e.origin, this.embedUrl)) {
				let t = _i.parseRedirectUrl(e.data);
				if (t) {
					this.hasRedirected === !1 && (this.hasRedirected = !0, _i.navigateTop(t));
					return;
				}
			}
			if (this.iframe && n?.contentWindow && n.contentWindow === e.source && pi.isDonationMessage(e.data)) {
				pi.dispatch(e.data);
				return;
			}
			this.iframe && n?.contentWindow && n.contentWindow === e.source && [
				Vr.DONATION_BUTTON_NEXT,
				Vr.DONATION_BUTTON_BACK,
				Vr.DONATION_GO_TO_STEP
			].includes(e.data.event) && this.iframe.getBoundingClientRect().top < 0 && this.iframe.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest"
			});
		}, this.componentType = an.GIVING_FORM;
	}
	connectedCallback() {
		super.connectedCallback(), window.addEventListener("message", this.receiveMessageEvent);
	}
	disconnectedCallback() {
		window.removeEventListener("message", this.receiveMessageEvent), super.disconnectedCallback();
	}
	willUpdate(e) {
		!this.dataController && this.embedUrl.length === 0 && this.account && (this.dataController = new qr({
			host: this,
			queryFn: () => ei(this.account, this.campaign)
		})), this.embedUrl.length === 0 && (this.embedUrl = this.dataController?.data?.embed_url || "", this.maxWidth = this.dataController?.data?.embed_max_width || "560px", this.isEventTicketsFlow = this.dataController?.data?.is_event_tickets_flow || !1);
	}
	render() {
		return W.isWixEditorPreview() && !this.closable ? this.renderEditorPreviewNotice() : F`
      ${this.showGoalBar ? this.getGivebutterGoalBar() : ""}
      <givebutter-iframe
        ${Bt(this.iframeChanged)}
        src="${this.getEmbedUrl()}"
        error="${wt(this.dataController?.error)}"
        closable="${this.closable}"
        max-width="${this.maxWidth}"
        max-height="${this.maxHeight}"
        footer-class="${this.footerClass}"
        iframe-class="${zr(this.iframeClass, this.closable && this.isEventTicketsFlow && "h-full! w-screen!", this.closable && !this.isEventTicketsFlow && "max-modal-desktop:h-full! w-screen!")}"
        class="${zr("flex flex-col", this.closable && this.isEventTicketsFlow && "h-dvh w-full modal-desktop:max-h-[min(90dvh,725px)]", this.closable && !this.isEventTicketsFlow && "h-dvh modal-desktop:h-auto w-full modal-desktop:w-auto modal-desktop:max-h-[90dvh]")}"
        .overrideIsLoading="${this.isLoading}"
      ></givebutter-iframe>
    `;
	}
	getGivebutterGoalBar() {
		return F`
      <givebutter-goal-bar
        account="${this.account}"
        campaign="${this.campaign}"
        class="${this.iframeClass}"
        size="sm"
        border-width="0"
        max-width="${this.maxWidth}"
        background-color="transparent"
        progress-bar-color="${this.themeColor}"
      ></givebutter-goal-bar>
    `;
	}
	iframeChanged(e) {
		this.iframe = e;
	}
	renderEditorPreviewNotice() {
		return this.previewImageUrl ? (this.previewRetry.start(this.previewImageUrl), vi({
			src: this.previewImageUrl,
			alt: "Givebutter Donation Form preview",
			maxWidth: this.maxWidth || "560px",
			attempt: this.previewRetry.attempt
		})) : yi({
			title: "Givebutter Donation Form",
			description: "Publish your site to preview the live form here.",
			maxWidthPx: 560
		});
	}
	getEmbedUrl() {
		return gi(this.embedUrl, {
			analyticsQueryString: this.analytics.getQueryString(),
			closable: this.closable,
			widgetId: this.widgetId,
			platform: W.getPlatform()
		});
	}
};
H([vt()], bi.prototype, "isLoading", void 0), H([V({
	type: String,
	attribute: "theme-color"
})], bi.prototype, "themeColor", void 0), H([V({
	type: String,
	attribute: "max-width"
})], bi.prototype, "maxWidth", void 0), H([V({
	type: String,
	attribute: "max-height"
})], bi.prototype, "maxHeight", void 0), H([V({
	type: Boolean,
	attribute: "closable"
})], bi.prototype, "closable", void 0), H([V({
	type: Boolean,
	attribute: "show-goal-bar",
	converter: sn._boolean
})], bi.prototype, "showGoalBar", void 0), H([V({
	type: String,
	attribute: "iframe-class"
})], bi.prototype, "iframeClass", void 0), H([V({
	type: String,
	attribute: "footer-class"
})], bi.prototype, "footerClass", void 0), H([V({
	type: String,
	attribute: "preview-image-url"
})], bi.prototype, "previewImageUrl", void 0), H([V({ type: Boolean })], bi.prototype, "isEventTicketsFlow", void 0), bi = H([ht("givebutter-giving-form")], bi);
//#endregion
//#region src/mixins/iframe-emitter.ts
var xi = (e) => {
	class t extends e {
		constructor(...e) {
			super(...e), this.emitIframeMessage = (e) => {
				let t = this.iframe?.shadowRoot, n = K.apiUrl;
				t?.querySelector("iframe")?.contentWindow?.postMessage(e, n);
			};
		}
	}
	return t;
}, Si = (e, t) => {
	let n = e?.parentElement;
	for (; n;) {
		if (n.classList.contains(t)) return n;
		n = n.parentElement;
	}
	return U.error(`Could not find ancestor element with class ${t}`), null;
}, Ci = /* @__PURE__ */ function(e) {
	return e.UNDEFINED = "", e.BUTTON = "button", e.GIVING_FORM = "giving-form", e.SIGNUP_FORM = "signup-form", e.GOAL_BAR = "goal-bar", e;
}({}), wi = /* @__PURE__ */ function(e) {
	return e.PROGRESS_BAR = "progress-bar", e.THERMOMETER = "thermometer", e;
}({}), Ti = /* @__PURE__ */ function(e) {
	return e.STATIC = "static", e.POPUP = "popup", e;
}({}), Ei = /* @__PURE__ */ function(e) {
	return e.SIMPLE = "simple", e.STACKED = "stacked", e.TWO_COLUMN = "two-column", e;
}({}), Di = class extends on {
	constructor() {
		super(), this.config = {}, this.align = "left", this.platform = "", this.refreshToken = "", this.position = "", this.amount = "", this.frequency = "", this.fund = "", this.promo = "", this.markReady = () => {
			this.toggleAttribute("data-ready", !0);
		}, this.componentType = an.DYNAMIC;
	}
	async connectedCallback() {
		if (super.connectedCallback(), this.addEventListener(Ur.READY, this.markReady), this.syncSdkPlatform(), !(!this.account || !this.widgetId)) {
			if (this.lastFetchedAccount = this.account, this.lastFetchedWidgetId = this.widgetId, this.lastFetchedRefreshToken = this.refreshToken, W.getPlatform() === Gt.godaddy && W.isInsideIframe()) {
				let e = window.parent.document.createElement("givebutter-widget");
				e.id = this.widgetId, e.position = this.position, e.align = this.align;
				let t = window.frameElement;
				t?.parentElement?.insertBefore(e, t.nextSibling), !W.isGoDaddyBackoffice() && this.position.length > 0 && Si(t, "widget-html")?.setAttribute("style", "height: 0px;");
				return;
			}
			this.dataController = new qr({
				host: this,
				queryFn: () => $r(this.account, this.widgetId)
			});
		}
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeEventListener(Ur.READY, this.markReady);
	}
	shouldUpdate(e) {
		return e.has("platform") && this.syncSdkPlatform(), W.isWixEditorPreview() && (!this.account || !this.widgetId) ? !0 : super.shouldUpdate(e);
	}
	willUpdate(e) {
		super.willUpdate(e), e.has("platform") && this.syncSdkPlatform(), (!this.account || !this.widgetId) && this.clearDataController();
	}
	updated(e) {
		super.updated(e), !(!(this.account !== this.lastFetchedAccount || this.widgetId !== this.lastFetchedWidgetId || this.refreshToken !== this.lastFetchedRefreshToken) || !this.account || !this.widgetId) && (this.lastFetchedAccount = this.account, this.lastFetchedWidgetId = this.widgetId, this.lastFetchedRefreshToken = this.refreshToken, this.dataController ? this.dataController.refetch() : this.dataController = new qr({
			host: this,
			queryFn: () => $r(this.account, this.widgetId)
		}));
	}
	render() {
		let e = this.dataController?.data?.type;
		if (e) {
			if (e === "button") return this.getButton();
			if (e === "giving-form") return this.getGivingForm();
			if (e === "signup-form") return this.getSignupForm();
			if (e === "goal-bar") return this.getGoalBar();
		}
		return !e && W.isWixEditorPreview() ? this.dataController?.errorStatus === 404 ? this.renderWixDeletedState() : this.dataController?.errorStatus === 422 ? this.renderWixUnavailableState() : this.renderWixEmptyState() : F``;
	}
	syncSdkPlatform() {
		this.platform && Object.values(Gt).includes(this.platform) && (K.platform = this.platform);
	}
	clearDataController() {
		this.toggleAttribute("data-ready", !1), this.dataController?.destroy(), this.dataController = void 0, this.lastFetchedAccount = void 0, this.lastFetchedWidgetId = void 0;
	}
	getButton() {
		let e = this.dataController?.data?.config, t = this.dataController?.data?.embed_max_width ?? "560px", n = this.dataController?.data?.is_event_tickets_flow ?? !1;
		return F`<givebutter-button
      id="${this.widgetId}"
      account="${this.account}"
      campaign="${e.campaign}"
      embed-url="${wt(this.getEmbedUrl())}"
      icon="${e.icon}"
      icon-position="${e.iconPosition}"
      label="${e.label}"
      label-color="${e.labelColor}"
      drop-shadow="${e.dropShadow}"
      border-color="${e.borderColor}"
      border-width="${e.borderWidth}"
      border-radius="${e.borderRadius}"
      background-color="${e.backgroundColor}"
      position="${this.position.length > 0 ? this.position : e.position}"
      max-width="${t}"
      button-class="${this.getAlignClass()}"
      .isEventTicketsFlow="${n}"
    ></givebutter-button>`;
	}
	getGivingForm() {
		let e = this.dataController?.data?.config, t = this.dataController?.data?.embed_max_width ?? "560px", n = this.dataController?.data?.is_event_tickets_flow ?? !1;
		return F`<givebutter-giving-form
      id="${this.widgetId}"
      account="${this.account}"
      campaign="${e.campaign}"
      theme-color="${wt(this.dataController?.data?.theme_color)}"
      embed-url="${wt(this.getEmbedUrl())}"
      max-width="${t}"
      iframe-class="${this.getAlignClass()}"
      footer-class="${this.getAlignClass()}"
      show-goal-bar="${e.showGoalBar}"
      preview-image-url="${wt(this.dataController?.data?.preview_image_url)}"
      .isEventTicketsFlow="${n}"
    ></givebutter-giving-form>`;
	}
	getSignupForm() {
		let e = this.dataController?.data?.config;
		return F`<givebutter-signup-form
      id="${this.widgetId}"
      account="${this.account}"
      channel="${e.channel}"
      type="${e.type}"
      embed-url="${wt(this.dataController?.data?.embed_url)}"
      form-class="${this.getAlignClass()}"
      title="${e.title}"
      description="${e.description}"
      border-radius="${e.borderRadius}"
      layout="${e.layout}"
      button-text="${e.buttonText}"
      button-text-color="${e.buttonTextColor}"
      button-background-color="${e.buttonBackgroundColor}"
      open-delay="${e.openDelay}"
      image="${e.image}"
      image-sizing="${e.imageSizing}"
      preview-image-url="${wt(this.dataController?.data?.preview_image_url)}"
    ></givebutter-signup-form>`;
	}
	getGoalBar() {
		let e = this.dataController?.data?.config;
		return F`<givebutter-goal-bar
      id="${this.widgetId}"
      account="${this.account}"
      campaign="${e.campaign}"
      goal="${wt(this.dataController?.data?.goal)}"
      raised="${wt(this.dataController?.data?.raised)}"
      raised-percentage="${wt(this.dataController?.data?.raised_percentage)}"
      type="${e.type}"
      text-color="${e.textColor}"
      progress-bar-color="${e.progressBarColor}"
      border-color="${e.borderColor}"
      border-width="${e.borderWidth}"
      border-radius="${e.borderRadius}"
      background-color="${e.backgroundColor}"
      size="${e.size}"
      show-goal-amount="${e.showGoalAmount}"
      show-amount-raised="${e.showAmountRaised}"
      show-raised-percentage="${e.showRaisedPercentage}"
    ></givebutter-goal-bar>`;
	}
	renderWixEmptyState() {
		return yi({
			title: "Givebutter Widget",
			description: F`Click to configure Settings ${Ai} for this element.`,
			maxWidthPx: 420
		});
	}
	renderWixDeletedState() {
		return F`
      <div class="flex h-full w-full items-center justify-center">
        <div
          class="mx-auto flex flex-col items-center gap-1.5 rounded-2xl border border-dashed border-gray-300 bg-gray-50 p-10 text-center font-sans"
        >
          ${Oi}
          <p class="text-sm text-gray-500">Widget deleted</p>
        </div>
      </div>
    `;
	}
	renderWixUnavailableState() {
		return F`
      <div class="flex h-full w-full items-center justify-center">
        <div
          class="mx-auto flex max-w-[420px] flex-col items-center gap-1.5 rounded-2xl border border-dashed border-gray-300 bg-gray-50 p-10 text-center font-sans"
        >
          ${ki}
          <p class="text-base font-semibold text-gray-900">Widget unavailable</p>
          <p class="text-sm text-gray-500">This widget can't be loaded on this site.</p>
        </div>
      </div>
    `;
	}
	getAlignClass() {
		switch (this.align) {
			case "center": return "mx-auto";
			case "right": return "ml-auto";
			case "left": return "mr-auto";
			default: return "";
		}
	}
	getEmbedUrl() {
		let e = this.dataController?.data?.embed_url;
		if (!e) return;
		let t = new URL(e), n = new URLSearchParams(t.search);
		return this.amount.length > 0 && n.set("amount", this.amount), this.frequency.length > 0 && n.set("frequency", this.frequency), this.fund.length > 0 && n.set("fund", this.fund), this.promo.length > 0 && n.set("promo", this.promo), t.search = n.toString(), t.toString();
	}
};
H([vt()], Di.prototype, "config", void 0), H([V({
	type: String,
	attribute: "align"
})], Di.prototype, "align", void 0), H([V({
	type: String,
	attribute: "platform"
})], Di.prototype, "platform", void 0), H([V({
	type: String,
	attribute: "refresh-token"
})], Di.prototype, "refreshToken", void 0), H([V({
	type: String,
	attribute: "position"
})], Di.prototype, "position", void 0), H([V({
	type: String,
	attribute: "amount"
})], Di.prototype, "amount", void 0), H([V({
	type: String,
	attribute: "frequency"
})], Di.prototype, "frequency", void 0), H([V({
	type: String,
	attribute: "fund"
})], Di.prototype, "fund", void 0), H([V({
	type: String,
	attribute: "promo"
})], Di.prototype, "promo", void 0), Di = H([ht("givebutter-widget")], Di);
var Oi = F`
  <svg class="h-8 w-8 text-[#B42318]" viewBox="0 0 384 512" fill="currentColor" aria-hidden="true">
    <!--!Font Awesome Free v6 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
    <path
      d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    />
  </svg>
`, ki = F`
  <svg class="h-8 w-8 text-[#ffb730]" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 4.5a1.25 1.25 0 0 1 1.25 1.25v5a1.25 1.25 0 0 1-2.5 0v-5A1.25 1.25 0 0 1 12 6.5Zm0 9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
    />
  </svg>
`, Ai = F`
  <svg
    class="-mb-px inline-block h-4 w-4 align-[-0.125em]"
    viewBox="0 0 640 640"
    fill="currentColor"
    aria-hidden="true"
  >
    <!--!Font Awesome Free v7.3.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
    <path
      d="M259.1 73.5C262.1 58.7 275.2 48 290.4 48L350.2 48C365.4 48 378.5 58.7 381.5 73.5L396 143.5C410.1 149.5 423.3 157.2 435.3 166.3L503.1 143.8C517.5 139 533.3 145 540.9 158.2L570.8 210C578.4 223.2 575.7 239.8 564.3 249.9L511 297.3C511.9 304.7 512.3 312.3 512.3 320C512.3 327.7 511.8 335.3 511 342.7L564.4 390.2C575.8 400.3 578.4 417 570.9 430.1L541 481.9C533.4 495 517.6 501.1 503.2 496.3L435.4 473.8C423.3 482.9 410.1 490.5 396.1 496.6L381.7 566.5C378.6 581.4 365.5 592 350.4 592L290.6 592C275.4 592 262.3 581.3 259.3 566.5L244.9 496.6C230.8 490.6 217.7 482.9 205.6 473.8L137.5 496.3C123.1 501.1 107.3 495.1 99.7 481.9L69.8 430.1C62.2 416.9 64.9 400.3 76.3 390.2L129.7 342.7C128.8 335.3 128.4 327.7 128.4 320C128.4 312.3 128.9 304.7 129.7 297.3L76.3 249.8C64.9 239.7 62.3 223 69.8 209.9L99.7 158.1C107.3 144.9 123.1 138.9 137.5 143.7L205.3 166.2C217.4 157.1 230.6 149.5 244.6 143.4L259.1 73.5zM320.3 400C364.5 399.8 400.2 363.9 400 319.7C399.8 275.5 363.9 239.8 319.7 240C275.5 240.2 239.8 276.1 240 320.3C240.2 364.5 276.1 400.2 320.3 400z"
    />
  </svg>
`, Q = class extends xi(on) {
	constructor() {
		super(), this.contentRef = Lt(), this.isLoading = !0, this.isOpen = !1, this.channel = "email", this.type = Ti.STATIC, this.openDelay = 5e3, this.formClass = "", this.iframeClass = "", this.footerClass = "", this.title = "", this.description = "", this.borderRadius = 0, this.layout = "simple", this.buttonText = "Subscribe", this.buttonTextColor = "", this.buttonBackgroundColor = "", this.image = "", this.imageSizing = "cover", this.previewImageUrl = "", this.previewRetry = new Yr(this), this.observer = new Ct(this, {
			config: {
				childList: !0,
				subtree: !0
			},
			target: document.querySelector("[data-overlay-outer-wrapper]"),
			callback: (e) => {
				let t = e[0];
				t && (this.isOpen = t.removedNodes.length <= 0);
			}
		}), this.receiveMessageEvent = (e) => {
			e.data === Vr.CLOSE_MODAL && this.shadowRoot?.dispatchEvent(new Event(Hr.CLOSE_OVERLAY, {
				bubbles: !0,
				composed: !0
			})), this.iframe && e.data === Vr.FORM_LOADED && (this.isLoading = !1);
		}, this.componentType = an.SIGNUP_FORM;
	}
	connectedCallback() {
		super.connectedCallback(), window.addEventListener("message", this.receiveMessageEvent);
	}
	disconnectedCallback() {
		window.removeEventListener("message", this.receiveMessageEvent), super.disconnectedCallback();
	}
	willUpdate(e) {
		!this.dataController && this.embedUrl.length === 0 && this.account && (this.dataController = new qr({
			host: this,
			queryFn: () => $r(this.account, this.id)
		})), this.embedUrl.length === 0 && (this.embedUrl = this.dataController?.data?.embed_url || "");
	}
	firstUpdated() {
		this.contentRef.value && this.observer.observe(this.contentRef.value);
	}
	updated(e) {
		e.has("isLoading") ? (this.refreshSubmitButtonSettings(), this.refreshChannel()) : ((e.has("buttonText") || e.has("buttonTextColor") || e.has("buttonBackgroundColor")) && this.refreshSubmitButtonSettings(), e.has("channel") && this.refreshChannel());
	}
	render() {
		return W.isWixEditorPreview() ? this.renderEditorPreviewNotice() : this.type === Ti.STATIC ? this.renderForm() : this.renderPopup();
	}
	renderEditorPreviewNotice() {
		return this.previewImageUrl ? (this.previewRetry.start(this.previewImageUrl), vi({
			src: this.previewImageUrl,
			alt: "Givebutter Signup Form preview",
			maxWidth: this.layout === Ei.TWO_COLUMN ? "620px" : "420px",
			attempt: this.previewRetry.attempt
		})) : yi({
			title: "Givebutter Signup Form",
			description: "Publish your site to preview the live form here.",
			maxWidthPx: 420
		});
	}
	renderPopup() {
		return F`
      <givebutter-dialog
        trigger=${xt.TIMED}
        open-delay=${this.openDelay}
        hide-on-outside-click
        close-button
      >
        <div slot="content" ${Bt(this.contentRef)}>${this.isOpen ? this.renderForm() : ""}</div>
      </givebutter-dialog>
    `;
	}
	renderForm() {
		return F`
      <div
        class="${this.getFormClass()} bg-white text-left md:shadow-md"
        style=${Ut(this.getFormStyles())}
      >
        ${this.layout === "simple" ? "" : F`<div
                class=${this.getBannerClass()}
                style=${Ut(this.getBannerStyles())}
              ></div>`}
        <div class="grow overflow-auto p-6">
          <h1 class="text-2xl font-semibold text-black">${this.title}</h1>
          <p class="mt-1 text-gray-700">${this.description}</p>
          <givebutter-iframe
            ${Bt(this.iframeChanged)}
            src="${this.getEmbedUrl()}"
            error="${wt(this.dataController?.error)}"
            iframe-class="${this.iframeClass}"
            footer-class="${this.footerClass}"
            .overrideIsLoading="${this.isLoading}"
            .showPoweredByGivebutter="${!1}"
            .showBorder="${!1}"
          ></givebutter-iframe>
        </div>
      </div>
    `;
	}
	getBannerClass() {
		return zr(this.layout === Ei.STACKED && "h-32", this.layout === Ei.TWO_COLUMN && "w-64");
	}
	getBannerStyles() {
		return {
			"background-image": `url(${this.image})`,
			"background-size": {
				fill: "cover",
				fit: "contain",
				stretch: "100% 100%"
			}[this.imageSizing] || "cover",
			"background-repeat": this.imageSizing === "fit" ? "no-repeat" : "repeat",
			"background-position": "center"
		};
	}
	getFormClass() {
		let e = this.layout === Ei.TWO_COLUMN, t = this.layout === Ei.STACKED;
		return zr((e || t) && "flex flex-col gap-1", e ? "sm:flex-row max-w-[620px]" : "max-w-[420px]", this.type === Ti.STATIC && this.formClass, this.type === Ti.POPUP && "modal-desktop:overflow-auto max-h-dvh modal-desktop:max-h-[90vh]");
	}
	getFormStyles() {
		return { borderRadius: `${this.borderRadius}px` };
	}
	iframeChanged(e) {
		e && (this.iframe = e, this.refreshSubmitButtonSettings(), this.refreshChannel());
	}
	refreshChannel() {
		this.emitIframeMessage({
			event: Br.CHANNEL_SETTINGS,
			props: { channel: this.channel }
		});
	}
	refreshSubmitButtonSettings() {
		this.emitIframeMessage({
			event: Br.BUTTON_SETTINGS,
			props: {
				text: this.buttonText,
				textColor: this.buttonTextColor,
				backgroundColor: this.buttonBackgroundColor
			}
		});
	}
	getEmbedUrl() {
		return qt.isValidEmbedUrl(this.embedUrl) ? this.embedUrl : "";
	}
};
H([vt()], Q.prototype, "isLoading", void 0), H([V({
	type: String,
	attribute: "channel"
})], Q.prototype, "channel", void 0), H([V({
	type: String,
	attribute: "type"
})], Q.prototype, "type", void 0), H([V({
	type: Number,
	attribute: "open-delay"
})], Q.prototype, "openDelay", void 0), H([V({
	type: String,
	attribute: "form-class"
})], Q.prototype, "formClass", void 0), H([V({
	type: String,
	attribute: "iframe-class"
})], Q.prototype, "iframeClass", void 0), H([V({
	type: String,
	attribute: "footer-class"
})], Q.prototype, "footerClass", void 0), H([V({
	type: String,
	attribute: "title"
})], Q.prototype, "title", void 0), H([V({
	type: String,
	attribute: "description"
})], Q.prototype, "description", void 0), H([V({
	type: Number,
	attribute: "border-radius"
})], Q.prototype, "borderRadius", void 0), H([V({
	type: String,
	attribute: "layout"
})], Q.prototype, "layout", void 0), H([V({
	type: String,
	attribute: "button-text"
})], Q.prototype, "buttonText", void 0), H([V({
	type: String,
	attribute: "button-text-color"
})], Q.prototype, "buttonTextColor", void 0), H([V({
	type: String,
	attribute: "button-background-color"
})], Q.prototype, "buttonBackgroundColor", void 0), H([V({
	type: String,
	attribute: "image"
})], Q.prototype, "image", void 0), H([V({
	type: String,
	attribute: "image-sizing"
})], Q.prototype, "imageSizing", void 0), H([V({
	type: String,
	attribute: "preview-image-url"
})], Q.prototype, "previewImageUrl", void 0), Q = H([ht("givebutter-signup-form")], Q);
//#endregion
//#region src/mixins/previewable-component.ts
var ji = class extends on {
	constructor(...e) {
		super(...e), this.preview = !1;
	}
	shouldUpdate(e) {
		if (this.preview) {
			if (!qt.isPreviewHostAllowed()) throw Error("[widgets-core] Preview mode is only available on Givebutter-controlled surfaces.");
			return !0;
		}
		return super.shouldUpdate(e);
	}
};
H([V({
	type: Boolean,
	attribute: "preview",
	converter: sn._boolean
})], ji.prototype, "preview", void 0);
//#endregion
//#region src/utils/animator.ts
var Mi = class e {
	static {
		this.ANIMATION_STEP_INTERVAL = 25;
	}
	static animate(t, n, r, i) {
		if (t >= n && typeof i == "function") {
			i();
			return;
		}
		let a = n / 100, o = Math.min(t + a, n);
		r(o), o < n && setTimeout(() => e.animate(o, n, r, i), e.ANIMATION_STEP_INTERVAL);
	}
}, Ni = /* @__PURE__ */ new WeakMap(), Pi = 0, Fi = /* @__PURE__ */ new Map(), Ii = /* @__PURE__ */ new WeakSet(), Li = () => new Promise((e) => requestAnimationFrame(e)), Ri = (e, t) => {
	let n = e - t;
	return n === 0 ? void 0 : n;
}, zi = (e, t) => {
	let n = e / t;
	return n === 1 ? void 0 : n;
}, Bi = {
	left: (e, t) => {
		let n = Ri(e, t);
		return {
			value: n,
			transform: n == null || isNaN(n) ? void 0 : `translateX(${n}px)`
		};
	},
	top: (e, t) => {
		let n = Ri(e, t);
		return {
			value: n,
			transform: n == null || isNaN(n) ? void 0 : `translateY(${n}px)`
		};
	},
	width: (e, t) => {
		let n;
		t === 0 && (t = 1, n = { width: "1px" });
		let r = zi(e, t);
		return {
			value: r,
			overrideFrom: n,
			transform: r == null || isNaN(r) ? void 0 : `scaleX(${r})`
		};
	},
	height: (e, t) => {
		let n;
		t === 0 && (t = 1, n = { height: "1px" });
		let r = zi(e, t);
		return {
			value: r,
			overrideFrom: n,
			transform: r == null || isNaN(r) ? void 0 : `scaleY(${r})`
		};
	}
}, Vi = {
	duration: 333,
	easing: "ease-in-out"
}, Hi = [
	"left",
	"top",
	"width",
	"height",
	"opacity",
	"color",
	"background"
], Ui = /* @__PURE__ */ new WeakMap(), Wi = Ot(class extends It {
	constructor(e) {
		if (super(e), this.t = !1, this.i = null, this.o = null, this.h = !0, this.shouldLog = !1, e.type === Dt.CHILD) throw Error("The `animate` directive must be used in attribute position.");
		this.createFinished();
	}
	createFinished() {
		this.resolveFinished?.(), this.finished = new Promise((e) => {
			this.l = e;
		});
	}
	async resolveFinished() {
		this.l?.(), this.l = void 0;
	}
	render(e) {
		return L;
	}
	getController() {
		return Ni.get(this.u);
	}
	isDisabled() {
		return this.options.disabled || this.getController()?.disabled;
	}
	update(e, [t]) {
		let n = this.u === void 0;
		return n && (this.u = e.options?.host, this.u.addController(this), this.u.updateComplete.then((e) => this.t = !0), this.element = e.element, Ui.set(this.element, this)), this.optionsOrCallback = t, (n || typeof t != "function") && this.m(t), this.render(t);
	}
	m(e) {
		e ??= {};
		let t = this.getController();
		t !== void 0 && ((e = {
			...t.defaultOptions,
			...e
		}).keyframeOptions = {
			...t.defaultOptions.keyframeOptions,
			...e.keyframeOptions
		}), e.properties ??= Hi, this.options = e;
	}
	p() {
		let e = {}, t = this.element.getBoundingClientRect(), n = getComputedStyle(this.element);
		return this.options.properties.forEach((r) => {
			let i = t[r] ?? (Bi[r] ? void 0 : n[r]), a = Number(i);
			e[r] = isNaN(a) ? i + "" : a;
		}), e;
	}
	v() {
		let e, t = !0;
		return this.options.guard && (e = this.options.guard(), t = ((e, t) => {
			if (Array.isArray(e)) {
				if (Array.isArray(t) && t.length === e.length && e.every((e, n) => e === t[n])) return !1;
			} else if (t === e) return !1;
			return !0;
		})(e, this._)), this.h = this.t && !this.isDisabled() && !this.isAnimating() && t && this.element.isConnected, this.h && (this._ = Array.isArray(e) ? Array.from(e) : e), this.h;
	}
	hostUpdate() {
		typeof this.optionsOrCallback == "function" && this.m(this.optionsOrCallback()), this.v() && (this.A = this.p(), this.i = this.i ?? this.element.parentNode, this.o = this.element.nextSibling);
	}
	async hostUpdated() {
		if (!this.h || !this.element.isConnected || this.options.skipInitial && !this.isHostRendered) return;
		let e;
		this.prepare(), await Li;
		let t = this.P(), n = this.V(this.options.keyframeOptions, t), r = this.p();
		if (this.A !== void 0) {
			let { from: n, to: i } = this.O(this.A, r, t);
			this.log("measured", [
				this.A,
				r,
				n,
				i
			]), e = this.calculateKeyframes(n, i);
		} else {
			let n = Fi.get(this.options.inId);
			if (n) {
				Fi.delete(this.options.inId);
				let { from: i, to: a } = this.O(n, r, t);
				e = this.calculateKeyframes(i, a), e = this.options.in ? [
					{
						...this.options.in[0],
						...e[0]
					},
					...this.options.in.slice(1),
					e[1]
				] : e, Pi++, e.forEach((e) => e.zIndex = Pi);
			} else this.options.in && (e = [...this.options.in, {}]);
		}
		this.animate(e, n);
	}
	resetStyles() {
		this.j !== void 0 && (this.element.setAttribute("style", this.j ?? ""), this.j = void 0);
	}
	commitStyles() {
		this.j = this.element.getAttribute("style"), this.webAnimation?.commitStyles(), this.webAnimation?.cancel();
	}
	reconnected() {}
	async disconnected() {
		if (!this.h || (this.options.id !== void 0 && Fi.set(this.options.id, this.A), this.options.out === void 0)) return;
		if (this.prepare(), await Li(), this.i?.isConnected) {
			let e = this.o && this.o.parentNode === this.i ? this.o : null;
			if (this.i.insertBefore(this.element, e), this.options.stabilizeOut) {
				let e = this.p();
				this.log("stabilizing out");
				let t = this.A.left - e.left, n = this.A.top - e.top;
				getComputedStyle(this.element).position !== "static" || t === 0 && n === 0 || (this.element.style.position = "relative"), t !== 0 && (this.element.style.left = t + "px"), n !== 0 && (this.element.style.top = n + "px");
			}
		}
		let e = this.V(this.options.keyframeOptions);
		await this.animate(this.options.out, e), this.element.remove();
	}
	prepare() {
		this.createFinished();
	}
	start() {
		this.options.onStart?.(this);
	}
	didFinish(e) {
		e && this.options.onComplete?.(this), this.A = void 0, this.animatingProperties = void 0, this.frames = void 0, this.resolveFinished();
	}
	P() {
		let e = [];
		for (let t = this.element.parentNode; t; t = t?.parentNode) {
			let n = Ui.get(t);
			n && !n.isDisabled() && n && e.push(n);
		}
		return e;
	}
	get isHostRendered() {
		let e = Ii.has(this.u);
		return e || this.u.updateComplete.then(() => {
			Ii.add(this.u);
		}), e;
	}
	V(e, t = this.P()) {
		let n = { ...Vi };
		return t.forEach((e) => Object.assign(n, e.options.keyframeOptions)), Object.assign(n, e), n;
	}
	O(e, t, n) {
		e = { ...e }, t = { ...t };
		let r = n.map((e) => e.animatingProperties).filter((e) => e !== void 0), i = 1, a = 1;
		return r.length > 0 && (r.forEach((e) => {
			e.width && (i /= e.width), e.height && (a /= e.height);
		}), e.left !== void 0 && t.left !== void 0 && (e.left = i * e.left, t.left = i * t.left), e.top !== void 0 && t.top !== void 0 && (e.top = a * e.top, t.top = a * t.top)), {
			from: e,
			to: t
		};
	}
	calculateKeyframes(e, t, n = !1) {
		let r = {}, i = {}, a = !1, o = {};
		for (let n in t) {
			let s = e[n], c = t[n];
			if (n in Bi) {
				let e = Bi[n];
				if (s === void 0 || c === void 0) continue;
				let t = e(s, c);
				t.transform !== void 0 && (o[n] = t.value, a = !0, r.transform = `${r.transform ?? ""} ${t.transform}`, t.overrideFrom !== void 0 && Object.assign(r, t.overrideFrom));
			} else s !== c && s !== void 0 && c !== void 0 && (a = !0, r[n] = s, i[n] = c);
		}
		return r.transformOrigin = i.transformOrigin = n ? "center center" : "top left", this.animatingProperties = o, a ? [r, i] : void 0;
	}
	async animate(e, t = this.options.keyframeOptions) {
		this.start(), this.frames = e;
		let n = !1;
		if (!this.isAnimating() && !this.isDisabled() && (this.options.onFrames && (this.frames = e = this.options.onFrames(this), this.log("modified frames", e)), e !== void 0)) {
			this.log("animate", [e, t]), n = !0, this.webAnimation = this.element.animate(e, t);
			let r = this.getController();
			r?.add(this);
			try {
				await this.webAnimation.finished;
			} catch {}
			r?.remove(this);
		}
		return this.didFinish(n), n;
	}
	isAnimating() {
		return this.webAnimation?.playState === "running" || this.webAnimation?.pending;
	}
	log(e, t) {
		this.shouldLog && !this.isDisabled() && console.log(e, this.options.id, t);
	}
}), Gi = class {
	static toLocale(e, t = !0) {
		return e ||= 0, t || (e = Math.round(e)), e.toLocaleString();
	}
};
//#endregion
//#region src/components/partials/progress-bar.ts
function Ki({ raised: e, borderColor: t, borderWidth: n, borderRadius: r, backgroundColor: i, padding: a, progressBarColor: o, raisedPercentage: s, showAmountRaised: c, showRaisedPercentage: l, showGoalAmount: u, goal: d, textColor: f, size: p, areDisplayOptionsDisabled: m, animationDuration: h }) {
	let g = zr(c ? "block" : "hidden", p === "sm" && "text-xl", p === "md" && "text-2xl", p === "lg" && "text-3xl"), ee = () => ({
		color: f,
		"border-color": t,
		"border-width": n + "px",
		"border-radius": r + "px",
		padding: a + "px",
		"background-color": i
	}), te = zr(p === "sm" && "h-4", p === "md" && "h-6", p === "lg" && "h-8");
	return F`
    <div
      class="m-auto flex w-full rounded-md font-medium"
      style=${Ut(ee())}
    >
      <div class="flex flex-1 flex-col gap-1">
        <div class="flex items-baseline gap-x-2">
          <div class="flex flex-1 flex-wrap">
            <p class="${g} leading-tight">
              <span id="raised">${"$" + Gi.toLocale(e, !1)}</span>
            </p>
          </div>
          <div class="mb-1 flex items-end gap-x-2">
            <p id="goal" class="text-base leading-tight font-normal">
              ${l ? Gi.toLocale(s) + "%" : ""}
              ${l && u ? " of " : ""}
              ${u ? "$" + Gi.toLocale(d) : ""}
              ${m || !u ? "" : "goal"}
            </p>
          </div>
        </div>
        <div
          class="${te} flex rounded-full border border-gray-300 bg-white p-1"
        >
          <div
            ${Wi({
		keyframeOptions: { duration: h },
		properties: ["width"],
		in: [{ width: "0%" }]
	})}
            class="h-full max-w-full rounded-full"
            style=${Ut({
		width: (s > 100 ? 100 : s) + "%",
		"background-color": o
	})}
          ></div>
        </div>
      </div>
    </div>
  `;
}
//#endregion
//#region src/components/partials/thermometer-svg.ts
function qi(e, t, n, r) {
	let i = (e) => n >= e ? t : a, a = r || "#DEDEDE";
	return F`
    <svg width="132" height="370" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_3_3385)">
        <mask
          id="path-1-outside-1_3_3385"
          maskUnits="userSpaceOnUse"
          x="12.919"
          y="1.973"
          width="113"
          height="359"
          fill="#000"
        >
          <path fill="#fff" d="M12.919 1.973h113v359h-113z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M69.46 5.973c-16.121 0-29.19 13.069-29.19 29.19V260.01c-14.08 9.425-23.351 25.476-23.351 43.693 0 29.017 23.523 52.54 52.54 52.54 29.018 0 52.541-23.523 52.541-52.54 0-18.217-9.271-34.268-23.351-43.693V35.162c0-16.12-13.069-29.189-29.19-29.189Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M69.46 5.973c-16.121 0-29.19 13.069-29.19 29.19V260.01c-14.08 9.425-23.351 25.476-23.351 43.693 0 29.017 23.523 52.54 52.54 52.54 29.018 0 52.541-23.523 52.541-52.54 0-18.217-9.271-34.268-23.351-43.693V35.162c0-16.12-13.069-29.189-29.19-29.189Z"
          fill="url(#thermometerGradient)"
        />
        <path
          d="m40.27 260.01 2.165 3.234 1.727-1.156v-2.078H40.27Zm58.379 0h-3.892v2.078l1.727 1.156 2.165-3.234ZM44.162 35.162c0-13.971 11.326-25.297 25.298-25.297V2.08c-18.27 0-33.082 14.811-33.082 33.081h7.784Zm0 224.848V35.162h-7.784V260.01h7.784Zm-23.351 43.693c0-16.864 8.577-31.725 21.624-40.459l-4.33-6.468c-15.113 10.116-25.078 27.357-25.078 46.927h7.784Zm48.649 48.648c-26.868 0-48.65-21.78-48.65-48.648h-7.783c0 31.167 25.266 56.432 56.433 56.432v-7.784Zm48.648-48.648c0 26.868-21.78 48.648-48.648 48.648v7.784c31.166 0 56.432-25.265 56.432-56.432h-7.784Zm-21.624-40.459c13.047 8.734 21.624 23.595 21.624 40.459h7.784c0-19.57-9.965-36.811-25.078-46.927l-4.33 6.468ZM94.757 35.162V260.01h7.784V35.162h-7.784ZM69.46 9.865c13.97 0 25.297 11.326 25.297 25.297h7.784c0-18.27-14.811-33.08-33.081-33.08v7.783Z"
          fill="${a}"
          mask="url(#path-1-outside-1_3_3385)"
        />
      </g>
      <g filter="url(#filter1_d_3_3385)" clip-path="url(#clip0_3_3385)">
        <path
          d="M4.95 29.142v8.317H3.31v-6.425l-1.973.628v-1.295l3.438-1.225h.177Zm8.29 3.437v1.437c0 .623-.067 1.161-.2 1.613-.133.449-.325.818-.575 1.106a2.273 2.273 0 0 1-.884.633 3.045 3.045 0 0 1-1.14.206 3.35 3.35 0 0 1-.935-.126 2.354 2.354 0 0 1-.781-.405 2.571 2.571 0 0 1-.593-.69 3.538 3.538 0 0 1-.377-1.003 6.1 6.1 0 0 1-.13-1.334V32.58c0-.623.066-1.157.199-1.602.137-.448.329-.815.576-1.1.25-.285.547-.494.89-.627a3.045 3.045 0 0 1 1.14-.205c.334 0 .643.043.928.13.29.084.55.216.782.394.231.179.43.409.592.69.164.277.29.61.377.998.087.384.13.824.13 1.322Zm-1.648 1.654v-1.876c0-.3-.017-.562-.051-.787a2.306 2.306 0 0 0-.143-.57 1.203 1.203 0 0 0-.239-.387.87.87 0 0 0-.325-.217 1.145 1.145 0 0 0-.405-.069c-.186 0-.351.037-.496.109a.922.922 0 0 0-.359.348 1.872 1.872 0 0 0-.228.627c-.05.258-.074.574-.074.946v1.876c0 .3.015.564.046.792.034.228.083.424.148.587.068.16.148.291.24.394a.874.874 0 0 0 .324.216c.126.046.263.069.41.069.183 0 .345-.036.485-.109a.953.953 0 0 0 .365-.353c.103-.163.179-.376.228-.639.05-.262.074-.581.074-.957Zm8.352-1.654v1.437c0 .623-.066 1.161-.2 1.613-.132.449-.324.818-.575 1.106a2.273 2.273 0 0 1-.884.633 3.046 3.046 0 0 1-1.14.206 3.35 3.35 0 0 1-.935-.126 2.353 2.353 0 0 1-.78-.405 2.57 2.57 0 0 1-.594-.69 3.536 3.536 0 0 1-.376-1.003 6.101 6.101 0 0 1-.131-1.334V32.58c0-.623.066-1.157.2-1.602.136-.448.328-.815.575-1.1.251-.285.547-.494.89-.627a3.045 3.045 0 0 1 1.14-.205c.334 0 .644.043.929.13.289.084.55.216.781.394.232.179.43.409.593.69.163.277.289.61.376.998.088.384.131.824.131 1.322Zm-1.647 1.654v-1.876c0-.3-.017-.562-.052-.787a2.306 2.306 0 0 0-.142-.57 1.203 1.203 0 0 0-.24-.387.87.87 0 0 0-.325-.217 1.145 1.145 0 0 0-.404-.069c-.187 0-.352.037-.496.109a.922.922 0 0 0-.36.348 1.872 1.872 0 0 0-.227.627c-.05.258-.075.574-.075.946v1.876c0 .3.016.564.046.792.034.228.084.424.148.587.069.16.148.291.24.394a.875.875 0 0 0 .325.216c.125.046.262.069.41.069.183 0 .344-.036.485-.109a.953.953 0 0 0 .364-.353c.103-.163.18-.376.229-.639.049-.262.074-.581.074-.957Zm2.742-3.039v-.439c0-.315.068-.602.205-.86.137-.26.338-.466.604-.622.267-.156.593-.234.981-.234.4 0 .732.078.998.234.27.156.47.363.604.621.137.259.205.546.205.861v.44c0 .307-.068.59-.205.849a1.517 1.517 0 0 1-.599.62c-.266.157-.594.235-.986.235-.395 0-.728-.078-.998-.234a1.555 1.555 0 0 1-.604-.621 1.787 1.787 0 0 1-.205-.85Zm1.089-.439v.44c0 .132.024.26.074.381a.712.712 0 0 0 .24.29c.11.073.243.11.398.11a.679.679 0 0 0 .4-.11.685.685 0 0 0 .228-.29c.049-.122.074-.249.074-.382v-.439c0-.14-.027-.27-.08-.388a.653.653 0 0 0-.633-.405.666.666 0 0 0-.627.405.993.993 0 0 0-.074.388Zm2.879 5.108v-.439a1.8 1.8 0 0 1 .205-.855c.14-.258.344-.466.61-.621.27-.156.6-.234.992-.234.395 0 .726.078.992.234.266.155.467.363.604.621a1.8 1.8 0 0 1 .206.855v.44a1.8 1.8 0 0 1-.206.854 1.517 1.517 0 0 1-.598.622c-.266.156-.595.233-.987.233-.395 0-.727-.077-.997-.233a1.586 1.586 0 0 1-.616-.622 1.8 1.8 0 0 1-.205-.855Zm1.094-.439v.44c0 .136.03.265.092.387.06.122.144.218.25.29.11.073.238.109.382.109.183 0 .325-.036.428-.108a.544.544 0 0 0 .21-.291c.043-.122.064-.251.064-.388v-.439a.918.918 0 0 0-.08-.382.666.666 0 0 0-.633-.404.67.67 0 0 0-.4.114.68.68 0 0 0-.233.29.918.918 0 0 0-.08.382Zm1.118-5.08-4.054 6.488-.798-.422 4.054-6.487.798.422Z"
          fill="${i(100)}"
        />
        <path
          d="M68.487 33.46h31.135"
          stroke="${a}"
          stroke-width="1.946"
          stroke-linecap="round"
        />
        <path
          d="M2.111 61.238h.109c.456 0 .847-.055 1.174-.165a2.1 2.1 0 0 0 .815-.49c.213-.213.371-.474.474-.782.102-.311.154-.665.154-1.06v-1.574c0-.3-.03-.564-.092-.792a1.58 1.58 0 0 0-.25-.564 1.068 1.068 0 0 0-.377-.342.966.966 0 0 0-.467-.114.87.87 0 0 0-.485.136c-.14.088-.26.208-.359.36-.095.152-.17.326-.222.524-.05.194-.074.397-.074.61 0 .213.024.416.074.61.05.19.123.36.222.507.099.145.222.26.37.348.149.084.324.126.525.126.194 0 .367-.037.519-.109.156-.076.287-.175.393-.296.11-.122.194-.257.251-.405.06-.148.091-.298.091-.45l.542.296c0 .266-.057.528-.171.787a2.423 2.423 0 0 1-1.18 1.209 1.98 1.98 0 0 1-.855.188c-.388 0-.732-.07-1.032-.211a2.253 2.253 0 0 1-.764-.593 2.686 2.686 0 0 1-.468-.89 3.648 3.648 0 0 1-.16-1.1c0-.403.065-.78.194-1.134.134-.354.322-.666.565-.935.247-.27.541-.481.884-.633a2.77 2.77 0 0 1 1.151-.234 2.55 2.55 0 0 1 2.041.94c.247.297.437.653.57 1.067.137.414.205.874.205 1.38v.57a6.1 6.1 0 0 1-.176 1.505 4.376 4.376 0 0 1-.52 1.26 3.554 3.554 0 0 1-.854.957 3.66 3.66 0 0 1-1.18.61c-.449.141-.95.211-1.505.211H2.11v-1.328Zm11.129-3.632v1.437c0 .623-.067 1.161-.2 1.614-.133.448-.325.817-.575 1.106a2.272 2.272 0 0 1-.884.632 3.046 3.046 0 0 1-1.14.205 3.35 3.35 0 0 1-.935-.125 2.352 2.352 0 0 1-.781-.405 2.57 2.57 0 0 1-.593-.69 3.537 3.537 0 0 1-.377-1.003 6.1 6.1 0 0 1-.13-1.334v-1.437c0-.623.066-1.157.199-1.602.137-.448.329-.815.576-1.1.25-.285.547-.494.89-.627a3.044 3.044 0 0 1 1.14-.205c.334 0 .643.043.928.13.29.085.55.216.782.394.231.179.429.409.592.69.164.278.29.61.377.998.087.384.13.825.13 1.322Zm-1.648 1.654v-1.876c0-.3-.017-.562-.051-.787a2.308 2.308 0 0 0-.143-.57 1.203 1.203 0 0 0-.239-.387.872.872 0 0 0-.325-.217 1.143 1.143 0 0 0-.405-.069c-.186 0-.351.037-.496.109a.922.922 0 0 0-.359.348 1.872 1.872 0 0 0-.228.627c-.05.258-.074.574-.074.946v1.876c0 .3.015.564.046.792.034.228.083.424.148.587.068.16.148.291.24.394a.872.872 0 0 0 .324.216c.126.046.262.069.41.069.183 0 .345-.036.485-.108a.953.953 0 0 0 .365-.354c.103-.163.179-.376.228-.639a5.27 5.27 0 0 0 .074-.957Zm2.742-3.039v-.439c0-.315.069-.602.206-.86.137-.26.338-.466.604-.622.266-.156.593-.234.98-.234.4 0 .732.078.998.234.27.156.471.363.605.621.136.259.205.546.205.861v.44c0 .307-.069.59-.205.849a1.518 1.518 0 0 1-.599.621c-.266.156-.595.234-.986.234-.396 0-.728-.078-.998-.234a1.556 1.556 0 0 1-.604-.621 1.787 1.787 0 0 1-.205-.85Zm1.09-.439v.44c0 .132.024.26.074.381a.712.712 0 0 0 .239.29c.11.073.243.11.399.11a.678.678 0 0 0 .399-.11.685.685 0 0 0 .228-.29c.05-.122.074-.249.074-.382v-.439a.93.93 0 0 0-.08-.387.653.653 0 0 0-.633-.405.666.666 0 0 0-.627.405.992.992 0 0 0-.074.387Zm2.878 5.108v-.439a1.8 1.8 0 0 1 .206-.855c.14-.258.344-.465.61-.621.27-.156.6-.234.992-.234.395 0 .726.078.992.234.266.155.467.363.604.621a1.8 1.8 0 0 1 .205.855v.44a1.8 1.8 0 0 1-.205.854 1.518 1.518 0 0 1-.599.622c-.266.156-.595.233-.986.233-.395 0-.728-.077-.998-.233a1.586 1.586 0 0 1-.615-.622 1.8 1.8 0 0 1-.206-.855Zm1.095-.439v.44c0 .136.03.265.091.387s.145.218.251.29a.68.68 0 0 0 .382.109c.182 0 .325-.036.428-.108a.544.544 0 0 0 .21-.291c.042-.122.063-.25.063-.388v-.439a.917.917 0 0 0-.08-.382.666.666 0 0 0-.632-.405.67.67 0 0 0-.4.114.68.68 0 0 0-.233.291.917.917 0 0 0-.08.382Zm1.117-5.08-4.053 6.488-.798-.422 4.053-6.487.798.422Z"
          fill="${i(90)}"
        />
        <path
          d="M68.487 58.486h31.135"
          stroke="${a}"
          stroke-width="1.946"
          stroke-linecap="round"
        />
        <path
          d="M6.541 85.239c0 .52-.121.96-.365 1.317a2.271 2.271 0 0 1-1.003.804c-.422.178-.9.268-1.437.268-.536 0-1.016-.09-1.442-.268a2.31 2.31 0 0 1-1.01-.804c-.246-.358-.37-.796-.37-1.317a2.086 2.086 0 0 1 .798-1.676c.255-.206.553-.361.895-.468.343-.11.715-.165 1.118-.165.54 0 1.022.095 1.448.285.426.19.76.458 1.003.804.244.346.365.752.365 1.22Zm-1.653-.109c0-.254-.05-.473-.148-.655a1.002 1.002 0 0 0-.405-.428 1.219 1.219 0 0 0-.61-.148c-.232 0-.435.05-.61.148a1.037 1.037 0 0 0-.41.428 1.403 1.403 0 0 0-.143.656c0 .25.047.467.142.65.1.182.236.322.41.421.18.095.387.143.622.143.236 0 .44-.048.61-.143a.973.973 0 0 0 .4-.422 1.39 1.39 0 0 0 .142-.65Zm1.476-3.716c0 .421-.112.796-.336 1.123a2.242 2.242 0 0 1-.935.758 3.204 3.204 0 0 1-1.357.273c-.513 0-.969-.09-1.368-.273-.399-.183-.71-.435-.935-.758a1.938 1.938 0 0 1-.336-1.124c0-.501.112-.923.336-1.265.228-.346.54-.608.935-.787.4-.178.851-.268 1.357-.268.513 0 .967.09 1.362.268.4.179.711.441.935.787.228.342.342.764.342 1.266Zm-1.641.074c0-.225-.04-.418-.12-.582a.895.895 0 0 0-.342-.388.985.985 0 0 0-.536-.136c-.205 0-.382.043-.53.13a.871.871 0 0 0-.337.383 1.398 1.398 0 0 0-.114.593c0 .224.038.421.114.593.08.167.194.298.342.393a.972.972 0 0 0 .536.142.897.897 0 0 0 .867-.536c.08-.17.12-.368.12-.592Zm8.517 1.145v1.437c0 .623-.067 1.161-.2 1.614-.133.448-.325.817-.575 1.106a2.271 2.271 0 0 1-.884.632 3.044 3.044 0 0 1-1.14.206c-.335 0-.646-.042-.935-.126a2.353 2.353 0 0 1-.781-.405 2.573 2.573 0 0 1-.593-.69 3.54 3.54 0 0 1-.377-1.003 6.101 6.101 0 0 1-.13-1.334v-1.436c0-.624.066-1.158.199-1.603.137-.448.329-.815.576-1.1.25-.285.547-.494.89-.627a3.046 3.046 0 0 1 1.14-.205c.334 0 .643.044.928.131.29.084.55.215.782.393.231.179.429.409.592.69.164.278.29.61.377.998.087.384.13.825.13 1.322Zm-1.648 1.654V82.41c0-.3-.017-.562-.051-.787a2.31 2.31 0 0 0-.143-.57 1.204 1.204 0 0 0-.239-.387.872.872 0 0 0-.325-.217 1.145 1.145 0 0 0-.405-.068c-.186 0-.351.036-.496.108a.922.922 0 0 0-.359.348 1.87 1.87 0 0 0-.228.627c-.05.258-.074.574-.074.946v1.876c0 .3.015.564.046.792.034.228.083.424.148.587.068.16.148.291.24.394a.872.872 0 0 0 .324.216c.126.046.262.069.41.069.183 0 .345-.036.485-.108a.952.952 0 0 0 .365-.354c.103-.163.179-.376.228-.638a5.27 5.27 0 0 0 .074-.958Zm2.742-3.039v-.439c0-.315.069-.602.206-.86.137-.26.338-.466.604-.622.266-.156.593-.234.98-.234.4 0 .732.078.998.234.27.156.471.363.605.621.136.259.205.546.205.861v.44c0 .307-.069.59-.205.849a1.518 1.518 0 0 1-.599.621c-.266.156-.595.234-.986.234-.396 0-.728-.078-.998-.234a1.556 1.556 0 0 1-.604-.621 1.788 1.788 0 0 1-.205-.85Zm1.09-.439v.44c0 .132.024.26.074.381a.713.713 0 0 0 .239.29c.11.073.243.11.399.11a.678.678 0 0 0 .399-.11.685.685 0 0 0 .228-.29c.05-.121.074-.249.074-.382v-.439a.93.93 0 0 0-.08-.388.653.653 0 0 0-.633-.405.666.666 0 0 0-.627.405.993.993 0 0 0-.074.388Zm2.878 5.108v-.439a1.8 1.8 0 0 1 .206-.855c.14-.258.344-.465.61-.621.27-.156.6-.234.992-.234.395 0 .726.078.992.234.266.156.467.363.604.621a1.8 1.8 0 0 1 .205.855v.44a1.8 1.8 0 0 1-.205.854 1.517 1.517 0 0 1-.599.622c-.266.156-.595.234-.986.234-.395 0-.728-.078-.998-.234a1.585 1.585 0 0 1-.615-.622 1.8 1.8 0 0 1-.206-.855Zm1.095-.439v.44c0 .136.03.265.091.387s.145.218.251.29c.11.073.238.109.382.109.182 0 .325-.036.428-.108a.544.544 0 0 0 .21-.291c.042-.122.063-.25.063-.388v-.439a.917.917 0 0 0-.08-.382.666.666 0 0 0-.632-.404.67.67 0 0 0-.4.114.68.68 0 0 0-.233.29.917.917 0 0 0-.08.382Zm1.117-5.08-4.053 6.488-.798-.421 4.053-6.488.798.422Z"
          fill="${i(80)}"
        />
        <path
          d="M68.487 83.513h31.135"
          stroke="${a}"
          stroke-width="1.946"
          stroke-linecap="round"
        />
        <path
          d="M6.587 104.24v.884l-3.21 7.417H1.644l3.21-7.018H.72v-1.283h5.867Zm6.653 3.42v1.437c0 .623-.067 1.161-.2 1.614-.133.448-.325.817-.575 1.105a2.265 2.265 0 0 1-.884.633 3.042 3.042 0 0 1-1.14.206c-.335 0-.646-.042-.935-.126a2.335 2.335 0 0 1-.781-.405 2.567 2.567 0 0 1-.593-.689 3.547 3.547 0 0 1-.377-1.004 6.1 6.1 0 0 1-.13-1.334v-1.437c0-.623.066-1.157.199-1.602.137-.448.329-.815.576-1.1.25-.285.547-.494.89-.627a3.042 3.042 0 0 1 1.14-.205c.334 0 .643.044.928.131.29.084.55.215.782.393.231.179.429.409.592.69.164.278.29.61.377.998.087.384.13.825.13 1.322Zm-1.648 1.654v-1.876c0-.3-.017-.562-.051-.787a2.313 2.313 0 0 0-.143-.57 1.198 1.198 0 0 0-.239-.387.875.875 0 0 0-.325-.217 1.136 1.136 0 0 0-.405-.068c-.186 0-.351.036-.496.108a.919.919 0 0 0-.359.348 1.866 1.866 0 0 0-.228.627c-.05.258-.074.574-.074.946v1.876c0 .3.015.564.046.792.034.228.083.424.148.587.068.16.148.291.24.394a.861.861 0 0 0 .324.216c.126.046.262.069.41.069.183 0 .345-.036.485-.108a.959.959 0 0 0 .365-.354 1.84 1.84 0 0 0 .228-.638c.05-.263.074-.582.074-.958Zm2.742-3.039v-.439c0-.315.069-.602.206-.861.137-.258.338-.465.604-.621.266-.156.593-.234.98-.234.4 0 .732.078.998.234.27.156.471.363.605.621.136.259.205.546.205.861v.439c0 .308-.069.591-.205.85a1.52 1.52 0 0 1-.599.621c-.266.156-.595.234-.986.234-.396 0-.728-.078-.998-.234a1.559 1.559 0 0 1-.604-.621 1.79 1.79 0 0 1-.205-.85Zm1.09-.439v.439c0 .133.024.26.074.382a.711.711 0 0 0 .239.291c.11.072.243.108.399.108a.68.68 0 0 0 .399-.108.684.684 0 0 0 .228-.291c.05-.122.074-.249.074-.382v-.439c0-.14-.026-.27-.08-.388a.653.653 0 0 0-.633-.404.666.666 0 0 0-.627.404.997.997 0 0 0-.074.388Zm2.878 5.108v-.439c0-.311.069-.596.206-.855a1.6 1.6 0 0 1 .61-.621c.27-.156.6-.234.992-.234.395 0 .726.078.992.234.266.156.467.363.604.621.137.259.205.544.205.855v.439c0 .312-.068.597-.205.855a1.517 1.517 0 0 1-.599.622c-.266.156-.595.234-.986.234-.395 0-.728-.078-.998-.234a1.585 1.585 0 0 1-.615-.622 1.796 1.796 0 0 1-.206-.855Zm1.095-.439v.439c0 .137.03.266.091.388s.145.218.251.291c.11.072.238.108.382.108.182 0 .325-.036.428-.108a.546.546 0 0 0 .21-.291c.042-.122.063-.251.063-.388v-.439a.917.917 0 0 0-.08-.382.666.666 0 0 0-.632-.404.67.67 0 0 0-.4.114.68.68 0 0 0-.233.29.917.917 0 0 0-.08.382Zm1.117-5.079-4.053 6.487-.798-.421 4.053-6.488.798.422Z"
          fill="${i(70)}"
        />
        <path
          d="M68.487 108.541h31.135"
          stroke="${a}"
          stroke-width="1.946"
          stroke-linecap="round"
        />
        <path
          d="M5.184 129.181h.24v1.312h-.097c-.433 0-.82.064-1.157.193-.339.13-.626.314-.861.553-.232.236-.41.521-.536.856a3.263 3.263 0 0 0-.183 1.123v1.379c0 .297.029.559.086.787.06.224.146.412.256.564.114.149.247.261.4.337.152.072.323.108.513.108.178 0 .34-.038.484-.114.148-.076.274-.182.376-.319a1.48 1.48 0 0 0 .24-.49 2.16 2.16 0 0 0 .085-.622c0-.224-.028-.431-.085-.621a1.412 1.412 0 0 0-.24-.491 1.1 1.1 0 0 0-.387-.324 1.132 1.132 0 0 0-.513-.114c-.259 0-.487.06-.684.182-.194.118-.346.27-.457.456-.11.186-.169.382-.176.587l-.496-.319c.011-.293.072-.57.182-.832.114-.263.27-.494.468-.696.201-.205.442-.365.724-.479a2.44 2.44 0 0 1 .952-.177c.387 0 .728.075 1.02.223.297.148.544.351.741.61.198.258.346.557.445.895.099.338.148.699.148 1.083 0 .403-.066.777-.2 1.123-.128.346-.317.648-.564.907-.243.258-.536.46-.878.604a2.942 2.942 0 0 1-1.151.217c-.441 0-.842-.08-1.203-.24a2.727 2.727 0 0 1-.924-.684 3.1 3.1 0 0 1-.598-1.043 4.092 4.092 0 0 1-.206-1.323v-.638c0-.669.097-1.281.291-1.836.198-.559.481-1.042.85-1.448a3.767 3.767 0 0 1 1.334-.952c.52-.225 1.108-.337 1.761-.337Zm8.056 3.506v1.437c0 .623-.067 1.161-.2 1.614-.133.448-.325.817-.575 1.106a2.262 2.262 0 0 1-.884.632 3.042 3.042 0 0 1-1.14.206c-.335 0-.646-.042-.935-.126a2.335 2.335 0 0 1-.781-.405 2.567 2.567 0 0 1-.593-.689 3.547 3.547 0 0 1-.377-1.004 6.094 6.094 0 0 1-.13-1.334v-1.437c0-.623.066-1.157.199-1.601.137-.449.329-.816.576-1.101.25-.285.547-.494.89-.627a3.042 3.042 0 0 1 1.14-.205c.334 0 .643.044.928.131.29.084.55.215.782.393.231.179.429.409.592.69.164.278.29.61.377.998.087.384.13.825.13 1.322Zm-1.648 1.654v-1.876c0-.3-.017-.562-.051-.787a2.313 2.313 0 0 0-.143-.57 1.198 1.198 0 0 0-.239-.387.875.875 0 0 0-.325-.217 1.136 1.136 0 0 0-.405-.068c-.186 0-.351.036-.496.108a.919.919 0 0 0-.359.348 1.874 1.874 0 0 0-.228.627c-.05.258-.074.574-.074.946v1.876c0 .3.015.564.046.792.034.228.083.424.148.587.068.16.148.291.24.394a.861.861 0 0 0 .324.216c.126.046.262.069.41.069.183 0 .345-.036.485-.108a.951.951 0 0 0 .365-.354 1.84 1.84 0 0 0 .228-.638c.05-.263.074-.582.074-.958Zm2.742-3.039v-.439c0-.315.069-.602.206-.861.137-.258.338-.465.604-.621.266-.156.593-.234.98-.234.4 0 .732.078.998.234.27.156.471.363.605.621.136.259.205.546.205.861v.439c0 .308-.069.591-.205.85a1.52 1.52 0 0 1-.599.621c-.266.156-.595.234-.986.234-.396 0-.728-.078-.998-.234a1.559 1.559 0 0 1-.604-.621 1.79 1.79 0 0 1-.205-.85Zm1.09-.439v.439c0 .133.024.26.074.382a.711.711 0 0 0 .239.291c.11.072.243.108.399.108a.68.68 0 0 0 .399-.108.684.684 0 0 0 .228-.291c.05-.122.074-.249.074-.382v-.439c0-.14-.026-.27-.08-.387a.653.653 0 0 0-.633-.405.663.663 0 0 0-.627.405.989.989 0 0 0-.074.387Zm2.878 5.108v-.439c0-.311.069-.596.206-.855a1.6 1.6 0 0 1 .61-.621c.27-.156.6-.234.992-.234.395 0 .726.078.992.234.266.156.467.363.604.621.137.259.205.544.205.855v.439c0 .312-.068.597-.205.855a1.517 1.517 0 0 1-.599.622c-.266.156-.595.234-.986.234-.395 0-.728-.078-.998-.234a1.585 1.585 0 0 1-.615-.622 1.796 1.796 0 0 1-.206-.855Zm1.095-.439v.439c0 .137.03.266.091.388s.145.218.251.291c.11.072.238.108.382.108.182 0 .325-.036.428-.108a.546.546 0 0 0 .21-.291c.042-.122.063-.251.063-.388v-.439a.917.917 0 0 0-.08-.382.666.666 0 0 0-.632-.404.67.67 0 0 0-.4.114.68.68 0 0 0-.233.29.917.917 0 0 0-.08.382Zm1.117-5.079-4.053 6.487-.798-.421 4.053-6.488.798.422Z"
          fill="${i(60)}"
        />
        <path
          d="M68.487 133.568h31.135"
          stroke="${a}"
          stroke-width="1.946"
          stroke-linecap="round"
        />
        <path
          d="m2.493 158.815-1.31-.314.472-4.207H6.32v1.328H3.007l-.206 1.842c.11-.065.278-.133.502-.206.224-.076.475-.114.753-.114.402 0 .76.063 1.071.189.312.125.576.307.793.547.22.239.387.532.501.878.114.346.171.737.171 1.174 0 .369-.057.72-.17 1.055a2.612 2.612 0 0 1-.52.889 2.411 2.411 0 0 1-.872.61c-.35.149-.764.223-1.242.223-.358 0-.704-.054-1.038-.16a2.84 2.84 0 0 1-.895-.473 2.441 2.441 0 0 1-.633-.758 2.302 2.302 0 0 1-.245-1.027h1.63c.023.236.084.439.183.61.103.168.237.297.405.388.167.091.363.137.587.137.209 0 .388-.04.536-.12a.974.974 0 0 0 .359-.33c.091-.145.158-.312.2-.502.045-.194.068-.403.068-.627a2.17 2.17 0 0 0-.08-.61 1.298 1.298 0 0 0-.245-.473 1.074 1.074 0 0 0-.422-.308 1.458 1.458 0 0 0-.587-.109c-.304 0-.54.048-.707.143-.164.095-.3.203-.41.325Zm10.747-1.1v1.436c0 .624-.067 1.161-.2 1.614-.133.448-.325.817-.575 1.106a2.262 2.262 0 0 1-.884.632 3.042 3.042 0 0 1-1.14.206c-.335 0-.646-.042-.935-.126a2.335 2.335 0 0 1-.781-.405 2.567 2.567 0 0 1-.593-.689 3.547 3.547 0 0 1-.377-1.004 6.094 6.094 0 0 1-.13-1.334v-1.436c0-.624.066-1.158.199-1.602.137-.449.329-.816.576-1.101.25-.285.547-.494.89-.627a3.042 3.042 0 0 1 1.14-.205c.334 0 .643.044.928.131.29.084.55.215.782.393.231.179.429.409.592.69.164.278.29.61.377.998.087.384.13.825.13 1.323Zm-1.648 1.653v-1.876c0-.3-.017-.562-.051-.787a2.313 2.313 0 0 0-.143-.57 1.209 1.209 0 0 0-.239-.387.875.875 0 0 0-.325-.217 1.136 1.136 0 0 0-.405-.068c-.186 0-.351.036-.496.108a.919.919 0 0 0-.359.348 1.874 1.874 0 0 0-.228.627c-.05.258-.074.574-.074.946v1.876c0 .3.015.564.046.792.034.228.083.424.148.587.068.16.148.291.24.394a.861.861 0 0 0 .324.216c.126.046.262.069.41.069.183 0 .345-.036.485-.108a.951.951 0 0 0 .365-.354 1.84 1.84 0 0 0 .228-.638c.05-.263.074-.582.074-.958Zm2.742-3.039v-.439c0-.315.069-.602.206-.861.137-.258.338-.465.604-.621.266-.156.593-.234.98-.234.4 0 .732.078.998.234.27.156.471.363.605.621.136.259.205.546.205.861v.439c0 .308-.069.591-.205.85a1.52 1.52 0 0 1-.599.621c-.266.156-.595.234-.986.234-.396 0-.728-.078-.998-.234a1.559 1.559 0 0 1-.604-.621 1.79 1.79 0 0 1-.205-.85Zm1.09-.439v.439c0 .133.024.261.074.382a.711.711 0 0 0 .239.291c.11.072.243.108.399.108a.68.68 0 0 0 .399-.108.684.684 0 0 0 .228-.291c.05-.121.074-.249.074-.382v-.439c0-.14-.026-.27-.08-.387a.653.653 0 0 0-.633-.405.663.663 0 0 0-.627.405.989.989 0 0 0-.074.387Zm2.878 5.108v-.439c0-.311.069-.596.206-.855a1.6 1.6 0 0 1 .61-.621c.27-.156.6-.234.992-.234.395 0 .726.078.992.234.266.156.467.363.604.621.137.259.205.544.205.855v.439c0 .312-.068.597-.205.855a1.517 1.517 0 0 1-.599.622c-.266.156-.595.234-.986.234-.395 0-.728-.078-.998-.234a1.585 1.585 0 0 1-.615-.622 1.796 1.796 0 0 1-.206-.855Zm1.095-.439v.439c0 .137.03.266.091.388s.145.219.251.291c.11.072.238.108.382.108.182 0 .325-.036.428-.108a.543.543 0 0 0 .21-.291c.042-.122.063-.251.063-.388v-.439a.92.92 0 0 0-.08-.382.666.666 0 0 0-.632-.404.67.67 0 0 0-.4.114.68.68 0 0 0-.233.29.92.92 0 0 0-.08.382Zm1.117-5.079-4.053 6.487-.798-.421 4.053-6.488.798.422Z"
          fill="${i(50)}"
        />
        <path
          d="M68.487 158.595h31.135"
          stroke="${a}"
          stroke-width="1.946"
          stroke-linecap="round"
        />
        <path
          d="M6.764 184.52v1.289H.784l-.08-.998 3.46-5.49h1.305l-1.413 2.366-1.722 2.833h4.43Zm-.941-5.199v8.301H4.18v-8.301h1.642Zm7.417 3.421v1.436c0 .623-.067 1.161-.2 1.614-.133.448-.325.817-.575 1.106a2.262 2.262 0 0 1-.884.632 3.042 3.042 0 0 1-1.14.206c-.335 0-.646-.042-.935-.126a2.335 2.335 0 0 1-.781-.405 2.567 2.567 0 0 1-.593-.689 3.547 3.547 0 0 1-.377-1.004 6.094 6.094 0 0 1-.13-1.334v-1.436c0-.624.066-1.158.199-1.602.137-.449.329-.816.576-1.101.25-.285.547-.494.89-.627a3.042 3.042 0 0 1 1.14-.205c.334 0 .643.044.928.131.29.084.55.215.782.393.231.179.429.409.592.69.164.278.29.61.377.998.087.384.13.825.13 1.323Zm-1.648 1.653v-1.876c0-.3-.017-.562-.051-.787a2.313 2.313 0 0 0-.143-.57 1.198 1.198 0 0 0-.239-.387.875.875 0 0 0-.325-.217 1.136 1.136 0 0 0-.405-.068c-.186 0-.351.036-.496.108a.919.919 0 0 0-.359.348 1.874 1.874 0 0 0-.228.627c-.05.258-.074.574-.074.946v1.876c0 .3.015.564.046.792.034.228.083.424.148.587.068.16.148.291.24.394a.861.861 0 0 0 .324.216c.126.046.262.069.41.069.183 0 .345-.036.485-.108a.951.951 0 0 0 .365-.354 1.84 1.84 0 0 0 .228-.638c.05-.263.074-.582.074-.958Zm2.742-3.039v-.439c0-.315.069-.602.206-.861.137-.258.338-.465.604-.621.266-.156.593-.234.98-.234.4 0 .732.078.998.234.27.156.471.363.605.621.136.259.205.546.205.861v.439c0 .308-.069.591-.205.85a1.52 1.52 0 0 1-.599.621c-.266.156-.595.234-.986.234-.396 0-.728-.078-.998-.234a1.559 1.559 0 0 1-.604-.621 1.79 1.79 0 0 1-.205-.85Zm1.09-.439v.439c0 .133.024.261.074.382a.711.711 0 0 0 .239.291c.11.072.243.108.399.108a.68.68 0 0 0 .399-.108.684.684 0 0 0 .228-.291c.05-.121.074-.249.074-.382v-.439c0-.14-.026-.27-.08-.387a.653.653 0 0 0-.633-.405.663.663 0 0 0-.627.405.989.989 0 0 0-.074.387Zm2.878 5.108v-.439c0-.311.069-.596.206-.855a1.6 1.6 0 0 1 .61-.621c.27-.156.6-.234.992-.234.395 0 .726.078.992.234.266.156.467.363.604.621.137.259.205.544.205.855v.439c0 .312-.068.597-.205.855a1.517 1.517 0 0 1-.599.622c-.266.156-.595.234-.986.234-.395 0-.728-.078-.998-.234a1.585 1.585 0 0 1-.615-.622 1.796 1.796 0 0 1-.206-.855Zm1.095-.439v.439c0 .137.03.266.091.388s.145.219.251.291c.11.072.238.108.382.108.182 0 .325-.036.428-.108a.543.543 0 0 0 .21-.291c.042-.122.063-.251.063-.388v-.439a.917.917 0 0 0-.08-.382.666.666 0 0 0-.632-.404.67.67 0 0 0-.4.114.68.68 0 0 0-.233.29.917.917 0 0 0-.08.382Zm1.117-5.079-4.053 6.487-.798-.421 4.053-6.488.798.422Z"
          fill="${i(40)}"
        />
        <path
          d="M68.487 183.622h31.135"
          stroke="${a}"
          stroke-width="1.946"
          stroke-linecap="round"
        />
        <path
          d="M2.63 207.786h.878c.281 0 .513-.048.696-.143a.942.942 0 0 0 .405-.41 1.35 1.35 0 0 0 .136-.622c0-.213-.041-.401-.125-.564a.851.851 0 0 0-.37-.388c-.168-.095-.379-.142-.633-.142-.202 0-.388.04-.56.119-.17.08-.307.192-.41.337a.88.88 0 0 0-.154.524H.846c0-.456.121-.853.365-1.191.247-.339.577-.603.992-.793.414-.19.87-.285 1.368-.285.562 0 1.055.091 1.477.274.421.179.75.443.986.792.235.35.353.783.353 1.3 0 .262-.06.517-.182.764a2.14 2.14 0 0 1-.525.661c-.224.194-.498.35-.82.468a3.258 3.258 0 0 1-1.09.171H2.63v-.872Zm0 1.248v-.849h1.14c.453 0 .85.051 1.192.154.342.102.629.25.86.444.233.19.408.417.525.679.118.258.177.545.177.861 0 .387-.074.733-.222 1.037-.148.3-.358.555-.627.764a2.859 2.859 0 0 1-.935.479 4.094 4.094 0 0 1-2.2.017 3.071 3.071 0 0 1-.913-.439 2.256 2.256 0 0 1-.65-.741c-.16-.3-.24-.656-.24-1.066h1.648c0 .213.053.403.16.57.106.167.252.298.439.393.19.095.4.143.633.143.262 0 .486-.048.672-.143.19-.098.335-.235.434-.41.102-.179.153-.386.153-.621 0-.305-.055-.548-.165-.73a.986.986 0 0 0-.473-.411 1.862 1.862 0 0 0-.73-.131H2.63Zm10.61-1.265v1.436c0 .624-.067 1.161-.2 1.614-.133.448-.325.817-.575 1.106a2.262 2.262 0 0 1-.884.632 3.042 3.042 0 0 1-1.14.206c-.335 0-.646-.042-.935-.126a2.335 2.335 0 0 1-.781-.405 2.567 2.567 0 0 1-.593-.689 3.547 3.547 0 0 1-.377-1.004 6.094 6.094 0 0 1-.13-1.334v-1.436c0-.624.066-1.158.199-1.602.137-.449.329-.816.576-1.101.25-.285.547-.494.89-.627a3.042 3.042 0 0 1 1.14-.205c.334 0 .643.044.928.131.29.084.55.215.782.393.231.179.429.409.592.69.164.278.29.61.377.998.087.384.13.825.13 1.323Zm-1.648 1.653v-1.876c0-.3-.017-.562-.051-.787a2.313 2.313 0 0 0-.143-.57 1.209 1.209 0 0 0-.239-.387.875.875 0 0 0-.325-.217 1.136 1.136 0 0 0-.405-.068c-.186 0-.351.036-.496.108a.919.919 0 0 0-.359.348 1.874 1.874 0 0 0-.228.627c-.05.258-.074.574-.074.946v1.876c0 .3.015.564.046.792.034.228.083.424.148.587.068.16.148.291.24.394a.876.876 0 0 0 .324.217c.126.045.262.068.41.068.183 0 .345-.036.485-.108a.951.951 0 0 0 .365-.354 1.84 1.84 0 0 0 .228-.638c.05-.263.074-.582.074-.958Zm2.742-3.039v-.439c0-.315.069-.602.206-.861.137-.258.338-.465.604-.621.266-.156.593-.234.98-.234.4 0 .732.078.998.234.27.156.471.363.605.621.136.259.205.546.205.861v.439c0 .308-.069.591-.205.85a1.52 1.52 0 0 1-.599.621c-.266.156-.595.234-.986.234-.396 0-.728-.078-.998-.234a1.559 1.559 0 0 1-.604-.621 1.79 1.79 0 0 1-.205-.85Zm1.09-.439v.439c0 .133.024.261.074.382a.711.711 0 0 0 .239.291c.11.072.243.108.399.108a.68.68 0 0 0 .399-.108.684.684 0 0 0 .228-.291c.05-.121.074-.249.074-.382v-.439c0-.14-.026-.27-.08-.387a.653.653 0 0 0-.633-.405.663.663 0 0 0-.627.405.989.989 0 0 0-.074.387Zm2.878 5.108v-.439c0-.311.069-.596.206-.855a1.6 1.6 0 0 1 .61-.621c.27-.156.6-.234.992-.234.395 0 .726.078.992.234.266.156.467.363.604.621.137.259.205.544.205.855v.439c0 .312-.068.597-.205.855a1.517 1.517 0 0 1-.599.622c-.266.156-.595.234-.986.234-.395 0-.728-.078-.998-.234a1.585 1.585 0 0 1-.615-.622 1.796 1.796 0 0 1-.206-.855Zm1.095-.439v.439c0 .137.03.266.091.388s.145.219.251.291c.11.072.238.108.382.108.182 0 .325-.036.428-.108a.543.543 0 0 0 .21-.291c.042-.122.063-.251.063-.388v-.439a.92.92 0 0 0-.08-.382.666.666 0 0 0-.632-.404.67.67 0 0 0-.4.114.68.68 0 0 0-.233.29.92.92 0 0 0-.08.382Zm1.117-5.079-4.053 6.488-.798-.422 4.053-6.488.798.422Z"
          fill="${i(30)}"
        />
        <path
          d="M68.487 208.649h31.135"
          stroke="${a}"
          stroke-width="1.946"
          stroke-linecap="round"
        />
        <path
          d="M6.627 236.393v1.283H.948v-1.095l2.686-2.879c.27-.3.482-.564.638-.792.156-.232.268-.439.337-.622.072-.186.108-.363.108-.53 0-.251-.042-.466-.126-.644a.933.933 0 0 0-.37-.422 1.105 1.105 0 0 0-.593-.148c-.25 0-.468.061-.65.182a1.163 1.163 0 0 0-.41.508 1.874 1.874 0 0 0-.137.735H.783c0-.494.118-.946.354-1.357.235-.414.568-.743.997-.986.43-.247.939-.371 1.528-.371.582 0 1.072.095 1.471.285.403.187.707.456.912.81.21.35.314.768.314 1.254 0 .274-.044.542-.131.804a3.628 3.628 0 0 1-.377.775c-.16.255-.353.513-.581.776-.228.262-.48.534-.758.815l-1.443 1.619h3.558Zm6.613-3.597v1.436c0 .624-.067 1.161-.2 1.614-.133.448-.325.817-.575 1.106a2.262 2.262 0 0 1-.884.632 3.042 3.042 0 0 1-1.14.206c-.335 0-.646-.042-.935-.126a2.335 2.335 0 0 1-.781-.405 2.567 2.567 0 0 1-.593-.689 3.547 3.547 0 0 1-.377-1.004 6.094 6.094 0 0 1-.13-1.334v-1.436c0-.624.066-1.158.199-1.602.137-.449.329-.816.576-1.101.25-.285.547-.494.89-.627a3.042 3.042 0 0 1 1.14-.205c.334 0 .643.044.928.131.29.084.55.215.782.393.231.179.429.409.592.69.164.278.29.61.377.998.087.384.13.825.13 1.323Zm-1.648 1.653v-1.876c0-.3-.017-.562-.051-.786a2.31 2.31 0 0 0-.143-.571 1.209 1.209 0 0 0-.239-.387.875.875 0 0 0-.325-.217 1.136 1.136 0 0 0-.405-.068c-.186 0-.351.036-.496.108a.919.919 0 0 0-.359.348 1.874 1.874 0 0 0-.228.627c-.05.258-.074.574-.074.946v1.876c0 .3.015.564.046.792.034.228.083.424.148.588.068.159.148.29.24.393a.876.876 0 0 0 .324.217c.126.045.262.068.41.068.183 0 .345-.036.485-.108a.951.951 0 0 0 .365-.354 1.84 1.84 0 0 0 .228-.638c.05-.263.074-.582.074-.958Zm2.742-3.039v-.439c0-.315.069-.602.206-.861.137-.258.338-.465.604-.621.266-.156.593-.234.98-.234.4 0 .732.078.998.234.27.156.471.363.605.621.136.259.205.546.205.861v.439c0 .308-.069.591-.205.85a1.52 1.52 0 0 1-.599.621c-.266.156-.595.234-.986.234-.396 0-.728-.078-.998-.234a1.559 1.559 0 0 1-.604-.621 1.79 1.79 0 0 1-.205-.85Zm1.09-.439v.439c0 .133.024.261.074.382a.711.711 0 0 0 .239.291c.11.072.243.108.399.108a.68.68 0 0 0 .399-.108.684.684 0 0 0 .228-.291c.05-.121.074-.249.074-.382v-.439c0-.14-.026-.27-.08-.387a.653.653 0 0 0-.633-.405.663.663 0 0 0-.627.405.989.989 0 0 0-.074.387Zm2.878 5.108v-.439c0-.311.069-.596.206-.855a1.6 1.6 0 0 1 .61-.621c.27-.156.6-.234.992-.234.395 0 .726.078.992.234.266.156.467.363.604.621.137.259.205.544.205.855v.439c0 .312-.068.597-.205.856a1.52 1.52 0 0 1-.599.621c-.266.156-.595.234-.986.234-.395 0-.728-.078-.998-.234a1.589 1.589 0 0 1-.615-.621 1.803 1.803 0 0 1-.206-.856Zm1.095-.439v.439c0 .137.03.266.091.388s.145.219.251.291c.11.072.238.108.382.108.182 0 .325-.036.428-.108a.543.543 0 0 0 .21-.291c.042-.122.063-.251.063-.388v-.439a.92.92 0 0 0-.08-.382.666.666 0 0 0-.632-.404.67.67 0 0 0-.4.114.68.68 0 0 0-.233.29.92.92 0 0 0-.08.382Zm1.117-5.079-4.053 6.488-.798-.422 4.053-6.488.798.422Z"
          fill="${i(20)}"
        />
        <path
          d="M68.487 233.676h31.135"
          stroke="${a}"
          stroke-width="1.946"
          stroke-linecap="round"
        />
        <path
          d="M4.95 254.385v8.318H3.31v-6.425l-1.973.627v-1.294l3.438-1.226h.177Zm8.29 3.438v1.436c0 .624-.067 1.161-.2 1.614-.133.448-.325.817-.575 1.106a2.262 2.262 0 0 1-.884.632 3.042 3.042 0 0 1-1.14.206c-.335 0-.646-.042-.935-.126a2.352 2.352 0 0 1-.781-.404 2.588 2.588 0 0 1-.593-.69 3.547 3.547 0 0 1-.377-1.004 6.094 6.094 0 0 1-.13-1.334v-1.436c0-.624.066-1.158.199-1.602.137-.449.329-.816.576-1.101.25-.285.547-.494.89-.627a3.042 3.042 0 0 1 1.14-.205c.334 0 .643.044.928.131.29.084.55.215.782.393.231.179.429.409.592.69.164.278.29.61.377.998.087.384.13.825.13 1.323Zm-1.648 1.653V257.6c0-.3-.017-.562-.051-.786a2.31 2.31 0 0 0-.143-.571 1.209 1.209 0 0 0-.239-.387.875.875 0 0 0-.325-.217 1.158 1.158 0 0 0-.405-.068c-.186 0-.351.036-.496.108a.919.919 0 0 0-.359.348 1.874 1.874 0 0 0-.228.627c-.05.258-.074.574-.074.946v1.876c0 .3.015.564.046.792.034.228.083.424.148.588.068.159.148.29.24.393a.876.876 0 0 0 .324.217c.126.045.262.068.41.068.183 0 .345-.036.485-.108a.951.951 0 0 0 .365-.354 1.84 1.84 0 0 0 .228-.638c.05-.263.074-.582.074-.958Zm2.742-3.039v-.439c0-.315.069-.602.206-.861.137-.258.338-.465.604-.621.266-.156.593-.234.98-.234.4 0 .732.078.998.234.27.156.471.363.605.621.136.259.205.546.205.861v.439c0 .308-.069.591-.205.85a1.52 1.52 0 0 1-.599.621c-.266.156-.595.234-.986.234-.396 0-.728-.078-.998-.234a1.559 1.559 0 0 1-.604-.621 1.79 1.79 0 0 1-.205-.85Zm1.09-.439v.439c0 .133.024.261.074.382a.711.711 0 0 0 .239.291c.11.072.243.108.399.108a.68.68 0 0 0 .399-.108.684.684 0 0 0 .228-.291c.05-.121.074-.249.074-.382v-.439c0-.14-.026-.27-.08-.387a.653.653 0 0 0-.633-.405.663.663 0 0 0-.627.405.989.989 0 0 0-.074.387Zm2.878 5.108v-.439c0-.311.069-.596.206-.855a1.6 1.6 0 0 1 .61-.621c.27-.156.6-.234.992-.234.395 0 .726.078.992.234.266.156.467.363.604.621.137.259.205.544.205.855v.439c0 .312-.068.597-.205.856a1.52 1.52 0 0 1-.599.621c-.266.156-.595.234-.986.234-.395 0-.728-.078-.998-.234a1.589 1.589 0 0 1-.615-.621 1.803 1.803 0 0 1-.206-.856Zm1.095-.439v.439c0 .137.03.266.091.388s.145.219.251.291c.11.072.238.108.382.108.182 0 .325-.036.428-.108a.543.543 0 0 0 .21-.291c.042-.122.063-.251.063-.388v-.439a.92.92 0 0 0-.08-.382.666.666 0 0 0-.632-.404.67.67 0 0 0-.4.114.68.68 0 0 0-.233.29.92.92 0 0 0-.08.382Zm1.117-5.079-4.053 6.488-.798-.422 4.053-6.488.798.422Z"
          fill="${i(10)}"
        />
        <path
          d="M68.487 258.703h31.135"
          stroke="${a}"
          stroke-width="1.946"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <linearGradient
          ${Bt(e)}
          id="thermometerGradient"
          x1="69.46"
          y1="5.973"
          x2="69.46"
          y2="356.243"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.6" stop-color="#fff" />
          <stop offset="0.6" stop-color="${t}" />
        </linearGradient>
        <filter
          id="filter0_dd_3_3385"
          x="7.189"
          y=".135"
          width="124.541"
          height="369.73"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.946" in="SourceAlpha" result="effect1_dropShadow_3_3385" />
          <feOffset dy="1.946" />
          <feGaussianBlur stdDeviation="1.946" />
          <feColorMatrix
            values="0 0 0 0 0.0705882 0 0 0 0 0.0980392 0 0 0 0 0.14902 0 0 0 0.06 0"
          />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3_3385" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.946" in="SourceAlpha" result="effect2_dropShadow_3_3385" />
          <feOffset dy="3.892" />
          <feGaussianBlur stdDeviation="3.892" />
          <feColorMatrix
            values="0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0 0.105882 0 0 0 0.1 0"
          />
          <feBlend in2="effect1_dropShadow_3_3385" result="effect2_dropShadow_3_3385" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_3_3385" result="shape" />
        </filter>
        <filter
          id="filter1_d_3_3385"
          x="-1.568"
          y="4.027"
          width="104.108"
          height="266.595"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy=".973" />
          <feGaussianBlur stdDeviation=".973" />
          <feColorMatrix
            values="0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0 0.105882 0 0 0 0.05 0"
          />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3_3385" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_3_3385" result="shape" />
        </filter>
        <clipPath id="clip0_3_3385">
          <path fill="#fff" transform="translate(.378 5)" d="M0 0h98.27v262.703H0z" />
        </clipPath>
      </defs>
    </svg>
  `;
}
//#endregion
//#region src/components/partials/thermometer.ts
function Ji({ thermometerGradientElement: e, progressBarColor: t, currentRaisedPercentage: n, raisedPercentage: r, showAmountRaised: i, showRaisedPercentage: a, showGoalAmount: o, goal: s, raised: c, size: l, textColor: u, borderColor: d, areDisplayOptionsDisabled: f }) {
	let p = zr(i ? "block" : "hidden", l === "sm" && "text-lg", l === "md" && "text-3xl", l === "lg" && "text-5xl");
	return F`
    <div class="flex flex-col gap-2">
      <div class="flex justify-center">
        ${qi(e, t, n, d)}
      </div>
      <div class="flex flex-col gap-2 text-center" style="${Ut({ color: u })}">
        <div id="raised" class="${p}">
          <span>${"$" + Gi.toLocale(c, !1)}</span>
        </div>
        <div id="goal" class="text-base">
          ${a ? Gi.toLocale(r) + "%" : ""}
          ${a && o ? " of " : ""}
          ${o ? "$" + Gi.toLocale(s) : ""}
          ${f || !o ? "" : "goal"}
        </div>
      </div>
    </div>
  `;
}
//#endregion
//#region src/components/goal-bar.ts
var Yi = 1e3 * 10, Xi = {
	goal: 1e4,
	raised: 7200,
	raisedPercentage: 72
}, $ = class extends ji {
	constructor() {
		super(), this.thermometerGradientElement = Lt(), this.currentRaisedPercentage = 0, this.isThermometerGradientUpdating = !1, this.areDisplayOptionsDisabled = !0, this.class = "", this.type = "progress-bar", this.goal = 0, this.raised = 0, this.raisedPercentage = 0, this.textColor = "#000", this.padding = 16, this.progressBarColor = "green", this.fillColor = "red", this.borderColor = "", this.borderWidth = 1, this.borderRadius = 0, this.animationDuration = 2e3, this.backgroundColor = "#FFF", this.size = "md", this.maxWidth = "100%", this.showGoalAmount = !0, this.showAmountRaised = !0, this.showRaisedPercentage = !0, this.componentType = an.GOAL_BAR;
	}
	willUpdate(e) {
		if (this.preview) {
			e.has("preview") && (this.goal = Xi.goal, this.raised = Xi.raised, this.raisedPercentage = Xi.raisedPercentage);
			return;
		}
		(e.has("campaign") || e.has("account")) && this.dataController && (this.dataController.destroy(), this.dataController = void 0, this.goal = 0, this.raised = 0, this.raisedPercentage = 0), !this.dataController && this.account && this.campaign && (this.dataController = new qr({
			host: this,
			queryFn: () => ti(this.account, this.campaign),
			cacheTime: Yi,
			retryCount: 1,
			onSuccess: (e) => {
				e.goal > 0 && (this.goal = e.goal, this.raised = e.raised, this.raisedPercentage = e.raised_percentage);
			},
			shouldStopInterval: (e) => e.goal <= 0
		}));
	}
	updated(e) {
		if (e.has("type") && (this.currentRaisedPercentage = 0), e.has("raised") || e.has("raisedPercentage") || e.has("type")) {
			let e = this.raisedPercentage > 100 ? 100 : this.raisedPercentage;
			e === 0 || this.animationDuration === 0 ? (this.updateThermometerGradient(e), this.isThermometerGradientUpdating = !1) : (this.isThermometerGradientUpdating = !0, Mi.animate(this.currentRaisedPercentage, e, (e) => {
				this.updateThermometerGradient(e);
			}, () => {
				this.isThermometerGradientUpdating = !1;
			}));
		}
		this.areDisplayOptionsDisabled = !this.showGoalAmount && !this.showAmountRaised && !this.showRaisedPercentage;
	}
	render() {
		return F`
      <div style=${Ut({ maxWidth: this.maxWidth })} class="${this.class}">
        ${this.type === "progress-bar" ? Ki(this) : Ji(this)}
      </div>
    `;
	}
	updateThermometerGradient(e) {
		if (this.currentRaisedPercentage = e, this.thermometerGradientElement.value) {
			let t = e === 100 ? 0 : -.007 * e + .785, n = this.thermometerGradientElement.value.querySelectorAll("stop");
			n[0].setAttribute("offset", t.toString()), n[1].setAttribute("offset", t.toString());
		}
	}
};
H([vt()], $.prototype, "currentRaisedPercentage", void 0), H([vt()], $.prototype, "isThermometerGradientUpdating", void 0), H([vt()], $.prototype, "areDisplayOptionsDisabled", void 0), H([V({ type: String })], $.prototype, "class", void 0), H([V({
	type: String,
	attribute: "type"
})], $.prototype, "type", void 0), H([V({
	type: Number,
	attribute: "goal"
})], $.prototype, "goal", void 0), H([V({
	type: Number,
	attribute: "raised"
})], $.prototype, "raised", void 0), H([V({
	type: Number,
	attribute: "raised-percentage"
})], $.prototype, "raisedPercentage", void 0), H([V({
	type: String,
	attribute: "text-color"
})], $.prototype, "textColor", void 0), H([V({
	type: Number,
	attribute: "padding"
})], $.prototype, "padding", void 0), H([V({
	type: String,
	attribute: "progress-bar-color"
})], $.prototype, "progressBarColor", void 0), H([V({
	type: String,
	attribute: "progress-color"
})], $.prototype, "fillColor", void 0), H([V({
	type: String,
	attribute: "border-color"
})], $.prototype, "borderColor", void 0), H([V({
	type: Number,
	attribute: "border-width"
})], $.prototype, "borderWidth", void 0), H([V({
	type: Number,
	attribute: "border-radius"
})], $.prototype, "borderRadius", void 0), H([V({
	type: Number,
	attribute: "animation-duration"
})], $.prototype, "animationDuration", void 0), H([V({
	type: String,
	attribute: "background-color"
})], $.prototype, "backgroundColor", void 0), H([V({
	type: String,
	attribute: "size"
})], $.prototype, "size", void 0), H([V({
	type: String,
	attribute: "max-width"
})], $.prototype, "maxWidth", void 0), H([V({
	type: Boolean,
	attribute: "show-goal-amount",
	converter: sn._boolean
})], $.prototype, "showGoalAmount", void 0), H([V({
	type: Boolean,
	attribute: "show-amount-raised",
	converter: sn._boolean
})], $.prototype, "showAmountRaised", void 0), H([V({
	type: Boolean,
	attribute: "show-raised-percentage",
	converter: sn._boolean
})], $.prototype, "showRaisedPercentage", void 0), $ = H([ht("givebutter-goal-bar")], $);
//#endregion
//#region ../../node_modules/.pnpm/lit-html@3.3.2/node_modules/lit-html/directives/unsafe-html.js
var Zi = class extends kt {
	constructor(e) {
		if (super(e), this.it = L, e.type !== Dt.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
	}
	render(e) {
		if (e === L || e == null) return this._t = void 0, this.it = e;
		if (e === I) return e;
		if (typeof e != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
		if (e === this.it) return this._t;
		this.it = e;
		let t = [e];
		return t.raw = t, this._t = {
			_$litType$: this.constructor.resultType,
			strings: t,
			values: []
		};
	}
};
Zi.directiveName = "unsafeHTML", Zi.resultType = 1;
var Qi = Ot(Zi), $i = (e) => e.hasAttribute("href") && (e.getAttribute("href")?.startsWith("#") ?? !1), ea = (e) => {
	let t = e.getAttribute("href");
	return t ? t.substring(1) : null;
}, ta = (e) => {
	window.parent?.location?.href ? window.parent.history.pushState(null, "", `#${e}`) : history.pushState(null, "", `#${e}`);
}, na = () => window.location.hash ? window.location.hash.substring(1) : "", ra = () => {
	if (window.parent && window.parent !== window) {
		let e = window.parent?.location?.hash;
		return e ? e.substring(1) : "";
	}
	return "";
}, ia = (e, t) => e.getElementById(t) || e.querySelector(`[id="${t}"]`) || e.querySelector(`[name="${t}"], a[name="${t}"]`), aa = (e) => e.tagName === "A" && !e.textContent && e.parentElement || e, oa = (e, t = 80) => {
	let n = e.getBoundingClientRect().top + window.scrollY - t;
	window.scrollTo({
		top: n,
		behavior: "smooth"
	});
}, sa = /<p\b[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/giu;
function ca(e) {
	return e.replace(sa, "");
}
var la = class extends Te {
	constructor(...e) {
		super(...e), this.html = "", this.whitespace = "default", this.SCROLL_OFFSET = 80, this.clickHandler = this.handleAnchorClick.bind(this), this.popstateHandler = this.checkAndHandleUrlHash.bind(this);
	}
	static {
		this.styles = s`
    :host {
      all: initial;
      display: block;
      font-family: Matter, sans-serif;
      word-break: break-word;
      overflow-wrap: break-word;
      font-size: var(--gb-html-font-size, 16px);
      line-height: var(--gb-html-line-height, 1.5);
      color: var(--gb-html-color, revert);
      -webkit-font-smoothing: antialiased;
    }

    a {
      color: var(--gb-html-link-color, #568fdf);
      text-decoration: var(--gb-html-link-text-decoration, revert);
      font-weight: var(--gb-html-link-font-weight, revert);
    }

    a:hover {
      text-decoration: var(--gb-html-link-text-decoration-hover, revert);
    }

    img,
    iframe,
    video {
      max-width: 100%;
      box-sizing: border-box;
      vertical-align: middle;
    }

    img,
    video {
      height: auto;
    }

    /* Horizontal YouTube embeds (if they don't already have a wrapper) */
    :not([style*='relative']) > iframe[src*='youtube.com']:not([data-video-vertical]),
    :not([style*='relative']) > iframe[src*='youtube-nocookie.com']:not([data-video-vertical]),
    :not([style*='relative']) > iframe[src*='youtu.be']:not([data-video-vertical]) {
      aspect-ratio: 16 / 9;
      height: auto !important;
      width: 100% !important;
    }

    /* Vertical video embeds (any source) */
    :not([style*='relative']) > iframe[data-video-vertical] {
      aspect-ratio: 9 / 16;
      height: auto !important;
      width: 100% !important;
    }

    ol li p,
    ul li p,
    table p {
      margin: 0;
    }

    table {
      border-collapse: collapse;
    }
  `;
	}
	connectedCallback() {
		super.connectedCallback(), window.addEventListener("popstate", this.popstateHandler), setTimeout(() => this.checkAndHandleUrlHash(), 200);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), window.removeEventListener("popstate", this.popstateHandler), this.shadowRoot && this.shadowRoot.removeEventListener("click", this.clickHandler, !0);
	}
	handleAnchorClick(e) {
		let t = e.target.closest("a");
		if (t && $i(t)) {
			e.preventDefault(), e.stopPropagation();
			let n = ea(t);
			n && (this.scrollToAnchor(n), ta(n));
		}
	}
	checkAndHandleUrlHash() {
		let e = na();
		if (!e) {
			let e = ra();
			if (e) return this.scrollToAnchor(e);
		}
		return e ? this.scrollToAnchor(e) : !1;
	}
	scrollToAnchor(e) {
		if (!this.shadowRoot) return !1;
		let t = ia(this.shadowRoot, e);
		return t ? (oa(aa(t), this.SCROLL_OFFSET), !0) : !1;
	}
	render() {
		return this.html ? F`${Qi(this.whitespace === "truncate" ? ca(this.html) : this.html)}` : "";
	}
};
H([V({
	type: String,
	attribute: "html"
})], la.prototype, "html", void 0), H([V({
	type: String,
	attribute: "whitespace"
})], la.prototype, "whitespace", void 0), la = H([ht("givebutter-html-renderer")], la);
//#endregion
//#region src/components/p2p-leaderboard.ts
var ua = 1e3 * 30, da = [
	{
		name: "Taylor Morgan",
		raised: 2450
	},
	{
		name: "Jordan Lee",
		raised: 1875
	},
	{
		name: "Riley Chen",
		raised: 1320
	},
	{
		name: "Casey Rivera",
		raised: 940
	},
	{
		name: "Avery Patel",
		raised: 610
	}
], fa = class extends ji {
	constructor(...e) {
		super(...e), this.backgroundColor = "#ffffff", this.textColor = "#000000", this.accentColor = "#3b82f6", this.displayCount = 5, this.leaderboardType = "members", this.showAmounts = !0, this.entries = [];
	}
	willUpdate(e) {
		super.willUpdate(e), (e.has("leaderboardType") || e.has("displayCount") || e.has("campaign")) && this.dataController && (this.dataController.destroy(), this.dataController = void 0), !this.dataController && this.account && this.campaign && !this.preview && (this.dataController = new qr({
			host: this,
			queryFn: () => ni(this.account, this.campaign, this.leaderboardType, this.displayCount),
			cacheTime: ua,
			retryCount: 1,
			onSuccess: (e) => {
				this.entries = e.data || [];
			}
		}));
	}
	formatCurrency(e) {
		return new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: "USD",
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		}).format(e);
	}
	render() {
		let e = (this.preview ? da : this.entries).slice(0, this.displayCount), t = Math.max(...e.map((e) => e.raised), 1);
		return F`
      <div
        class="w-full rounded-lg font-sans"
        style="background-color: ${this.backgroundColor}; color: ${this.textColor};"
      >
        <div class="mb-3 text-sm font-semibold tracking-wide uppercase opacity-60">
          Top ${this.leaderboardType === "teams" ? "Teams" : "Fundraisers"}
        </div>
        ${e.length === 0 ? F`<div class="py-4 text-center text-sm opacity-50">No entries yet</div>` : e.map((e, n) => F`
                  <div class="mb-2 flex items-center gap-3">
                    <span class="w-5 text-right text-sm font-bold opacity-40">${n + 1}</span>
                    <div class="flex-1">
                      <div class="mb-1 flex items-baseline justify-between">
                        <span class="text-sm font-medium">${e.name}</span>
                        ${this.showAmounts ? F`<span class="text-sm font-semibold"
                                >${this.formatCurrency(e.raised)}</span
                              >` : ""}
                      </div>
                      <div class="h-1.5 w-full overflow-hidden rounded-full bg-gray-200">
                        <div
                          class="h-full rounded-full"
                          style="width: ${e.raised / t * 100}%; background-color: ${this.accentColor};"
                        ></div>
                      </div>
                    </div>
                  </div>
                `)}
      </div>
    `;
	}
};
H([V({
	type: String,
	attribute: "background-color"
})], fa.prototype, "backgroundColor", void 0), H([V({
	type: String,
	attribute: "text-color"
})], fa.prototype, "textColor", void 0), H([V({
	type: String,
	attribute: "accent-color"
})], fa.prototype, "accentColor", void 0), H([V({
	type: Number,
	attribute: "display-count"
})], fa.prototype, "displayCount", void 0), H([V({
	type: String,
	attribute: "leaderboard-type"
})], fa.prototype, "leaderboardType", void 0), H([V({
	type: Boolean,
	attribute: "show-amounts",
	converter: sn._boolean
})], fa.prototype, "showAmounts", void 0), H([vt()], fa.prototype, "entries", void 0), fa = H([ht("givebutter-p2p-leaderboard")], fa);
//#endregion
export { Ci as DynamicElementType, q as GivebutterButton, St as GivebutterDialog, xt as GivebutterDialogMode, Di as GivebutterDynamicElement, bi as GivebutterGivingForm, $ as GivebutterGoalBar, la as GivebutterHTMLRenderer, Gr as GivebutterIframe, fa as GivebutterP2pLeaderboard, Q as GivebutterSignupForm, wi as GoalBarElementType, Ei as SignupFormLayout, Ti as SignupFormType, K as WidgetsSdk };

//# sourceMappingURL=index.js.map